webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

module.exports = {"breakpoints":{"mobile":0,"desktop":640},"spacing":{"base_padding":"2rem","masonry_cell_padding":"1.5rem"},"heights":{"header":"6rem","footer":"5rem","slider_caption":"10rem","hp_grid_item_height":54,"slider_thumb_height":"7rem","thumb_hl_height":"3px"},"colors":{"black":"#010101","grey":"#f2f2f2"},"widths":{"single_pad":"1.5rem","double_pad":"3rem","global_max_width":"100%","grid_width":"120rem","two_col_max_width":"57.2rem","home_width":"140rem","home_width_px":1400,"nav_width":"50rem","home_grid_ratio":0.387,"ex_pub_width":"180vw"},"fonts":{"h1_size":"1.75rem","big_headline":"2.8rem","footer_size":"1.4rem","caption_size":"1rem","tiny":"1rem","small":"1.2rem","caption_spacing":".05rem","mallory_book":"'mallory', arial","mallory_medium":"'mallory', arial","mallory_bold":"'mallory', arial","mallory":"'mallory', arial","exchange":"'exchange'"}}

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollWatcher = exports.removeHidden = exports.splitString = exports.returnOpacity = exports.truncateText = exports.upperCase = exports.arrayPosition = exports.dropFirstItem = exports.instagramFormat = exports.photoArray = exports.getKey = exports.bgImage = exports.returnCategories = exports.filterCategory = undefined;

var _filterCategory = __webpack_require__(325);

var _filterCategory2 = _interopRequireDefault(_filterCategory);

var _returnCategories = __webpack_require__(329);

var _returnCategories2 = _interopRequireDefault(_returnCategories);

var _bgImage = __webpack_require__(84);

var _bgImage2 = _interopRequireDefault(_bgImage);

var _getKey = __webpack_require__(161);

var _getKey2 = _interopRequireDefault(_getKey);

var _photoArray = __webpack_require__(328);

var _photoArray2 = _interopRequireDefault(_photoArray);

var _instagramFormat = __webpack_require__(327);

var _instagramFormat2 = _interopRequireDefault(_instagramFormat);

var _dropFirstItem = __webpack_require__(324);

var _dropFirstItem2 = _interopRequireDefault(_dropFirstItem);

var _arrayPostion = __webpack_require__(323);

var _arrayPostion2 = _interopRequireDefault(_arrayPostion);

var _upperCase = __webpack_require__(333);

var _upperCase2 = _interopRequireDefault(_upperCase);

var _truncateText = __webpack_require__(332);

var _truncateText2 = _interopRequireDefault(_truncateText);

var _returnOpacity = __webpack_require__(330);

var _returnOpacity2 = _interopRequireDefault(_returnOpacity);

var _filterScripts = __webpack_require__(326);

var _scrollWatcher = __webpack_require__(331);

var _scrollWatcher2 = _interopRequireDefault(_scrollWatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.filterCategory = _filterCategory2.default;
exports.returnCategories = _returnCategories2.default;
exports.bgImage = _bgImage2.default;
exports.getKey = _getKey2.default;
exports.photoArray = _photoArray2.default;
exports.instagramFormat = _instagramFormat2.default;
exports.dropFirstItem = _dropFirstItem2.default;
exports.arrayPosition = _arrayPostion2.default;
exports.upperCase = _upperCase2.default;
exports.truncateText = _truncateText2.default;
exports.returnOpacity = _returnOpacity2.default;
exports.splitString = _filterScripts.splitString;
exports.removeHidden = _filterScripts.removeHidden;
exports.scrollWatcher = _scrollWatcher2.default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageStack = exports.Hero = exports.AnimateOnMount = exports.Video = exports.HelmetWrap = exports.Press = exports.FooterLayout = exports.WysywgPage = exports.BwSignature = exports.BottomBorder = exports.DropdownContent = exports.Image = exports.Headline = exports.BgImage = exports.ErrorRedirect = exports.Error = exports.RelatedPosts = exports.SocialShare = exports.PhotoFilmProjectDetail = exports.FlexiblePortfolioLayout = exports.SingleLineCaption = exports.PageWrapper = exports.PageLoader = exports.Layout = undefined;

var _Layout = __webpack_require__(250);

var _Layout2 = _interopRequireDefault(_Layout);

var _PageLoader = __webpack_require__(251);

var _PageLoader2 = _interopRequireDefault(_PageLoader);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _FlexiblePortfolioLayout = __webpack_require__(50);

var _FlexiblePortfolioLayout2 = _interopRequireDefault(_FlexiblePortfolioLayout);

var _PhotoFilmProjectDetail = __webpack_require__(274);

var _PhotoFilmProjectDetail2 = _interopRequireDefault(_PhotoFilmProjectDetail);

var _SocialShare = __webpack_require__(81);

var _SocialShare2 = _interopRequireDefault(_SocialShare);

var _RelatedPosts = __webpack_require__(79);

var _RelatedPosts2 = _interopRequireDefault(_RelatedPosts);

var _Error = __webpack_require__(248);

var _Error2 = _interopRequireDefault(_Error);

var _ErrorRedirect = __webpack_require__(249);

var _ErrorRedirect2 = _interopRequireDefault(_ErrorRedirect);

var _BgImage = __webpack_require__(35);

var _BgImage2 = _interopRequireDefault(_BgImage);

var _Video = __webpack_require__(254);

var _Video2 = _interopRequireDefault(_Video);

var _Image = __webpack_require__(29);

var _Image2 = _interopRequireDefault(_Image);

var _Headline = __webpack_require__(149);

var _Headline2 = _interopRequireDefault(_Headline);

var _DropdownContent = __webpack_require__(253);

var _DropdownContent2 = _interopRequireDefault(_DropdownContent);

var _BottomBorder = __webpack_require__(247);

var _BottomBorder2 = _interopRequireDefault(_BottomBorder);

var _BwSignature = __webpack_require__(141);

var _BwSignature2 = _interopRequireDefault(_BwSignature);

var _WsywygPage = __webpack_require__(252);

var _WsywygPage2 = _interopRequireDefault(_WsywygPage);

var _FooterLayout = __webpack_require__(151);

var _FooterLayout2 = _interopRequireDefault(_FooterLayout);

var _Press = __webpack_require__(145);

var _Press2 = _interopRequireDefault(_Press);

var _AnimateOnMount = __webpack_require__(78);

var _AnimateOnMount2 = _interopRequireDefault(_AnimateOnMount);

var _HelmetWrap = __webpack_require__(82);

var _HelmetWrap2 = _interopRequireDefault(_HelmetWrap);

var _Hero = __webpack_require__(46);

var _Hero2 = _interopRequireDefault(_Hero);

var _ImageStack = __webpack_require__(144);

var _ImageStack2 = _interopRequireDefault(_ImageStack);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// COMPONENT LIST:
exports.Layout = _Layout2.default;
exports.PageLoader = _PageLoader2.default;
exports.PageWrapper = _PageWrapper2.default;
exports.SingleLineCaption = _SingleLineCaption2.default;
exports.FlexiblePortfolioLayout = _FlexiblePortfolioLayout2.default;
exports.PhotoFilmProjectDetail = _PhotoFilmProjectDetail2.default;
exports.SocialShare = _SocialShare2.default;
exports.RelatedPosts = _RelatedPosts2.default;
exports.Error = _Error2.default;
exports.ErrorRedirect = _ErrorRedirect2.default;
exports.BgImage = _BgImage2.default;
exports.Headline = _Headline2.default;
exports.Image = _Image2.default;
exports.DropdownContent = _DropdownContent2.default;
exports.BottomBorder = _BottomBorder2.default;
exports.BwSignature = _BwSignature2.default;
exports.WysywgPage = _WsywygPage2.default;
exports.FooterLayout = _FooterLayout2.default;
exports.Press = _Press2.default;
exports.HelmetWrap = _HelmetWrap2.default;
exports.Video = _Video2.default;
exports.AnimateOnMount = _AnimateOnMount2.default;
exports.Hero = _Hero2.default;
exports.ImageStack = _ImageStack2.default;

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCollapseMenu = exports.collapseMenu = exports.setRouterState = exports.setVideoPlaying = exports.scrollData = exports.setScrollDirection = exports.scrollDirection = exports.setDirectionDown = exports.setCatPage = exports.setCatNav = exports.setSlugState = exports.setMenuState = exports.setResizeState = exports.setScrollState = exports.categorySelectedTrigger = exports.staticContentFetchData = exports.homeIncrementTrigger = exports.setHeaderStyle = exports.setHeaderNavLocation = undefined;

var _header_nav_location = __webpack_require__(311);

var _home_counter = __webpack_require__(312);

var _home_counter2 = _interopRequireDefault(_home_counter);

var _static_content = __webpack_require__(313);

var _static_content2 = _interopRequireDefault(_static_content);

var _a_window_data = __webpack_require__(310);

var _a_category_nav = __webpack_require__(308);

var _a_media_controls = __webpack_require__(309);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.setHeaderNavLocation = _header_nav_location.setHeaderNavLocation;
exports.setHeaderStyle = _header_nav_location.setHeaderStyle;
exports.homeIncrementTrigger = _home_counter2.default;
exports.staticContentFetchData = _static_content2.default;
exports.categorySelectedTrigger = _a_category_nav.categorySelectedTrigger;
exports.setScrollState = _a_window_data.setScrollState;
exports.setResizeState = _a_window_data.setResizeState;
exports.setMenuState = _header_nav_location.setMenuState;
exports.setSlugState = _header_nav_location.setSlugState;
exports.setCatNav = _a_category_nav.setCatNav;
exports.setCatPage = _a_category_nav.setCatPage;
exports.setDirectionDown = _a_window_data.setDirectionDown;
exports.scrollDirection = _a_window_data.scrollDirection;
exports.setScrollDirection = _a_window_data.setScrollDirection;
exports.scrollData = _a_window_data.scrollData;
exports.setVideoPlaying = _a_media_controls.setVideoPlaying;
exports.setRouterState = _header_nav_location.setRouterState;
exports.collapseMenu = _header_nav_location.collapseMenu;
exports.forceCollapseMenu = _header_nav_location.forceCollapseMenu;

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleLineCaption = function SingleLineCaption(props) {
  var styleWhite = {
    color: '#FFFFFF'
  };
  var styleBlack = {
    color: '#010101'
  };
  return _react2.default.createElement(
    'div',
    { style: props.White ? styleWhite : styleBlack, className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + ((props.Stacked ? 'caption-wrapper column' : 'caption-wrapper row') || '')
    },
    props.Headline ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.Headline }, className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'primary'
    }) : null,
    props.Sep && props.Description ? _react2.default.createElement(
      'span',
      {
        className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'separator'
      },
      '/'
    ) : null,
    props.Description ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.Description }, className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'secondary'
    }) : null,
    props.Date ? _react2.default.createElement(
      'span',
      {
        className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]])
      },
      _react2.default.createElement(
        'span',
        {
          className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'sep'
        },
        ' '
      ),
      _react2.default.createElement(
        'span',
        {
          className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'secondary'
        },
        props.Description ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.Description }, className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]])
        }) : null,
        props.DateComma ? _react2.default.createElement(
          'span',
          {
            className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]])
          },
          ', '
        ) : null,
        props.Date ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.Date }, className: _style2.default.dynamic([['739848641', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]])
        }) : null
      )
    ) : null,
    _react2.default.createElement(_style2.default, {
      styleId: '739848641',
      css: ['.caption-wrapper.__jsx-style-dynamic-selector{width:100%;margin-bottom:0;}', '.caption-wrapper.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector{font-weight:bold;}', '.column.__jsx-style-dynamic-selector{-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}', '.column.__jsx-style-dynamic-selector>.secondary.__jsx-style-dynamic-selector{padding-top:.5rem;}', '.row.__jsx-style-dynamic-selector{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}', '.row.__jsx-style-dynamic-selector>.secondary.__jsx-style-dynamic-selector{padding-left:.5rem;}', '.row.__jsx-style-dynamic-selector>.separator.__jsx-style-dynamic-selector{padding-left:.5rem;}', '.column.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{display:block;}', '.primary.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector,.sep.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector,.secondary.__jsx-style-dynamic-selector a.__jsx-style-dynamic-selector{font-weight:bold;}', '.separator.__jsx-style-dynamic-selector,.primary.__jsx-style-dynamic-selector,.sep.__jsx-style-dynamic-selector,.secondary.__jsx-style-dynamic-selector{font-size:' + _theme.fonts.tiny + ';-webkit-letter-spacing:' + _theme.fonts.caption_spacing + ';-moz-letter-spacing:' + _theme.fonts.caption_spacing + ';-ms-letter-spacing:' + _theme.fonts.caption_spacing + ';letter-spacing:' + _theme.fonts.caption_spacing + ';font-family:' + _theme.fonts.mallory + ';text-transform:uppercase;margin:0;}', '.primary.__jsx-style-dynamic-selector,.sep.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';padding-right:.15rem;font-weight:bold;}', '.secondary.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';font-weight:normal;}'],
      dynamic: [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]
    })
  );
};

exports.default = SingleLineCaption;

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageWrapper = function (_Component) {
  _inherits(PageWrapper, _Component);

  function PageWrapper() {
    _classCallCheck(this, PageWrapper);

    return _possibleConstructorReturn(this, (PageWrapper.__proto__ || Object.getPrototypeOf(PageWrapper)).apply(this, arguments));
  }

  _createClass(PageWrapper, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.scroll_top('top');
      this.props.scroll_data({
        cat_menu_wrapper: null,
        portfolio_wrapper: null
      });
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.props.staticContent && _react2.default.createElement(
          'main',
          { className: 'page-wrap pop-in ' + this.props.pageId, id: 'top' },
          this.props.children
        )
      );
    }
  }]);

  return PageWrapper;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    staticContent: state.staticContent
  };
}, function (dispatch) {
  return {
    scroll_top: function scroll_top(direction) {
      return dispatch((0, _actions.scrollDirection)(direction));
    },
    scroll_data: function scroll_data(scroll_state) {
      return dispatch((0, _actions.scrollData)(scroll_state));
    }
  };
})(PageWrapper);

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image(props) {
    _classCallCheck(this, Image);

    var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

    _this.state = {
      imageStatus: false
    };
    _this.style1 = {
      opacity: 0
    };
    _this.style2 = {
      opacity: 1
    };
    return _this;
  }

  _createClass(Image, [{
    key: 'handleImageLoaded',
    value: function handleImageLoaded() {
      this.setState({ imageStatus: true });
    }
  }, {
    key: 'handleImageErrored',
    value: function handleImageErrored() {
      this.setState({ imageStatus: false });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-2152439149' + ' ' + 'image-wrapper'
        },
        _react2.default.createElement('img', {
          style: this.state.imageStatus ? this.style2 : this.style1,
          src: this.props.source,
          onLoad: this.handleImageLoaded.bind(this),
          onError: this.handleImageErrored.bind(this),
          className: 'jsx-2152439149'
        }),
        _react2.default.createElement(_style2.default, {
          styleId: '2152439149',
          css: ['.image-wrapper.jsx-2152439149{width:100%;height:auto;}', 'img.jsx-2152439149{width:100%;height:auto;margin-bottom:-4px;-webkit-transition:opacity 1000ms ease;transition:opacity 1000ms ease;}']
        })
      );
    }
  }]);

  return Image;
}(_react.Component);

exports.default = Image;
;

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BgImage = function (_Component) {
  _inherits(BgImage, _Component);

  function BgImage(props) {
    _classCallCheck(this, BgImage);

    var _this = _possibleConstructorReturn(this, (BgImage.__proto__ || Object.getPrototypeOf(BgImage)).call(this, props));

    _this.state = {
      imageStatus: false,
      imgStyle: null
    };
    _this.bgSize = null;
    if (_this.props.bgSize == 'contain') {
      _this.bgSize = 'contain ';
    } else {
      _this.bgSize = '';
    }
    _this.theClasses = 'bg-image ' + _this.bgSize + ' ';
    _this.updateImageBg = _this.updateImageBg.bind(_this);
    _this.style1 = {
      opacity: 0
    };
    return _this;
  }

  _createClass(BgImage, [{
    key: 'updateImageBg',
    value: function updateImageBg(p) {
      var img = p.source;
      var Bg = 'url(' + img + ')';
      this.setState({
        imgStyle: {
          backgroundImage: Bg,
          opacity: 1
        }
      });
    }
  }, {
    key: 'handleImageLoaded',
    value: function handleImageLoaded() {
      var t = this;
      this.setState({ imageStatus: true });
      if (this.props.isLoaded) {
        t.props.isLoaded();
      }
    }
  }, {
    key: 'handleImageErrored',
    value: function handleImageErrored() {
      this.setState({ imageStatus: false });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateImageBg(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateImageBg(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: this.state.imageStatus ? this.state.imgStyle : this.style1, className: 'jsx-3190779215' + ' ' + ((this.state.imageStatus ? this.theClasses + 'loaded' : this.theClasses + 'loading') || '')
        },
        _react2.default.createElement('img', {
          src: this.props.source,
          onLoad: this.handleImageLoaded.bind(this),
          onError: this.handleImageErrored.bind(this),
          className: 'jsx-3190779215'
        }),
        _react2.default.createElement(_style2.default, {
          styleId: '3190779215',
          css: ['.bg-image.jsx-3190779215{width:100%;height:100%;-webkit-transition:all 1500ms ease;transition:all 1500ms ease;background-size:cover;background-repeat:no-repeat;background-position:center;-webkit-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);transform:translate3d(0,0,0);display:block;-webkit-backface-visibility:hidden;backface-visibility:hidden;opacity:0;position:relative;}', '.bg-image.contain.jsx-3190779215{background-size:contain;}', 'img.jsx-3190779215{width:0;height:0;overflow:hidden;position:absolute;top:0;left:0;}']
        })
      );
    }
  }]);

  return BgImage;
}(_react.Component);

exports.default = BgImage;
;

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _CategoryNavDesk = __webpack_require__(255);

var _CategoryNavDesk2 = _interopRequireDefault(_CategoryNavDesk);

var _CategoryNavMobile = __webpack_require__(256);

var _CategoryNavMobile2 = _interopRequireDefault(_CategoryNavMobile);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CategoryNavWrapperRF = function CategoryNavWrapperRF(props) {
  return _react2.default.createElement(
    'div',
    { id: 'category-menu-wrapper' },
    props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(_CategoryNavDesk2.default, { Url: props.cat_page, Navigation: props.cat_nav }) : _react2.default.createElement(_CategoryNavMobile2.default, { Url: props.cat_page, Navigation: props.cat_nav })
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    cat_page: state.category_nav_page,
    cat_nav: state.category_nav,
    window_width: state.window_dimensions.window_width
  };
})(CategoryNavWrapperRF);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _HeroSwiper = __webpack_require__(269);

var _HeroSwiper2 = _interopRequireDefault(_HeroSwiper);

var _ScrollPrompt = __webpack_require__(147);

var _ScrollPrompt2 = _interopRequireDefault(_ScrollPrompt);

var _HeroSwiperSlide = __webpack_require__(152);

var _HeroSwiperSlide2 = _interopRequireDefault(_HeroSwiperSlide);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hero = function Hero(props) {
  var heroHeight = {
    height: props.height
  };
  return _react2.default.createElement(
    'section',
    { id: 'hero', style: heroHeight, className: 'jsx-3615848577'
    },
    props.video_header_state == 'video-playing' && _react2.default.createElement('div', {
      className: 'jsx-3615848577' + ' ' + 'block-out'
    }),
    props.sliderContent.length > 1 ? _react2.default.createElement(_HeroSwiper2.default, { slides: props.sliderContent, height: props.height }) : _react2.default.createElement(_HeroSwiperSlide2.default, { slideData: props.sliderContent[0], height: props.height }),
    props.window_width >= _theme.breakpoints.desktop && _react2.default.createElement(_ScrollPrompt2.default, null),
    _react2.default.createElement(_style2.default, {
      styleId: '3615848577',
      css: ['#hero.jsx-3615848577{height:100vh;width:100%;position:relative;overflow:hidden;}']
    })
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width,
    video_header_state: state.video_state.header_style
  };
})(Hero);

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactLazyload = __webpack_require__(126);

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _Image = __webpack_require__(29);

var _Image2 = _interopRequireDefault(_Image);

var _ProjectDetailCaption = __webpack_require__(146);

var _ProjectDetailCaption2 = _interopRequireDefault(_ProjectDetailCaption);

var _Popover = __webpack_require__(155);

var _Popover2 = _interopRequireDefault(_Popover);

var _GridItemMobile = __webpack_require__(272);

var _GridItemMobile2 = _interopRequireDefault(_GridItemMobile);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlexiblePortfolioLayout = function (_Component) {
  _inherits(FlexiblePortfolioLayout, _Component);

  function FlexiblePortfolioLayout(props) {
    _classCallCheck(this, FlexiblePortfolioLayout);

    var _this = _possibleConstructorReturn(this, (FlexiblePortfolioLayout.__proto__ || Object.getPrototypeOf(FlexiblePortfolioLayout)).call(this, props));

    _this.closePopup = _this._closePopup.bind(_this);
    _this.state = {
      popover: false,
      currentImage: null,
      thumbClicked: null,
      clicks: 0
    };
    _this.mobileClickHandler = _this.mobileClickHandler.bind(_this);
    return _this;
  }

  _createClass(FlexiblePortfolioLayout, [{
    key: 'mobileClickHandler',
    value: function mobileClickHandler(id) {
      this.setState({
        popover: true,
        currentImage: id
      });
    }
  }, {
    key: '_clickPopupDesktop',
    value: function _clickPopupDesktop(id) {
      this.setState({
        currentImage: id,
        popover: true
      });
    }
  }, {
    key: '_clickPopupMobile',
    value: function _clickPopupMobile(id, buttonId) {
      if (this.state.clicks == 0 || this.state.clicks == 1 && buttonId != this.state.thumbClicked) {
        this.setState({
          thumbClicked: buttonId,
          clicks: 1
        });
      } else if (this.state.clicks == 1 && buttonId == this.state.thumbClicked) {
        this.setState({
          popover: true,
          currentImage: id,
          clicks: 0,
          thumbClicked: null
        });
      }
    }
  }, {
    key: '_closePopup',
    value: function _closePopup() {
      this.setState({
        popover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var GridItemDesk = function GridItemDesk(props) {
        return _react2.default.createElement(
          'div',
          { className: 'flexible-image-wrapper', onClick: function onClick() {
              return _this2._clickPopupDesktop(props.ImgData.image.urls.id);
            } },
          _react2.default.createElement(
            _reactLazyload2.default,
            { height: '100%' },
            _react2.default.createElement(_ProjectDetailCaption2.default, {
              ProjectName: props.ImgData.image.metadata.title,
              ImageDescription: props.ImgData.image.metadata.caption,
              ExpandIcon: true
            }),
            _react2.default.createElement(
              'div',
              { className: 'image-inner' },
              _react2.default.createElement(
                'div',
                { className: 'gradient-wrapper' },
                _react2.default.createElement('div', { className: 'bg-gradient', style: { opacity: (0, _scripts.returnOpacity)(props.ImgData.image.gradient_opacity) } })
              ),
              props.ImgSize == 'full_row' ? _react2.default.createElement(_Image2.default, { source: props.ImgData.image.urls.large }) : props.ImgSize == 'full_bleed' ? _react2.default.createElement(_Image2.default, { source: props.ImgData.image.urls.large }) : _react2.default.createElement(_Image2.default, { source: props.ImgData.image.urls.small })
            )
          )
        );
      };
      var FlexLayoutDesk = (0, _scripts.photoArray)(this.props.LayoutItems).flex_array.map(function (item, i) {
        return _react2.default.createElement(
          'li',
          { className: 'flexible-row', key: 'flex-layout-item-desk' + i },
          item.two_column ? _react2.default.createElement(
            'div',
            { className: 'two_column flex-row-wrapper' },
            _react2.default.createElement(GridItemDesk, { ImgData: item.two_column[0], ImgSize: 'two_column' }),
            _react2.default.createElement(GridItemDesk, { ImgData: item.two_column[1], ImgSize: 'two_column' })
          ) : item.image ? _react2.default.createElement(
            'div',
            { className: item.image.position + ' flex-row-wrapper' },
            _react2.default.createElement(GridItemDesk, { ImgData: item, ImgSize: item.image.position })
          ) : null
        );
      });
      var FlexLayoutMobile = (0, _scripts.photoArray)(this.props.LayoutItems).carousel_array.map(function (item, i) {
        return _react2.default.createElement(
          'li',
          { className: 'flexible-row', key: 'flex-layout-item-mobile' + i },
          _react2.default.createElement(
            'div',
            { className: item.position + ' flex-row-wrapper' },
            _react2.default.createElement(_GridItemMobile2.default, { clickFunction: _this2.mobileClickHandler, ImgData: item, Index: i })
          )
        );
      });
      return _react2.default.createElement(
        'section',
        { id: 'flexible-layout' },
        this.state.popover && _react2.default.createElement(_Popover2.default, { Images: (0, _scripts.photoArray)(this.props.LayoutItems).carousel_array, CurrentImage: this.state.currentImage, ClickFunction: function ClickFunction() {
            return _this2.closePopup();
          } }),
        this.props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(
          'ul',
          { id: 'layout' },
          FlexLayoutDesk
        ) : _react2.default.createElement(
          'ul',
          { id: 'layout' },
          FlexLayoutMobile
        )
      );
    }
  }]);

  return FlexiblePortfolioLayout;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(FlexiblePortfolioLayout);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactPlayer = __webpack_require__(72);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _ErrorBoundary = __webpack_require__(142);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _actions = __webpack_require__(10);

var _scripts = __webpack_require__(5);

var _PlayButton = __webpack_require__(277);

var _PlayButton2 = _interopRequireDefault(_PlayButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VideoPlayer = function (_Component) {
  _inherits(VideoPlayer, _Component);

  function VideoPlayer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, VideoPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VideoPlayer.__proto__ || Object.getPrototypeOf(VideoPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      url: null,
      playing: false,
      volume: 0.8,
      muted: false,
      played: 0,
      loaded: 0,
      duration: 0,
      playbackRate: 1.0,
      loop: false,
      started: false,
      buffering: false,
      opacity: {
        opacity: 0
      },
      hasEnded: false
      // LIFECYCLE
    }, _this.clearVideo = function () {
      _this.props.video_playing({
        url: null,
        header_style: ''
      });
    }, _this.playPause = function () {
      _this.setState({
        playing: !_this.state.playing
      });
    }, _this.stop = function () {
      _this.setState({
        url: null,
        playing: false
      });
      _this.clearVideo();
    }, _this.onPlay = function () {
      _this.props.video_playing({
        url: _this.props.videoId,
        header_style: 'video-playing'
      });
      setTimeout(function () {
        _this.setState({
          playing: true,
          buffering: false,
          started: true,
          hasEnded: false
        });
      }, 1);
    }, _this.onPause = function () {
      if (!_this.state.hasEnded) {
        _this.setState({
          playing: false
        });
        _this.props.video_playing({
          url: _this.props.videoId,
          header_style: 'video-paused'
        });
      }
    }, _this.onEnded = function () {
      _this.setState({
        url: null,
        playing: false,
        started: false,
        hasEnded: true
      });
      _this.clearVideo();
    }, _this.onStart = function () {
      _this.setState({
        started: true,
        playing: true
      });
    }, _this.onBuffer = function () {
      _this.setState({
        buffering: true
      });
    }, _this.ref = function (player) {
      _this.player = player;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(VideoPlayer, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({
        playing: false,
        started: true
      });
      this.clearVideo();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.url != this.props.current_video) {
        this.clearVideo();
        this.setState({
          url: null,
          playing: false,
          started: false,
          opacityFull: {
            opacity: 1
          },
          opacityZero: {
            opacity: 0
          }
        });
        this.player.seekTo(0);
      }
    }
    // VIDEO CONTROL HANDLERS

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-3314548654' + ' ' + 'video__container'
        },
        _react2.default.createElement(
          _ErrorBoundary2.default,
          null,
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-3314548654' + ' ' + 'video__wrapper'
            },
            _react2.default.createElement(
              'div',
              { style: (0, _scripts.bgImage)(this.props.videoPoster), className: 'jsx-3314548654' + ' ' + ((this.state.started ? 'video__thumbnail playing' : 'video__thumbnail') || '')
              },
              this.props.videoId && _react2.default.createElement(_PlayButton2.default, { PlayFunction: function PlayFunction() {
                  return _this2.onPlay();
                }, CTA: this.props.cta })
            ),
            _react2.default.createElement(_reactPlayer2.default, {
              url: this.props.videoUrl,
              className: 'video',
              width: '100%',
              height: '100%',
              ref: this.ref,
              volume: this.state.volume,
              playing: this.state.playing,
              onStart: this.onStart,
              onPlay: this.onPlay,
              onBuffer: this.onBuffer,
              onPause: this.onPause,
              onEnded: this.onEnded,
              config: {
                vimeo: {
                  playerVars: {
                    showinfo: 0,
                    controls: 0
                  }
                }
              }
            })
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: '3314548654',
          css: ['.video__container.jsx-3314548654{display:block;width:100%;height:0;padding-bottom:56.25%;overflow-y:visible;position:relative;}', '.video__wrapper.jsx-3314548654{height:100%;width:100%;position:absolute;top:0;left:0;background-color:black;}', '.video.jsx-3314548654{position:absolute!important;top:0;left:0;right:0;margin:auto;width:100%;height:100%;z-index:100;}', '.video__thumbnail.jsx-3314548654{position:absolute;top:0;left:0;width:100%;height:100%;background-color:white;will-change:opacity;-webkit-transition:opacity 500ms ease;transition:opacity 500ms ease;opacity:1;background-size:cover;background-position:center;background-repeat:no-repeat;}', '.playing.jsx-3314548654{opacity:0!important;pointer-events:none;}']
        })
      );
    }
  }]);

  return VideoPlayer;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width,
    current_video: state.video_state.url
  };
}, function (dispatch) {
  return {
    video_playing: function video_playing(url) {
      return dispatch((0, _actions.setVideoPlaying)(url));
    }
  };
})(VideoPlayer);

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimateOnMount = function (_Component) {
    _inherits(AnimateOnMount, _Component);

    function AnimateOnMount(props) {
        _classCallCheck(this, AnimateOnMount);

        var _this = _possibleConstructorReturn(this, (AnimateOnMount.__proto__ || Object.getPrototypeOf(AnimateOnMount)).call(this, props));

        _this.state = {
            animate: false
        };
        // https://stanko.github.io/react-rerender-in-component-did-mount/    
        _this.startAnimation = _this.startAnimation.bind(_this);

        return _this;
    }

    _createClass(AnimateOnMount, [{
        key: 'startAnimation',
        value: function startAnimation(callback) {
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    callback();
                });
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var t = this;
            this.startAnimation(function () {
                t.setState({ animate: true });
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.setState({ animate: false });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: this.state.animate ? 'animate-wrapper animate' : 'animate-wrapper' },
                this.props.children
            );
        }
    }]);

    return AnimateOnMount;
}(_react.Component);

exports.default = AnimateOnMount;
;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _BgImage = __webpack_require__(35);

var _BgImage2 = _interopRequireDefault(_BgImage);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scrollUpRelated() {
  window.scrollTo(0, 0);
}
var RelatedPosts = function RelatedPosts(props) {
  var Posts = props.Posts.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { onClick: function onClick() {
          scrollUpRelated();
        }, key: item.new_key + '-' + i, className: 'jsx-3974682660' + ' ' + 'post-item'
      },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/' + item.link.postType + '/' + item.link.slug },
        _react2.default.createElement(
          'div',
          { style: (0, _scripts.bgImage)(item.thumbnail.small), className: 'jsx-3974682660' + ' ' + 'post-item-wrapper'
          },
          _react2.default.createElement(_BgImage2.default, { source: item.thumbnail.thumb })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-3974682660' + ' ' + 'caption'
          },
          _react2.default.createElement(_SingleLineCaption2.default, { Headline: item.title, Description: item.description, Sep: true, Stacked: false })
        )
      ),
      _react2.default.createElement(_style2.default, {
        styleId: '3974682660',
        css: ['.post-item.jsx-3974682660{padding:0 1.5rem;margin-bottom:3rem;width:100%;}', '@media (min-width:640px){.post-item.jsx-3974682660{margin-bottom:0;width:calc(100% / 3);}}', '.post-item-wrapper.jsx-3974682660{width:100%;height:0;overflow:hidden;padding-bottom:100%;background-size:cover;background-repeat:no-repeat;background-postion:center;position:relative;}', '.caption.jsx-3974682660{margin-top:1.5rem;}']
      })
    );
  });
  return _react2.default.createElement(
    'section',
    { id: 'related-posts', className: _style2.default.dynamic([['3380795842', [_theme.colors.grey, _theme.widths.global_max_width, _theme.fonts.mallory, _theme.colors.black]]])
    },
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['3380795842', [_theme.colors.grey, _theme.widths.global_max_width, _theme.fonts.mallory, _theme.colors.black]]]) + ' ' + 'title'
      },
      _react2.default.createElement(
        'h5',
        {
          className: _style2.default.dynamic([['3380795842', [_theme.colors.grey, _theme.widths.global_max_width, _theme.fonts.mallory, _theme.colors.black]]]) + ' ' + 'title-text'
        },
        'RELATED'
      )
    ),
    _react2.default.createElement(
      'ul',
      { id: 'posts', className: _style2.default.dynamic([['3380795842', [_theme.colors.grey, _theme.widths.global_max_width, _theme.fonts.mallory, _theme.colors.black]]])
      },
      Posts
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '3380795842',
      css: ['#related-posts.__jsx-style-dynamic-selector{width:100vw;padding:0 1.5rem 2rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;background-color:' + _theme.colors.grey + ';}', '#posts.__jsx-style-dynamic-selector{list-style:none;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}', '@media (min-width:640px){#related-posts.__jsx-style-dynamic-selector{padding-bottom:6.5rem;}#posts.__jsx-style-dynamic-selector{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}}', '.title.__jsx-style-dynamic-selector{padding:4rem 0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}', '.title-text.__jsx-style-dynamic-selector{font-size:1.8rem;font-family:' + _theme.fonts.mallory + ';text-transform:uppercase;font-weight:bold;color:' + _theme.colors.black + ';}'],
      dynamic: [_theme.colors.grey, _theme.widths.global_max_width, _theme.fonts.mallory, _theme.colors.black]
    })
  );
};

exports.default = RelatedPosts;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Image = __webpack_require__(29);

var _Image2 = _interopRequireDefault(_Image);

var _reactRedux = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialIcons = function SocialIcons(props) {
  var SocialLinks = props.socialLinks.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { key: item.channel + i, className: 'jsx-1198293410' + ' ' + 'social-item'
      },
      _react2.default.createElement(
        'a',
        { target: '_blank', href: item.link, className: 'jsx-1198293410' + ' ' + 'social-link'
        },
        _react2.default.createElement(_Image2.default, { source: item.icon })
      ),
      _react2.default.createElement(_style2.default, {
        styleId: '1198293410',
        css: ['.social-item.jsx-1198293410{width:1.8rem;height:1.8rem;margin:0 1rem;}']
      })
    );
  });
  return _react2.default.createElement(
    'ul',
    {
      className: 'jsx-3939158945' + ' ' + 'social-links'
    },
    SocialLinks,
    _react2.default.createElement(_style2.default, {
      styleId: '3939158945',
      css: ['.social-links.jsx-3939158945{list-style:none;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;width:100%;}']
    })
  );
};
// REDUX


var mapStateToProps = function mapStateToProps(state) {
  return {
    socialLinks: state.staticContent.homeData.data.social_links
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(SocialIcons);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _theme = __webpack_require__(1);

var _AnimateOnMount = __webpack_require__(78);

var _AnimateOnMount2 = _interopRequireDefault(_AnimateOnMount);

__webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SocialShare = function (_Component) {
  _inherits(SocialShare, _Component);

  function SocialShare(props) {
    _classCallCheck(this, SocialShare);

    var _this = _possibleConstructorReturn(this, (SocialShare.__proto__ || Object.getPrototypeOf(SocialShare)).call(this, props));

    _this.image = null;
    _this.description = '';
    var align = 'center';
    _this.state = {
      showLinks: false,
      timeoutId: null
    };
    if (props.align) {
      align = props.align;
    };
    _this.ulStyle = {
      textAlign: align
    };
    _this.toggleLinks = _this.toggleLinks.bind(_this);
    _this.toggleClick = _this.toggleClick.bind(_this);

    return _this;
  }

  _createClass(SocialShare, [{
    key: 'toggleLinks',
    value: function toggleLinks() {
      clearTimeout(this.state.intervalId);
      this.setState({
        showLinks: !this.state.showLinks
      });
    }
  }, {
    key: 'toggleClick',
    value: function toggleClick() {
      if (this.state.showLinks == false) {
        var timeoutId = setTimeout(this.toggleLinks, 10000);
        this.setState({ timeoutId: timeoutId });
      }
      this.toggleLinks();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.state.intervalId);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var t = this;
      if (this.props.Meta.image) {
        t.image = t.props.Meta.image;
      };
      if (this.props.Meta.title) {
        t.description += t.props.Meta.title + ' | ';
      }
      if (this.props.Meta.description) {
        t.description += t.props.Meta.description;
      }
      this.description = encodeURIComponent(this.description);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'social-share' },
        _react2.default.createElement(
          'div',
          { style: this.ulStyle, id: 'share-links' },
          this.state.showLinks ? _react2.default.createElement(
            _AnimateOnMount2.default,
            null,
            _react2.default.createElement(
              'ul',
              { className: 'share-links-wrap' },
              _react2.default.createElement(
                'li',
                { onClick: this.toggleClick, className: 'share-li' },
                _react2.default.createElement(
                  'a',
                  { className: 'external-link', target: '_blank', href: 'https://www.facebook.com/sharer.php?u=' + window.location.href },
                  'Facebook'
                )
              ),
              _react2.default.createElement(
                'li',
                { onClick: this.toggleClick, className: 'share-li mid' },
                _react2.default.createElement(
                  'a',
                  { className: 'external-link', target: '_blank', href: 'http://twitter.com/share?text=' + this.description + '&url=' + window.location.href },
                  'Twitter'
                )
              ),
              _react2.default.createElement(
                'li',
                { onClick: this.toggleClick, className: 'share-li' },
                _react2.default.createElement(
                  'a',
                  { className: 'external-link', target: '_blank', href: 'mailto:?subject=' + this.description + '&body=' + window.location.href },
                  'Email'
                )
              )
            )
          ) : _react2.default.createElement(
            'div',
            { onClick: this.toggleClick, className: 'share-title share-label external-link' },
            'Share'
          )
        )
      );
    }
  }]);

  return SocialShare;
}(_react.Component);

exports.default = SocialShare;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(566);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelmetWrap = function HelmetWrap(props) {
    var pm = props.pageMeta;
    return _react2.default.createElement(
        _reactHelmet.Helmet,
        null,
        pm.title ? _react2.default.createElement(
            'title',
            null,
            pm.title
        ) : null,
        pm.title ? _react2.default.createElement('meta', { property: 'og:title', content: pm.title }) : null,
        pm.title ? _react2.default.createElement('meta', { name: 'twitter:title', content: pm.title }) : null,
        pm.description ? _react2.default.createElement('meta', { name: 'description', content: pm.description }) : null,
        pm.description ? _react2.default.createElement('meta', { property: 'og:description', content: pm.description }) : null,
        pm.description ? _react2.default.createElement('meta', { name: 'twitter:description', content: pm.description }) : null,
        pm.image ? _react2.default.createElement('meta', { property: 'og:image', content: pm.image }) : null,
        pm.image ? _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary_large_image' }) : null,
        pm.image ? _react2.default.createElement('meta', { name: 'twitter:image', content: pm.image }) : null,
        pm.keywords ? _react2.default.createElement('meta', { name: 'keywords', content: pm.keywords }) : null,
        _react2.default.createElement('meta', { property: 'og:url', content: window.location.href })
    );
};

exports.default = HelmetWrap;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterDom = __webpack_require__(7);

var _Caption = __webpack_require__(300);

var _Caption2 = _interopRequireDefault(_Caption);

var _HomeModal = __webpack_require__(303);

var _HomeModal2 = _interopRequireDefault(_HomeModal);

var _theme = __webpack_require__(1);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkWrapper = function (_Component) {
  _inherits(LinkWrapper, _Component);

  function LinkWrapper(props) {
    _classCallCheck(this, LinkWrapper);

    var _this = _possibleConstructorReturn(this, (LinkWrapper.__proto__ || Object.getPrototypeOf(LinkWrapper)).call(this, props));

    _this.state = {
      popover: false,
      popoverImage: {},
      loading: false
    };
    _this.gradientOpacity = {
      opacity: (0, _scripts.returnOpacity)(_this.props.linkData.slideshow_gradient_opacity)
    };
    return _this;
  }

  _createClass(LinkWrapper, [{
    key: '_expandLink',
    value: function _expandLink(item) {
      this.setState({
        popover: true,
        popoverImage: item
      });
    }
  }, {
    key: '_closePopup',
    value: function _closePopup() {
      this.setState({
        popover: false
      });
    }
  }, {
    key: '_clickLink',
    value: function _clickLink(linkData, props) {
      if (linkData == 'external') {
        window.open(props.link, '_blank');
      } else if (linkData == 'instagram') {
        _scripts.instagramFormat.instaLink(props.description);
      } else if (linkData == 'expand') {
        this._expandLink(props);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.props.linkClass && _react2.default.createElement('div', { className: 'block-out' }),
        this.state.popover && _react2.default.createElement(_HomeModal2.default, { popoverData: this.props.linkData, ClickFunction: function ClickFunction() {
            return _this2._closePopup();
          } }),
        this.props.window_width >= _theme.breakpoints.desktop && _react2.default.createElement(
          'div',
          { className: !this.props.hideCaption ? 'hp-image-caption-wrap ' + this.props.video_header_state : 'hp-image-caption-wrap' },
          _react2.default.createElement(_Caption2.default, { linkData: this.props.linkData, type: this.props.linkData.type, opacity: this.props.linkData.slideshow_gradient_opacity })
        ),
        this.props.linkData.type !== 'border' && _react2.default.createElement(
          'div',
          { className: 'hp-image-gradient-wrapper' },
          _react2.default.createElement('div', { style: this.gradientOpacity, className: 'hp-image-gradient' })
        ),
        this.props.linkData.linkType == 'internal' && this.props.linkData.link.slug ? _react2.default.createElement(
          _reactRouterDom.Link,
          { className: 'grid-link', to: '/' + this.props.linkData.link.postType + '/' + this.props.linkData.link.slug },
          this.props.children
        ) : _react2.default.createElement(
          'a',
          { className: 'grid-link', onClick: function onClick() {
              return _this2._clickLink(_this2.props.linkData.linkType, _this2.props.linkData);
            } },
          this.props.children
        )
      );
    }
  }]);

  return LinkWrapper;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    video_header_state: state.video_state.header_style,
    window_width: state.window_dimensions.window_width
  };
})(LinkWrapper);

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bgImage = function bgImage(src) {
  var bgStyle = {
    backgroundImage: 'url(' + src + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  };
  return bgStyle;
};

exports.default = bgImage;

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BwSignature = function BwSignature(props) {
  return _react2.default.createElement(
    'div',
    {
      className: _style2.default.dynamic([['2054494881', [_theme.widths.single_pad, _theme.widths.single_pad]]]) + ' ' + ((props.position == 'top' ? 'signature-wrapper' : 'signature-loader') || '')
    },
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['2054494881', [_theme.widths.single_pad, _theme.widths.single_pad]]]) + ' ' + 'inner-signature'
      },
      props.color == 'white' ? _react2.default.createElement('div', { style: (0, _scripts.bgImage)('/static/icons/bw-cursive.svg'), className: _style2.default.dynamic([['2054494881', [_theme.widths.single_pad, _theme.widths.single_pad]]]) + ' ' + 'signature'
      }) : _react2.default.createElement('div', { style: (0, _scripts.bgImage)('/static/icons/bw-cursive-blk.svg'), className: _style2.default.dynamic([['2054494881', [_theme.widths.single_pad, _theme.widths.single_pad]]]) + ' ' + 'signature'
      })
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '2054494881',
      css: ['@-webkit-keyframes pulse-__jsx-style-dynamic-selector{0%{opacity:0;}15%{opacity:.25;}50%{opacity:1;}90%{opacity:.25;}100%{opacity:0;}}', '@keyframes pulse-__jsx-style-dynamic-selector{0%{opacity:0;}15%{opacity:.25;}50%{opacity:1;}90%{opacity:.25;}100%{opacity:0;}}', '.signature-wrapper.__jsx-style-dynamic-selector{width:100%;position:absolute;top:0;left:0;padding-left:' + _theme.widths.single_pad + ';padding-right:' + _theme.widths.single_pad + ';padding-top:4rem;}', '.signature-loader.__jsx-style-dynamic-selector{-webkit-animation:pulse-__jsx-style-dynamic-selector 5000ms infinite linear;animation:pulse-__jsx-style-dynamic-selector 5000ms infinite linear;padding-bottom:6rem;}', '.inner-signature.__jsx-style-dynamic-selector{width:100%;margin:auto;}', '.signature.__jsx-style-dynamic-selector{background-repeat:no-repeat;background-position:center;background-size:contain;width:12.6rem;height:6.6rem;}'],
      dynamic: [_theme.widths.single_pad, _theme.widths.single_pad]
    })
  );
};

exports.default = BwSignature;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import Raven from 'raven-js'

var ErrorBoundary = function (_Component) {
  _inherits(ErrorBoundary, _Component);

  function ErrorBoundary(props) {
    _classCallCheck(this, ErrorBoundary);

    var _this = _possibleConstructorReturn(this, (ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call(this, props));

    _this.state = { hasError: false };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({ hasError: true });
      // Raven.captureException(error, { extra: errorInfo })
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return _react2.default.createElement(
          "div",
          { id: "error-wrapper", className: "jsx-1673033450"
          },
          _react2.default.createElement(
            "h2",
            {
              className: "jsx-1673033450"
            },
            "Oops.. Something went wrong. \uD83D\uDE22"
          ),
          _react2.default.createElement(_style2.default, {
            styleId: "1673033450",
            css: ["#error-wrapper.jsx-1673033450{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;min-height:75vh;background-color:grey;text-transform:uppercase;color:#FFF;}"]
          })
        );
      }
      return this.props.children;
    }
  }]);

  return ErrorBoundary;
}(_react.Component);

exports.default = ErrorBoundary;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var studio_conversations = 'Studio <br /> Conversations';

var HeaderDropNav = function HeaderDropNav(_ref) {
  var onClick = _ref.onClick,
      currentPage = _ref.currentPage,
      linkClass = _ref.linkClass;
  return _react2.default.createElement(
    'div',
    { className: 'nav-header', onClick: onClick },
    _react2.default.createElement(
      'div',
      { className: linkClass },
      currentPage == 'Studio-conversations' || currentPage == 'Studio-conversation' ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: studio_conversations } }) : currentPage
    ),
    _react2.default.createElement('div', { className: 'nav-divot' })
  );
};

exports.default = HeaderDropNav;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _AnimateOnMount = __webpack_require__(78);

var _AnimateOnMount2 = _interopRequireDefault(_AnimateOnMount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageStack = function (_Component) {
    _inherits(ImageStack, _Component);

    function ImageStack(props) {
        _classCallCheck(this, ImageStack);

        var _this = _possibleConstructorReturn(this, (ImageStack.__proto__ || Object.getPrototypeOf(ImageStack)).call(this, props));

        _this.state = {
            topItem: 0,
            limit: 0,
            displayCaption: false,
            intervalId: null,
            images: _this.props.imgs
        };
        _this.addNextImage = _this.addNextImage.bind(_this);
        _this.originalArrayLength = _this.props.imgs.length;
        _this.emptyImgObj = {
            urls: null,
            metadata: null
        };
        return _this;
    }

    _createClass(ImageStack, [{
        key: 'renderImages',
        value: function renderImages() {
            return this.state.images.slice(0, this.state.limit).map(function (item, i) {
                var bgStyle = void 0;
                if (item.urls != null) {
                    bgStyle = {
                        backgroundImage: 'url(' + item.urls.small + ')'
                    };
                }
                return _react2.default.createElement(
                    'div',
                    { className: 'image-stack-image', key: i },
                    _react2.default.createElement(
                        _AnimateOnMount2.default,
                        null,
                        item.urls != null ? _react2.default.createElement('div', { className: 'bg-image', style: bgStyle }) : _react2.default.createElement('div', null)
                    )
                );
            });
        }
    }, {
        key: 'addNextImage',
        value: function addNextImage() {
            var count = void 0;
            var item = void 0;
            var capt = void 0;
            var shifter = void 0;
            var blanksCount = void 0;
            if (this.state.limit < this.props.imgs.length) {
                count = this.state.limit + 1;
                item = this.state.limit;
                capt = this.props.imgs[item].metadata;
            } else {
                count = this.state.limit + 1;
                var oldOne = this.state.images[this.state.limit - this.originalArrayLength];
                var newOne = {
                    urls: oldOne.urls,
                    metadata: oldOne.metadata
                };
                capt = oldOne.metadata;
                this.state.images.push(newOne);
                oldOne.urls = null;
                oldOne.metadata = null;
                this.forceUpdate();
            }

            this.setState({
                limit: count,
                displayCaption: capt
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.addNextImage();
            var intervalId = setInterval(this.addNextImage, 3000);
            this.setState({ intervalId: intervalId });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.state.intervalId);
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: 'image-stack-wrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'image-stack' },
                    this.state.displayCaption && this.state.displayCaption.title != '' ? _react2.default.createElement(
                        'div',
                        { className: 'caption' },
                        ' ',
                        _react2.default.createElement(_SingleLineCaption2.default, { Headline: this.state.displayCaption.title, Description: this.state.displayCaption.caption, Sep: true }),
                        ' '
                    ) : null,
                    _react2.default.createElement(
                        'div',
                        { className: 'image-stack-images' },
                        this.renderImages()
                    )
                )
            );
        }
    }]);

    return ImageStack;
}(_react.Component);

exports.default = ImageStack;
;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Press = function Press(props) {
  var pressItems = props.PressData.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { key: 'press_item-' + i, className: 'jsx-2684548044' + ' ' + 'press-article-item'
      },
      _react2.default.createElement(
        'a',
        { href: item.link, target: '_blank', className: 'jsx-2684548044' + ' ' + 'external-link-lg'
        },
        item.link_text
      ),
      _react2.default.createElement(_style2.default, {
        styleId: '2684548044',
        css: ['.press-article-item.jsx-2684548044{padding-bottom:1rem;}', '.press-article-item.jsx-2684548044:last-child{padding-bottom:0;}']
      })
    );
  });
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-3726076708' + ' ' + 'press-repeater'
    },
    _react2.default.createElement(
      'h3',
      {
        className: 'jsx-3726076708' + ' ' + 'small-header'
      },
      'Press'
    ),
    _react2.default.createElement(
      'ul',
      {
        className: 'jsx-3726076708' + ' ' + 'press-articles'
      },
      pressItems
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '3726076708',
      css: ['.press-repeater.jsx-3726076708{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}', '.press-articles.jsx-3726076708{list-style:none;}']
    })
  );
};

exports.default = Press;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProjectDetailCaption = function ProjectDetailCaption(props) {
  var captionColor = '#ffffff';
  if (props.darkCaption) {
    captionColor = _theme.colors.black;
  };
  return _react2.default.createElement(
    'div',
    { style: { color: captionColor }, className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'caption-wrapper'
    },
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + ((props.PageGrid ? 'project-caption ' + props.PageGrid : 'project-caption') || '')
      },
      _react2.default.createElement(
        'div',
        {
          className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]])
        },
        props.linksInCaption ? _react2.default.createElement(
          'div',
          { onClick: function onClick(e) {
              e.stopPropagation();
            }, className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'stop-propagation'
          },
          _react2.default.createElement(
            'div',
            {
              className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'copy-left'
            },
            _react2.default.createElement(
              'h3',
              {
                className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'project-name'
              },
              _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.ProjectName }, className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]])
              })
            ),
            _react2.default.createElement(
              'h4',
              {
                className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'image-description'
              },
              _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.ImageDescription }, className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]])
              })
            )
          ),
          props.ExpandIcon && _react2.default.createElement('div', { style: (0, _scripts.bgImage)('/static/icons/expand.svg'), className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'expand'
          })
        ) : _react2.default.createElement(
          'div',
          {
            className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'stop-propagation'
          },
          _react2.default.createElement(
            'div',
            {
              className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'copy-left'
            },
            _react2.default.createElement(
              'h3',
              {
                className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'project-name'
              },
              _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.ProjectName }, className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]])
              })
            ),
            _react2.default.createElement(
              'h4',
              {
                className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'image-description'
              },
              _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.ImageDescription }, className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]])
              })
            )
          ),
          props.ExpandIcon && _react2.default.createElement('div', { style: (0, _scripts.bgImage)('/static/icons/expand.svg'), className: _style2.default.dynamic([['438362156', [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]]]) + ' ' + 'expand'
          })
        )
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '438362156',
      css: ['.stop-propagation.__jsx-style-dynamic-selector{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;position:relative;padding:35% 2rem 2rem;z-index:100;}', '.caption-wrapper.__jsx-style-dynamic-selector{position:absolute;display:block;top:0;left:0;height:100%;width:100%;cursor:pointer;z-index:2;}', '.caption-wrapper.__jsx-style-dynamic-selector:hover>.project-caption.__jsx-style-dynamic-selector{opacity:1;}', '.project-caption.__jsx-style-dynamic-selector{position:absolute;bottom:0;left:0;width:100%;opacity:0;will-change:opacity;-webkit-transition:opacity 500ms ease;transition:opacity 500ms ease;}', '.photo-grid.__jsx-style-dynamic-selector{width:calc(100% - (' + _theme.spacing.masonry_cell_padding + ' * 2));bottom:calc(' + _theme.spacing.masonry_cell_padding + ');left:calc(' + _theme.spacing.masonry_cell_padding + ');}', '.copy.__jsx-style-dynamic-selector{position:relative;z-index:10;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}', '.expand.__jsx-style-dynamic-selector{height:2rem;width:2rem;}', '.bg-gradient.__jsx-style-dynamic-selector{width:100%;height:100%;position:absolute;bottom:0;left:0;background:linear-gradient(to bottom,rgba(255,255,255,0) 0%,rgba(255,255,255,0) 70%,rgba(76,76,76,1) 100%);mix-blend-mode:multiply;z-index:0;}', '.project-name.__jsx-style-dynamic-selector,.image-description.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';font-size:' + _theme.fonts.caption_size + ';-webkit-letter-spacing:' + _theme.fonts.caption_spacing + ';-moz-letter-spacing:' + _theme.fonts.caption_spacing + ';-ms-letter-spacing:' + _theme.fonts.caption_spacing + ';letter-spacing:' + _theme.fonts.caption_spacing + ';text-transform:uppercase;line-height:1.25;}', '.project-name.__jsx-style-dynamic-selector{margin-bottom:.175rem;font-weight:bold;}', '.image-description.__jsx-style-dynamic-selector{font-weight:300;}', '.landing-grid.__jsx-style-dynamic-selector>.copy.__jsx-style-dynamic-selector>h3.__jsx-style-dynamic-selector{margin-bottom:.25rem;font-size:1.75rem;text-transform:none;}'],
      dynamic: [_theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.spacing.masonry_cell_padding, _theme.fonts.mallory, _theme.fonts.caption_size, _theme.fonts.caption_spacing]
    })
  );
};

exports.default = ProjectDetailCaption;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Make fade when scroll
var ScrollPrompt = function ScrollPrompt(props) {
  return _react2.default.createElement(
    'div',
    { className: props.scrollDirection == 'top' ? 'scroll-prompt top' : 'scroll-prompt' },
    _react2.default.createElement(
      'svg',
      { version: '1.1', viewBox: '0 0 64 64', width: '45', height: '45' },
      _react2.default.createElement(
        'g',
        { className: 'nc-icon-wrapper', fill: '#ffffff' },
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#ffffff', strokeWidth: '2', strokeLinecap: 'square', strokeMiterlimit: '10', points: '60,18 32,46 4,18 ', strokeLinejoin: 'miter' })
      )
    )
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    scrollDirection: state.scroll_direction
  };
})(ScrollPrompt);

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-2034929409' + ' ' + 'spinner'
    },
    _react2.default.createElement(
      'svg',
      { version: '1.1', xmlns: 'http://www.w3.org/2000/svg', x: '0px', y: '0px', viewBox: '0 0 32 32', width: '32', height: '32', className: 'jsx-2034929409'
      },
      _react2.default.createElement(
        'g',
        { fill: '#111111', className: 'jsx-2034929409' + ' ' + 'nc-icon-wrapper'
        },
        _react2.default.createElement(
          'g',
          {
            className: 'jsx-2034929409' + ' ' + 'nc-loop_circle-04-32'
          },
          _react2.default.createElement('path', { 'data-cap': 'butt', fill: 'none', stroke: '#111111', strokeWidth: '2', strokeMiterlimit: '10', d: 'M2.30867,22.13668 C1.46776,20.26345,1,18.18635,1,16C1,7.71573,7.71573,1,16,1s15,6.71573,15,15s-6.71573,15-15,15 c-3.61453,0-6.93046-1.27847-9.52027-3.40787', transform: 'rotate(234.13100000005215 16 16)', strokeLinecap: 'butt', strokeLinejoin: 'miter', className: 'jsx-2034929409'
          })
        )
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '2034929409',
      css: ['@-webkit-keyframes spin-jsx-2034929409{from{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}to{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}', '@keyframes spin-jsx-2034929409{from{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg);}to{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);transform:rotate(360deg);}}', '.spinner.jsx-2034929409{width:32px;height:32px;position:absolute;top:0;left:0;bottom:0;right:0;margin:auto;-webkit-animation:spin-jsx-2034929409 700ms linear 0s infinite normal;animation:spin-jsx-2034929409 700ms linear 0s infinite normal;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards;opacity:.25;}']
    })
  );
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Headline = function Headline(props) {
  return _react2.default.createElement(
    'h1',
    {
      className: _style2.default.dynamic([['424690006', [_theme.fonts.mallory_bold, _theme.fonts.h1_size]]]) + ' ' + (props.color || '')
    },
    props.children,
    _react2.default.createElement(_style2.default, {
      styleId: '424690006',
      css: ['h1.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory_bold + ';font-size:' + _theme.fonts.h1_size + ';-webkit-letter-spacing:.2rem;-moz-letter-spacing:.2rem;-ms-letter-spacing:.2rem;letter-spacing:.2rem;color:#000;text-transform:uppercase;}', '.black.__jsx-style-dynamic-selector{color:#000;}', '.white.__jsx-style-dynamic-selector{color:#fff;}'],
      dynamic: [_theme.fonts.mallory_bold, _theme.fonts.h1_size]
    })
  );
};

exports.default = Headline;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _reactRedux = __webpack_require__(3);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _FilmHoverClip = __webpack_require__(257);

var _FilmHoverClip2 = _interopRequireDefault(_FilmHoverClip);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilmArtGrid = function FilmArtGrid(props) {
  var Grid = props.GridItems.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { className: 'img-grid-li ' + props.Page, key: 'film-art-grid-' + item.image.id },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { to: '/' + item.link.postType + '/' + item.link.slug },
        _react2.default.createElement(
          'div',
          { className: 'grid-item-link' },
          props.Page == 'film' ? _react2.default.createElement(_FilmHoverClip2.default, { itemData: item }) : props.Page == 'fine-art' && _react2.default.createElement('div', { className: 'img-wrapper-fine-art ' + (0, _scripts.returnCategories)(item.nav_categories), style: (0, _scripts.bgImage)(item.image.small) }),
          props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(
            'div',
            { className: 'film-caption' },
            _react2.default.createElement(
              'div',
              { className: 'caption-wrapper' },
              _react2.default.createElement(_SingleLineCaption2.default, { Headline: item.project_caption.headline, Description: item.project_caption.description, Sep: true })
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'film-caption' },
            _react2.default.createElement(_SingleLineCaption2.default, { Headline: item.project_caption.headline, Description: item.project_caption.description, Stacked: true })
          )
        )
      )
    );
  });
  return _react2.default.createElement(
    'section',
    { id: 'filter-grid' },
    _react2.default.createElement(
      'ul',
      { className: 'grid-wrapper' },
      Grid
    ),
    _react2.default.createElement(
      'div',
      { id: 'external-links' },
      props.Page == 'film' ? _react2.default.createElement(
        'ul',
        { className: 'external-link-list' },
        _react2.default.createElement(
          'li',
          { className: 'link-item' },
          _react2.default.createElement(
            'a',
            { className: 'external-link', href: props.vimeoLink, target: '_blank' },
            'Browse the Archive'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'link-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { className: 'external-link', to: '/about' },
            'View Full Filmography'
          )
        )
      ) : _react2.default.createElement(
        'ul',
        { className: 'external-link-list' },
        _react2.default.createElement(
          'li',
          { className: 'link-item' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { className: 'external-link', to: '/galleries' },
            'Gallery List'
          )
        ),
        _react2.default.createElement(
          'li',
          { className: 'link-item' },
          _react2.default.createElement(
            'a',
            { className: 'external-link', href: '#', target: '_blank' },
            'View Full Exhibitions'
          )
        )
      )
    )
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width,
    vimeoLink: state.staticContent.homeData.data.social_links[1].link
  };
})(FilmArtGrid);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _DesktopFooter = __webpack_require__(263);

var _DesktopFooter2 = _interopRequireDefault(_DesktopFooter);

var _MobileFooter = __webpack_require__(264);

var _MobileFooter2 = _interopRequireDefault(_MobileFooter);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterLayout = function FooterLayout(props) {
  return _react2.default.createElement(
    'footer',
    { id: 'footer-layout', className: 'jsx-398075171'
    },
    props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(_DesktopFooter2.default, { socialLinks: props.socialLinks }) : _react2.default.createElement(_MobileFooter2.default, { socialLinks: props.socialLinks }),
    _react2.default.createElement(_style2.default, {
      styleId: '398075171',
      css: ['#footer-layout.jsx-398075171{position:relative;width:100vw;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-top:1.5rem;}', '@media (min-width:640px){#footer-layout.jsx-398075171{margin-top:0;}}']
    })
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(FooterLayout);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _BgImage = __webpack_require__(35);

var _BgImage2 = _interopRequireDefault(_BgImage);

var _HeroSliderCaption = __webpack_require__(268);

var _HeroSliderCaption2 = _interopRequireDefault(_HeroSliderCaption);

var _theme = __webpack_require__(1);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroSliderSlide = function HeroSliderSlide(props) {
  //props.slideData.slideshow_photo.large
  var photo_desktop = props.slideData.slideshow_photo_full;
  if (props.height) {
    photo_desktop = props.slideData.slideshow_photo_short;
  }

  var photo_mobile = props.slideData.slideshow_photo_full;
  if (props.slideData.mobile_photo) {
    photo_mobile = props.slideData.mobile_photo;
  }

  var gradientStyle = {
    opacity: (0, _scripts.returnOpacity)(props.slideData.slideshow_gradient_opacity)
  };

  return _react2.default.createElement(
    'div',
    { style: props.height ? { height: props.height } : { height: '100vh' }, className: 'jsx-300611599' + ' ' + 'inner-slide'
    },
    _react2.default.createElement(_HeroSliderCaption2.default, { caption: props.slideData.slideshow_caption }),
    _react2.default.createElement(
      'div',
      {
        className: 'jsx-300611599' + ' ' + 'slide-wrapper'
      },
      _react2.default.createElement('div', { style: gradientStyle, className: 'jsx-300611599' + ' ' + 'slide-gradient'
      }),
      props.slideData.media_type == 'photograph' ? props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(_BgImage2.default, { source: photo_desktop }) : _react2.default.createElement(_BgImage2.default, { source: photo_mobile }) : null,
      props.children
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '300611599',
      css: ['.inner-slide.jsx-300611599{width:100vw;height:100%;background:#FFF;position:relative;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);}', '.slide-wrapper.jsx-300611599{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:absolute;top:0;left:0;z-index:50;-webkit-transform:translateZ(0);-ms-transform:translateZ(0);transform:translateZ(0);}', '.slide-gradient.jsx-300611599{content:\'\';width:100%;height:100%;background:linear-gradient(to bottom,rgba(76,76,76,1) 0%,rgba(255,255,255,0) 15%,rgba(255,255,255,0) 70%,rgba(76,76,76,1) 100%);mix-blend-mode:multiply;position:absolute;bottom:0;z-index:10;}']
    })
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(HeroSliderSlide);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FilmProjectInfo = __webpack_require__(271);

var _FilmProjectInfo2 = _interopRequireDefault(_FilmProjectInfo);

var _VideoPlayer = __webpack_require__(51);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilmProjectTop = function (_PureComponent) {
  _inherits(FilmProjectTop, _PureComponent);

  function FilmProjectTop(props) {
    _classCallCheck(this, FilmProjectTop);

    var _this = _possibleConstructorReturn(this, (FilmProjectTop.__proto__ || Object.getPrototypeOf(FilmProjectTop)).call(this, props));

    _this.state = {
      isOpen: _this.props.FilmData.auto_expand
    };
    _this.toggleDropdown = _this._toggleDropdown.bind(_this);
    return _this;
  }

  _createClass(FilmProjectTop, [{
    key: '_toggleDropdown',
    value: function _toggleDropdown() {
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'section',
        { id: 'film-project-top' },
        _react2.default.createElement(_VideoPlayer2.default, { videoId: this.props.FilmData.vimeo_id, videoUrl: 'https://vimeo.com/' + this.props.FilmData.vimeo_id, videoPoster: this.props.FilmData.video_img.large, cta: 'PLAY' }),
        _react2.default.createElement(
          'div',
          { id: 'film-detail-header' },
          _react2.default.createElement(
            'div',
            { className: 'headline' },
            _react2.default.createElement('h1', { className: 'medium-header hl-primary', dangerouslySetInnerHTML: { __html: this.props.FilmData.headline } }),
            this.props.FilmData.description && _react2.default.createElement('h2', { className: 'light-header hl-secondary', dangerouslySetInnerHTML: { __html: this.props.FilmData.description } })
          ),
          this.props.FilmData.content && _react2.default.createElement(
            'div',
            { className: 'expand' },
            _react2.default.createElement('button', { onClick: this.toggleDropdown, className: this.state.isOpen ? 'read-more small-header' : 'read-more closed small-header' })
          )
        ),
        this.props.FilmData.content && _react2.default.createElement(
          'div',
          { className: this.state.isOpen ? 'dropdown-content' : 'dropdown-content closed' },
          _react2.default.createElement(_FilmProjectInfo2.default, { ProjectInfo: this.props.FilmData })
        )
      );
    }
  }]);

  return FilmProjectTop;
}(_react.PureComponent);

exports.default = FilmProjectTop;
;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PortfolioHeader = function PortfolioHeader(props) {
  return _react2.default.createElement(
    'section',
    { id: 'portfolio-header', className: _style2.default.dynamic([['671863140', [_theme.spacing.masonry_cell_padding, _theme.heights.header]]])
    },
    _react2.default.createElement(_SingleLineCaption2.default, {
      Headline: props.HeaderData.headline,
      Description: props.HeaderData.description,
      Date: null,
      DateComma: false,
      Sep: true
    }),
    _react2.default.createElement(_style2.default, {
      styleId: '671863140',
      css: ['#portfolio-header.__jsx-style-dynamic-selector{width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;height:auto;padding:' + _theme.spacing.masonry_cell_padding + ' 3rem 0;margin-top:' + _theme.heights.header + ';margin-bottom:25px;}'],
      dynamic: [_theme.spacing.masonry_cell_padding, _theme.heights.header]
    })
  );
};

exports.default = PortfolioHeader;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PopoverSwiper = __webpack_require__(276);

var _PopoverSwiper2 = _interopRequireDefault(_PopoverSwiper);

var _PopoverModal = __webpack_require__(275);

var _PopoverModal2 = _interopRequireDefault(_PopoverModal);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.keydown = _this._handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: '_handleKeyDown',
    value: function _handleKeyDown(event) {
      switch (event.keyCode) {
        case 27:
          this.props.ClickFunction();
          break;
        default:
          break;
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('keydown', this.keydown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.keydown);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _PopoverModal2.default,
        null,
        _react2.default.createElement(
          'div',
          { id: 'popover-wrapper', className: _style2.default.dynamic([['3073870126', [_theme.colors.black]]])
          },
          _react2.default.createElement('button', { id: 'close-popover', onClick: this.props.ClickFunction, className: _style2.default.dynamic([['3073870126', [_theme.colors.black]]])
          }),
          _react2.default.createElement(_PopoverSwiper2.default, { PortfolioImages: this.props.Images, currentImage: this.props.CurrentImage }),
          _react2.default.createElement(_style2.default, {
            styleId: '3073870126',
            css: ['#slideshow-modal{width:100%;height:100vh;position:fixed;top:0;left:0;z-index:10000;background:' + _theme.colors.black + ';}', '#popover-wrapper.__jsx-style-dynamic-selector{width:100%;height:100%;position:absolute;top:0;left:0;}', '#close-popover.__jsx-style-dynamic-selector{position:fixed;top:2.5rem;right:2.5rem;height:2rem;width:3.5rem;border:0;background-color:rgba(0,0,0,0);z-index:12000;cursor:pointer;}', '#close-popover.__jsx-style-dynamic-selector:after{position:absolute;top:0;right:0;z-index:12001;content:\'CLOSE\';color:white;font-weight:bold;}'],
            dynamic: [_theme.colors.black]
          })
        )
      );
    }
  }]);

  return _class;
}(_react.Component);

exports.default = _class;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _ExPubSwiper = __webpack_require__(157);

var _ExPubSwiper2 = _interopRequireDefault(_ExPubSwiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement(
    _react.Fragment,
    null,
    props.data.hero_slider && _react2.default.createElement(_components.Hero, { sliderContent: props.data.hero_slider, height: '64vh' }),
    _react2.default.createElement(
      'section',
      { className: !props.data.hero_slider ? 'ex-pub-wrapper no-slider' : 'ex-pub-wrapper' },
      _react2.default.createElement(
        'article',
        { className: 'ex-pub-primary' },
        _react2.default.createElement(
          'div',
          { className: 'ex-pub-info' },
          _react2.default.createElement('h1', { className: 'medium-header publication-header', dangerouslySetInnerHTML: { __html: props.data.headline } }),
          props.children
        ),
        _react2.default.createElement(
          'div',
          { className: 'intro' },
          _react2.default.createElement('div', { className: 'formatted-markup', dangerouslySetInnerHTML: { __html: props.data.content } })
        )
      )
    ),
    _react2.default.createElement(_ExPubSwiper2.default, { Slides: props.data.gallery }),
    props.data.press && _react2.default.createElement(
      'section',
      { className: 'ex-pub-secondary' },
      _react2.default.createElement(_components.Press, { PressData: props.data.press })
    )
  );
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactIdSwiper = __webpack_require__(216);

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _components = __webpack_require__(6);

var _Popover = __webpack_require__(155);

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExPubSwiper = function (_Component) {
  _inherits(ExPubSwiper, _Component);

  function ExPubSwiper(props) {
    _classCallCheck(this, ExPubSwiper);

    var _this = _possibleConstructorReturn(this, (ExPubSwiper.__proto__ || Object.getPrototypeOf(ExPubSwiper)).call(this, props));

    _this.state = {
      popover: false,
      currentImage: _this.props.Slides[0].urls.id,
      thumbClicked: null,
      clicks: 0
    };
    return _this;
  }

  _createClass(ExPubSwiper, [{
    key: '_slideChange',
    value: function _slideChange() {
      var swiperIndex = this.swiper.realIndex;
      var currentSlide = this.props.Slides[swiperIndex].urls.id;
      this.setState({
        currentImage: currentSlide
      });
    }
  }, {
    key: '_closePopup',
    value: function _closePopup() {
      this.setState({
        popover: false
      });
    }
  }, {
    key: '_clickPopupDesktop',
    value: function _clickPopupDesktop(id) {
      this.setState({
        currentImage: id,
        popover: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var GalleryItems = this.props.Slides.map(function (item, i) {
        return _react2.default.createElement(
          'div',
          { key: 'pub-slide__' + item.urls.id + '-' + i, className: 'jsx-4183134571' + ' ' + 'ex-pub__slide'
          },
          _react2.default.createElement(
            'div',
            { onClick: function onClick() {
                return _this2._clickPopupDesktop(item.urls.id);
              }, className: 'jsx-4183134571' + ' ' + 'slide-img-wrapper'
            },
            _react2.default.createElement(_components.BgImage, { bgSize: 'contain', source: item.urls.large })
          ),
          _react2.default.createElement(_components.SingleLineCaption, { Headline: item.metadata.title, Description: item.metadata.caption }),
          _react2.default.createElement(_style2.default, {
            styleId: '4183134571',
            css: ['.ex-pub__slide.jsx-4183134571{height:calc(50vh + 6rem);opacity:.25;-webkit-transition:opacity 750ms ease;transition:opacity 750ms ease;will-change:opacity;text-align:center;}', '.slide-img-wrapper.jsx-4183134571{height:50vh;cursor:pointer;}', '@media (min-width:640px){.ex-pub__slide.jsx-4183134571{height:calc(70vh + 6rem);}.slide-img-wrapper.jsx-4183134571{height:70vh;}}', '.swiper-slide > .caption-wrapper{-webkit-transition:opacity 1000ms ease 250ms;transition:opacity 1000ms ease 250ms;will-change:opacity;opacity:0;padding-top:2rem;}', '.swiper-slide-active{opacity:1!important;}', '.swiper-slide-active > .caption-wrapper{opacity:1!important;}']
          })
        );
      });

      var swiperParams = {
        slidesPerView: 3,
        spaceBetween: 100,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          }
        },
        centeredSlides: true,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        loopAdditionalSlides: 5,
        navigation: {
          nextEl: '.ep_swiper-next',
          prevEl: '.ep_swiper-prev'
        },
        pagination: {
          clickable: true,
          loop: true
        },
        on: {
          slideChange: function slideChange() {
            _this2._slideChange();
          }
        }
      };

      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.popover && _react2.default.createElement(_Popover2.default, { Images: this.props.Slides, CurrentImage: this.state.currentImage, ClickFunction: function ClickFunction() {
            return _this2._closePopup();
          } }),
        _react2.default.createElement(
          'section',
          { id: 'ex-pub__slider', className: 'jsx-1782250627'
          },
          _react2.default.createElement(
            'div',
            { id: 'ex-pub__wrapper', className: 'jsx-1782250627'
            },
            _react2.default.createElement(
              _reactIdSwiper2.default,
              _extends({}, swiperParams, { ref: function ref(node) {
                  if (node) _this2.swiper = node.swiper;
                } }),
              GalleryItems
            )
          ),
          _react2.default.createElement(_style2.default, {
            styleId: '1782250627',
            css: ['#ex-pub__slider.jsx-1782250627{width:100%;position:relative;top:0;left:0;margin:6rem auto;overflow-x:hidden;}', '#ex-pub__wrapper.jsx-1782250627{width:100vw;position:relative;left:0;top:0;}', '#ex-pub__slider.jsx-1782250627,#ex-pub__wrapper.jsx-1782250627{height:calc(50vh + 6rem);}', '@media (min-width:640px){#ex-pub__slider.jsx-1782250627,#ex-pub__wrapper.jsx-1782250627{height:calc(70vh + 6rem);}}', '#ex-pub__wrapper > .swiper-container{width:170vw;position:absolute;top:0;left:0;-webkit-transform:translateX(-35vw);-ms-transform:translateX(-35vw);transform:translateX(-35vw);}', '.ep_swiper-next,.ep_swiper-prev{position:absolute;height:100%;top:0;width:25vw;cursor:pointer;background-size:contain;background-repeat:no-repeat;background-position:center;color:transparent;background-color:transparent;outline:none;z-index:12000;opacity:.85;text-transform:uppercase;}', '.ep_swiper-prev{left:35vw;cursor:url(\'/static/icons/arrow-left-cursor.svg\'),auto;}', '.ep_swiper-next{right:35vw;cursor:url(\'/static/icons/arrow-right-cursor.svg\'),auto;}']
          })
        )
      );
    }
  }]);

  return ExPubSwiper;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(ExPubSwiper);

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (props) {
  var gridItems = props.data.map(function (item, i) {
    return _react2.default.createElement(
      'div',
      { className: 'c-' + item.type + ' home-grid-item-wrapper', key: 'hp-grid-' + item.image.id + '-' + i + 'i' },
      _react2.default.createElement(
        _reactLazyload2.default,
        { height: '100%' },
        _react2.default.createElement(_DesktopGridItem2.default, { itemData: item })
      )
    );
  });
  return _react2.default.createElement(
    'section',
    { id: 'image-grid-desktop' },
    gridItems
  );
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DesktopGridItem = __webpack_require__(305);

var _DesktopGridItem2 = _interopRequireDefault(_DesktopGridItem);

var _reactLazyload = __webpack_require__(126);

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLazyload = __webpack_require__(126);

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

var _MobileGridItem = __webpack_require__(306);

var _MobileGridItem2 = _interopRequireDefault(_MobileGridItem);

var _LinkWrapper = __webpack_require__(83);

var _LinkWrapper2 = _interopRequireDefault(_LinkWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileGrid = function MobileGrid(props) {
  var gridItems = props.data.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { className: item.video ? 'home-grid-item-wrapper-mobile video-thumb-mobile' : 'home-grid-item-wrapper-mobile', key: 'hp-grid-mobile-' + item.image.id + i },
      _react2.default.createElement(
        _reactLazyload2.default,
        null,
        _react2.default.createElement(_MobileGridItem2.default, { itemData: item })
      )
    );
  });
  return _react2.default.createElement(
    'ul',
    { id: 'image-grid-mobile' },
    gridItems
  );
};

exports.default = MobileGrid;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBrowserHistory = __webpack_require__(426);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBrowserHistory2.default)();

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getKey = function getKey(item) {
  var itemKey = Object.keys(item);
  return itemKey[0];
};

exports.default = getKey;

/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports) {

module.exports = {"TITLE":"Bruce Weber","DESCRIPTION":"","defaults":{"wp_api":"https://api.bruceweber.com/wp-json/wp/v2/","custom_api":"https://api.bruceweber.com/wp-json/bwapi/v1/","page_filter":"pages?filter[name]=","id_filter":"pages?filter[page_id]="},"page_meta_defaults":{"title":"Bruce Weber","description":"Official Bruce Weber Website","keywords":"Bruce Weber, Photography, Photographer","image":"https://s3.amazonaws.com/bruce-weber/wp-content/uploads/2017/10/17203457/bw-home-hero.jpg"},"endpoints":{"latest":"home","photography":"photography","film":"film","fine_art":"fine-art","publications":"publications","about":"about"},"primary_nav":[{"page":"Latest","link":"/"},{"page":"Photography","link":"/photography"},{"page":"Film","link":"/film"},{"page":"Studio <br /> Conversations","link":"/studio-conversations"},{"page":"Fine Art","link":"/fine-art"},{"page":"Publications","link":"/publications"},{"page":"Journal","link":"/journal"},{"page":"About","link":"/about"},{"page":"Contact","link":"/contact"}]}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _router = __webpack_require__(322);

var _router2 = _interopRequireDefault(_router);

var _reactRedux = __webpack_require__(3);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var App = function (_PureComponent) {
  _inherits(App, _PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'render',
    value: function render() {
      if (this.props.hasErrored) {
        return _react2.default.createElement(_components.Error, null);
      }
      if (this.props.isLoading) {
        return _react2.default.createElement(_components.PageLoader, null);
      }
      return this.props.staticContent && _react2.default.createElement(_router2.default, { staticContent: this.props.staticContent });
    }
  }]);

  return App;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    staticContent: state.staticContent,
    hasErrored: state.staticContentHasErrored,
    isLoading: state.staticContentIsLoading
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(App);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(137);

var _reduxThunk = __webpack_require__(620);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reducers = __webpack_require__(317);

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var configureStore = function configureStore() {
  return (0, _redux.createStore)(_reducers2.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), (0, _redux.applyMiddleware)(_reduxThunk2.default));
};

exports.default = configureStore;

/***/ }),
/* 244 */,
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(409);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(237)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/sass-loader/lib/loader.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 246 */,
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BottomBorder = function BottomBorder() {
  return _react2.default.createElement(
    'div',
    { id: 'bottom-border', className: _style2.default.dynamic([['3685782656', [_theme.heights.header, _theme.widths.global_max_width, _theme.colors.black]]])
    },
    _react2.default.createElement('div', { id: 'border-inner', className: _style2.default.dynamic([['3685782656', [_theme.heights.header, _theme.widths.global_max_width, _theme.colors.black]]])
    }),
    _react2.default.createElement(_style2.default, {
      styleId: '3685782656',
      css: ['#bottom-border.__jsx-style-dynamic-selector{margin-top:' + _theme.heights.header + ';width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:absolute;bottom:0;left:0;}', '#border-inner.__jsx-style-dynamic-selector{width:100%;max-width:' + _theme.widths.global_max_width + ';border-bottom:1px solid ' + _theme.colors.black + ';}'],
      dynamic: [_theme.heights.header, _theme.widths.global_max_width, _theme.colors.black]
    })
  );
};

exports.default = BottomBorder;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _Headline = __webpack_require__(149);

var _Headline2 = _interopRequireDefault(_Headline);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error() {
  return _react2.default.createElement(
    _PageWrapper2.default,
    null,
    _react2.default.createElement(
      'section',
      { id: 'error-content', className: 'jsx-379817861'
      },
      _react2.default.createElement(
        _Headline2.default,
        { color: 'black' },
        'Error! Data Not Found.'
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '379817861',
      css: ['#error-content.jsx-379817861{width:100%;height:100vh;top:0;left:0;position:fixed;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}']
    })
  );
};

exports.default = Error;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorRedirect = function ErrorRedirect() {
  return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/404' } });
};

exports.default = ErrorRedirect;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _HeaderLayout = __webpack_require__(266);

var _HeaderLayout2 = _interopRequireDefault(_HeaderLayout);

var _FooterLayout = __webpack_require__(151);

var _FooterLayout2 = _interopRequireDefault(_FooterLayout);

var _HelmetWrap = __webpack_require__(82);

var _HelmetWrap2 = _interopRequireDefault(_HelmetWrap);

var _actions = __webpack_require__(10);

var _DATA = __webpack_require__(241);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Layout = function (_Component) {
  _inherits(Layout, _Component);

  function Layout() {
    _classCallCheck(this, Layout);

    return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  _createClass(Layout, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._routeData(this.props.routeData, this.props.matchData);
      this.props.setCatPage(this.props.routeData.pathname);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._routeData(nextProps.routeData, nextProps.matchData);
      this.props.setCatPage(nextProps.routeData.pathname);
    }
  }, {
    key: '_routeData',
    value: function _routeData(location, match) {
      this.props.setRouterData({
        location_data: location,
        match_data: match
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.props.staticContent && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(_HeaderLayout2.default, { location: this.props.routeData }),
          _react2.default.createElement(_HelmetWrap2.default, { pageMeta: _DATA.page_meta_defaults }),
          this.props.children,
          _react2.default.createElement(_FooterLayout2.default, { socialLinks: this.props.staticContent.homeData.data.social_links })
        )
      );
    }
  }]);

  return Layout;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    staticContent: state.staticContent
  };
}, function (dispatch) {
  return {
    setRouterData: function setRouterData(data) {
      return dispatch((0, _actions.setRouterState)(data));
    },
    setCatPage: function setCatPage(url) {
      return dispatch((0, _actions.setCatPage)(url));
    }
  };
})(Layout);

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _BwSignature = __webpack_require__(141);

var _BwSignature2 = _interopRequireDefault(_BwSignature);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageLoader = function PageLoader() {
  return _react2.default.createElement(
    _PageWrapper2.default,
    null,
    _react2.default.createElement(
      'section',
      { id: 'loader-content', className: 'jsx-3733782386'
      },
      _react2.default.createElement(
        'h1',
        {
          className: 'jsx-3733782386' + ' ' + 'loader-logo'
        },
        'Bruce Weber'
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '3733782386',
      css: ['@-webkit-keyframes pulse-jsx-3733782386{0%{opacity:0;}15%{opacity:.25;}50%{opacity:1;}90%{opacity:.25;}100%{opacity:0;}}', '@keyframes pulse-jsx-3733782386{0%{opacity:0;}15%{opacity:.25;}50%{opacity:1;}90%{opacity:.25;}100%{opacity:0;}}', '#loader-content.jsx-3733782386{height:100vh;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;position:fixed;top:0;left:0;padding-bottom:2vh;}', '.loader-logo.jsx-3733782386{-webkit-animation:pulse-jsx-3733782386 5000ms infinite linear;animation:pulse-jsx-3733782386 5000ms infinite linear;font-family:mallory,arial;font-weight:700;text-transform:uppercase;font-size:1.4rem;-webkit-letter-spacing:.15rem;-moz-letter-spacing:.15rem;-ms-letter-spacing:.15rem;letter-spacing:.15rem;}']
    })
  );
};

exports.default = PageLoader;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WysywgPage = function WysywgPage(props) {
  return _react2.default.createElement(
    _PageWrapper2.default,
    null,
    _react2.default.createElement(
      'section',
      { id: 'wysywg-page', className: _style2.default.dynamic([['1722443995', [_theme.heights.header, _theme.widths.global_max_width, _theme.fonts.big_headline]]])
      },
      _react2.default.createElement(
        'h1',
        {
          className: _style2.default.dynamic([['1722443995', [_theme.heights.header, _theme.widths.global_max_width, _theme.fonts.big_headline]]])
        },
        props.data.title
      ),
      _react2.default.createElement('article', { dangerouslySetInnerHTML: { __html: props.data.content }, className: _style2.default.dynamic([['1722443995', [_theme.heights.header, _theme.widths.global_max_width, _theme.fonts.big_headline]]]) + ' ' + 'formatted-markup'
      })
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '1722443995',
      css: ['#wysywg-page.__jsx-style-dynamic-selector{margin-top:' + _theme.heights.header + ';max-width:' + _theme.widths.global_max_width + ';text-align:center;padding:5rem 2.5rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}', 'h1.__jsx-style-dynamic-selector{margin-bottom:3rem;display:block;width:100%;text-align:center;font-size:' + _theme.fonts.big_headline + ';}', 'article.__jsx-style-dynamic-selector{max-width:70rem;margin:0 auto;text-align:left;}'],
      dynamic: [_theme.heights.header, _theme.widths.global_max_width, _theme.fonts.big_headline]
    })
  );
};

exports.default = WysywgPage;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownContent = function (_Component) {
  _inherits(DropdownContent, _Component);

  function DropdownContent(props) {
    _classCallCheck(this, DropdownContent);

    var _this = _possibleConstructorReturn(this, (DropdownContent.__proto__ || Object.getPrototypeOf(DropdownContent)).call(this, props));

    _this.state = { isOpen: false };
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(DropdownContent, [{
    key: 'handleClick',
    value: function handleClick() {
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.state.isOpen ? 'dropdown-content open' : 'dropdown-content closed' },
        _react2.default.createElement(
          'a',
          { onClick: this.handleClick, className: 'header' },
          this.props.header
        ),
        _react2.default.createElement('div', { className: 'body', dangerouslySetInnerHTML: { __html: this.props.body } })
      );
    }
  }]);

  return DropdownContent;
}(_react.Component);

exports.default = DropdownContent;
;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Video = function (_Component) {
  _inherits(Video, _Component);

  function Video(props) {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));
  }

  _createClass(Video, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'jsx-1499563426' + ' ' + 'video-container'
        },
        _react2.default.createElement('video', { ref: 'vid', src: this.props.source, autoPlay: true, muted: true, loop: true, className: 'jsx-1499563426'
        }),
        _react2.default.createElement(_style2.default, {
          styleId: '1499563426',
          css: ['.video-container.jsx-1499563426{position:absolute;top:-50%;left:-50%;width:200%;height:200%;}', '.video-container.jsx-1499563426>video.jsx-1499563426{position:absolute;top:0;bottom:0;right:0;left:0;margin:auto;min-height:50%;min-width:50%;}']
        })
      );
    }
  }]);

  return Video;
}(_react.Component);

exports.default = Video;
;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

var _reactScroll = __webpack_require__(132);

var Scroll = _interopRequireWildcard(_reactScroll);

var _scripts = __webpack_require__(5);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryNavDesk = function (_Component) {
  _inherits(CategoryNavDesk, _Component);

  function CategoryNavDesk() {
    _classCallCheck(this, CategoryNavDesk);

    return _possibleConstructorReturn(this, (CategoryNavDesk.__proto__ || Object.getPrototypeOf(CategoryNavDesk)).apply(this, arguments));
  }

  _createClass(CategoryNavDesk, [{
    key: '_changeCategory',
    value: function _changeCategory(category) {
      var _this2 = this;

      this.props.categorySelected(category);
      _reactScroll.animateScroll.scrollTo(this.props.windowHeight, {
        duration: 350
      });
      var scrollHandle = function scrollHandle() {
        setTimeout(function () {
          _this2.props.setDirectionDown();
        }, 10);
      };
      _reactScroll.Events.scrollEvent.register('end', function () {
        scrollHandle();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var navItems = (0, _scripts.dropFirstItem)(this.props.Navigation).map(function (item, i) {
        return _react2.default.createElement(
          'li',
          { key: i, className: 'category-menu-item-desktop' },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: _this3.props.Url + '/' + item.slug, className: _this3.props.currentCategory == item.slug ? 'category-button active' : 'category-button', onClick: function onClick() {
                return _this3._changeCategory(item.slug);
              } },
            _react2.default.createElement(
              'span',
              null,
              item.name
            )
          )
        );
      });
      return _react2.default.createElement(
        'menu',
        { className: 'category-menu-desktop' },
        _react2.default.createElement(
          'ul',
          { className: 'category-nav-wrapper-desktop' },
          this.props.Url == '/fine-art' ? _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '' + this.props.Url, className: 'category-button active fine-art-nav' },
            _react2.default.createElement(
              'span',
              null,
              'select exhibitions'
            )
          ) : _react2.default.createElement(
            _react.Fragment,
            null,
            _react2.default.createElement(
              'li',
              { className: 'category-menu-item-desktop' },
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '' + this.props.Url, className: this.props.currentCategory == 'everything' ? 'category-button active' : 'category-button', onClick: function onClick() {
                    return _this3._changeCategory('everything');
                  } },
                _react2.default.createElement(
                  'span',
                  null,
                  'Everything'
                )
              )
            ),
            navItems,
            this.props.Url == '/publications' && _react2.default.createElement(
              'li',
              { className: 'category-menu-item-desktop' },
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/publications/stockists', className: this.props.currentCategory == 'stocklists' ? 'category-button active' : 'category-button', onClick: function onClick() {
                    return _this3._changeCategory('stocklists');
                  } },
                _react2.default.createElement(
                  'span',
                  null,
                  'Stockists'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CategoryNavDesk;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    currentCategory: state.current_sub_category,
    currentCategorySlug: state.current_category_slug,
    windowHeight: state.window_dimensions.window_height
  };
}, function (dispatch) {
  return {
    categorySelected: function categorySelected(category) {
      return dispatch((0, _actions.categorySelectedTrigger)(category));
    },
    setDirectionDown: function setDirectionDown() {
      return dispatch((0, _actions.setDirectionDown)());
    }
  };
})(CategoryNavDesk);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

var _HeaderDropNav = __webpack_require__(143);

var _HeaderDropNav2 = _interopRequireDefault(_HeaderDropNav);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryNavMobile = function (_Component) {
  _inherits(CategoryNavMobile, _Component);

  function CategoryNavMobile(props) {
    _classCallCheck(this, CategoryNavMobile);

    var _this = _possibleConstructorReturn(this, (CategoryNavMobile.__proto__ || Object.getPrototypeOf(CategoryNavMobile)).call(this, props));

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  _createClass(CategoryNavMobile, [{
    key: '_dropClick',
    value: function _dropClick(e) {
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    }
  }, {
    key: '_changeCategory',
    value: function _changeCategory(category) {
      this.props.categorySelected(category);
      this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.categorySelected('everything');
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.categorySelected('everything');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var navItems = this.props.Navigation.map(function (item, i) {
        return _react2.default.createElement(
          'li',
          { key: i, className: 'category-menu-item-mobile' },
          _react2.default.createElement(
            _reactRouterDom.NavLink,
            { to: _this2.props.Url + '/' + item.slug, className: 'mobile-category-link', onClick: function onClick() {
                return _this2._changeCategory(item.slug);
              } },
            _react2.default.createElement(
              'span',
              null,
              item.name
            )
          )
        );
      });
      return _react2.default.createElement(
        'menu',
        { className: this.state.isOpen ? 'category-menu-mobile nav-drop' : 'category-menu-mobile' },
        this.props.Url == '/fine-art' ? _react2.default.createElement(
          'div',
          { className: 'nav-header' },
          _react2.default.createElement(
            'div',
            { className: 'mobile-category-link drop-down' },
            'Select Exhibitions'
          )
        ) : _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(_HeaderDropNav2.default, { currentPage: this.props.currentCategory, onClick: function onClick(e) {
              return _this2._dropClick(e);
            }, linkClass: 'mobile-category-link drop-down' }),
          _react2.default.createElement(
            'div',
            { className: 'cat-nav-dropdown' },
            _react2.default.createElement(
              'ul',
              { className: 'desk-menu' },
              navItems,
              this.props.Url == '/publications' && _react2.default.createElement(
                'li',
                { className: 'category-menu-item-mobile' },
                _react2.default.createElement(
                  _reactRouterDom.NavLink,
                  { to: '/publications/stockists', className: 'mobile-category-link', onClick: function onClick() {
                      return _this2._changeCategory('Stocklists');
                    } },
                  _react2.default.createElement(
                    'span',
                    null,
                    'Stockists'
                  )
                )
              )
            ),
            _react2.default.createElement('div', { className: 'cat-nav-bg-gradient' })
          )
        )
      );
    }
  }]);

  return CategoryNavMobile;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    currentCategory: state.current_sub_category,
    currentCategorySlug: state.current_category_slug
  };
}, function (dispatch) {
  return {
    categorySelected: function categorySelected(category) {
      return dispatch((0, _actions.categorySelectedTrigger)(category));
    }
  };
})(CategoryNavMobile);

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactPlayer = __webpack_require__(72);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _reactRedux = __webpack_require__(3);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilmHoverClip = function (_Component) {
  _inherits(FilmHoverClip, _Component);

  function FilmHoverClip(props) {
    _classCallCheck(this, FilmHoverClip);

    var _this = _possibleConstructorReturn(this, (FilmHoverClip.__proto__ || Object.getPrototypeOf(FilmHoverClip)).call(this, props));

    _this.state = {
      playing: false
    };
    return _this;
  }

  _createClass(FilmHoverClip, [{
    key: '_mouseOut',
    value: function _mouseOut() {
      this.setState({
        playing: false
      });
    }
  }, {
    key: '_mouseOver',
    value: function _mouseOver() {
      this.player.seekTo(0);
      this.setState({
        playing: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        !this.props.itemData.video_thumb || this.props.window_width < _theme.breakpoints.desktop ? _react2.default.createElement('div', { className: 'img-wrapper-film ' + (0, _scripts.returnCategories)(this.props.itemData.nav_categories), style: (0, _scripts.bgImage)(this.props.itemData.image.small) }) : _react2.default.createElement(
          'div',
          { className: 'film-thumb img-wrapper-film', onMouseOut: function onMouseOut() {
              return _this2._mouseOut();
            }, onMouseOver: function onMouseOver() {
              return _this2._mouseOver();
            } },
          _react2.default.createElement('div', { className: 'film-thumb__still', style: (0, _scripts.bgImage)(this.props.itemData.image.small) }),
          _react2.default.createElement(_reactPlayer2.default, {
            ref: function ref(node) {
              if (node) _this2.player = node.player;
            },
            url: this.props.itemData.video_thumb,
            className: 'film-thumb__player',
            width: '100%',
            height: '100%',
            muted: true,
            loop: true,
            playing: this.state.playing
          })
        )
      );
    }
  }]);

  return FilmHoverClip;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(FilmHoverClip);

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactMasonryComponent = __webpack_require__(219);

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _MasonryItemCaption = __webpack_require__(260);

var _MasonryItemCaption2 = _interopRequireDefault(_MasonryItemCaption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MasonryDesk = function (_Component) {
  _inherits(MasonryDesk, _Component);

  function MasonryDesk() {
    _classCallCheck(this, MasonryDesk);

    return _possibleConstructorReturn(this, (MasonryDesk.__proto__ || Object.getPrototypeOf(MasonryDesk)).apply(this, arguments));
  }

  _createClass(MasonryDesk, [{
    key: 'render',
    value: function render() {
      var masonryOptions = {
        transitionDuration: 0
      };
      return _react2.default.createElement(
        _reactMasonryComponent2.default,
        {
          ref: function (c) {
            this.masonry = this.masonry || c.masonry;
          }.bind(this),
          className: 'masonry-grid-wrapper masonry-grid-desktop loaded',
          elementType: 'ul',
          options: masonryOptions,
          disableImagesLoaded: false,
          updateOnEachImageLoad: true
        },
        this.props.GridItems.map(function (item, i) {
          return _react2.default.createElement(_MasonryItemCaption2.default, { itemData: item, isMobile: false, key: 'masonry-item-desk' + item.image.id + i });
        })
      );
    }
  }]);

  return MasonryDesk;
}(_react.Component);

;

exports.default = MasonryDesk;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _reactMasonryComponent = __webpack_require__(219);

var _reactMasonryComponent2 = _interopRequireDefault(_reactMasonryComponent);

var _reactRedux = __webpack_require__(3);

var _Image = __webpack_require__(29);

var _Image2 = _interopRequireDefault(_Image);

var _MasonryDesk = __webpack_require__(258);

var _MasonryDesk2 = _interopRequireDefault(_MasonryDesk);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MasonryGrid = function MasonryGrid(props) {
  var ImageGridMasonryMobile = props.GridItems.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { className: 'mg-li', key: 'masonry-item-mobile' + item.image.id + i },
      _react2.default.createElement(
        'div',
        { className: 'masonry-grid-item ' + (0, _scripts.returnCategories)(item.nav_categories) },
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/' + item.link.postType + '/' + item.link.slug, className: 'grid-item-link' },
          _react2.default.createElement(
            'div',
            { className: 'photo-landing-image-wrapper' },
            _react2.default.createElement(_Image2.default, { source: item.image.small })
          ),
          _react2.default.createElement(_SingleLineCaption2.default, {
            Headline: item.project_caption.headline,
            Description: item.project_caption.description,
            Stacked: false,
            Sep: true
          })
        )
      )
    );
  });
  return _react2.default.createElement(
    'section',
    { id: 'filter-grid' },
    props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(_MasonryDesk2.default, { GridItems: props.GridItems }) : _react2.default.createElement(
      'ul',
      { className: 'masonry-grid-wrapper masonry-grid-mobile' },
      ImageGridMasonryMobile
    )
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(MasonryGrid);

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _reactRedux = __webpack_require__(3);

var _scripts = __webpack_require__(5);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MasonryItemCaption = function (_Component) {
  _inherits(MasonryItemCaption, _Component);

  function MasonryItemCaption(props) {
    _classCallCheck(this, MasonryItemCaption);

    var _this = _possibleConstructorReturn(this, (MasonryItemCaption.__proto__ || Object.getPrototypeOf(MasonryItemCaption)).call(this, props));

    _this.state = {
      itemStyle: {
        opacity: 0
      },
      gradAlpha: {
        opacity: (0, _scripts.returnOpacity)(_this.props.itemData.project_caption.gradient_opacity)
      }
    };
    return _this;
  }

  _createClass(MasonryItemCaption, [{
    key: 'handleImageLoaded',
    value: function handleImageLoaded() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          itemStyle: {
            opacity: 1
          }
        });
      }, 250);
    }
  }, {
    key: 'render',
    value: function render() {
      var Caption = function Caption(props) {
        return _react2.default.createElement(
          'div',
          {
            className: _style2.default.dynamic([['1656172481', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'mg__caption'
          },
          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.captionData.headline }, className: _style2.default.dynamic([['1656172481', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'primary'
          }),
          props.captionData.description && _react2.default.createElement(
            'span',
            {
              className: _style2.default.dynamic([['1656172481', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'separator'
            },
            '/'
          ),
          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: props.captionData.description }, className: _style2.default.dynamic([['1656172481', [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]]]) + ' ' + 'secondary'
          }),
          _react2.default.createElement(_style2.default, {
            styleId: '1656172481',
            css: ['.mg__caption.__jsx-style-dynamic-selector{width:100%;padding-left:1em;padding-bottom:1em;position:absolute;bottom:0;left:0;z-index:1;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}', '.separator.__jsx-style-dynamic-selector,.primary.__jsx-style-dynamic-selector,.sep.__jsx-style-dynamic-selector,.secondary.__jsx-style-dynamic-selector{color:#fff;font-size:' + _theme.fonts.tiny + ';-webkit-letter-spacing:' + _theme.fonts.caption_spacing + ';-moz-letter-spacing:' + _theme.fonts.caption_spacing + ';-ms-letter-spacing:' + _theme.fonts.caption_spacing + ';letter-spacing:' + _theme.fonts.caption_spacing + ';font-family:' + _theme.fonts.mallory + ';text-transform:uppercase;margin:0;}', '.primary.__jsx-style-dynamic-selector,.sep.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';padding-right:.15rem;font-weight:bold;}', '.secondary.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';font-weight:normal;}'],
            dynamic: [_theme.fonts.tiny, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.mallory, _theme.fonts.mallory]
          })
        );
      };

      return _react2.default.createElement(
        'li',
        { className: 'mg-li' },
        _react2.default.createElement(
          'div',
          { className: 'mg-item ' + (0, _scripts.returnCategories)(this.props.itemData.nav_categories), style: this.state.itemStyle },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/' + this.props.itemData.link.postType + '/' + this.props.itemData.link.slug, className: 'mg-item__link' },
            _react2.default.createElement(
              'div',
              { className: 'mg__caption-wrapper' },
              _react2.default.createElement(Caption, { captionData: this.props.itemData.project_caption })
            ),
            _react2.default.createElement('div', { className: 'bg-gradient', style: this.state.gradAlpha }),
            _react2.default.createElement('img', { className: 'mg--image', src: this.props.itemData.image.small, onLoad: this.handleImageLoaded.bind(this) })
          )
        )
      );
    }
  }]);

  return MasonryItemCaption;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(MasonryItemCaption);

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Image = __webpack_require__(29);

var _Image2 = _interopRequireDefault(_Image);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _Stocklist = __webpack_require__(262);

var _Stocklist2 = _interopRequireDefault(_Stocklist);

var _scripts = __webpack_require__(5);

var _reactRouterDom = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicationsGrid = function PublicationsGrid(props) {
  var ImageGrid = props.GridItems.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { className: 'publications-grid-li', key: 'publications-grid-' + item.image.id },
      _react2.default.createElement(
        'div',
        { className: 'img-grid-item ' + (0, _scripts.returnCategories)(item.nav_categories) },
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/' + item.link.postType + '/' + item.link.slug, className: 'grid-item-link' },
          _react2.default.createElement(_Image2.default, { source: item.image.small }),
          _react2.default.createElement(_SingleLineCaption2.default, { Headline: item.project_caption.headline, Description: item.project_caption.description, Sep: true })
        )
      )
    );
  });
  return _react2.default.createElement(
    'section',
    { id: 'filter-grid' },
    props.Locations != '/publications/stockists' ? _react2.default.createElement(
      'ul',
      { className: 'publications-grid-wrapper' },
      ImageGrid
    ) : _react2.default.createElement(_Stocklist2.default, { data: props.StocklistData })
  );
};

exports.default = PublicationsGrid;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubItems = function SubItems(props) {
  var stockItems = props.SubItemList.map(function (subitem, i) {
    return _react2.default.createElement(
      'li',
      { className: 'stocklist-entry', key: i },
      _react2.default.createElement(
        'h5',
        { className: 'stocklist-header' },
        subitem.name
      ),
      _react2.default.createElement('div', { className: 'details', dangerouslySetInnerHTML: { __html: subitem.details } }),
      subitem.link ? _react2.default.createElement(
        'a',
        { href: subitem.link, target: '_blank', className: 'stocklist-link link' },
        subitem.link_text
      ) : null
    );
  });
  return _react2.default.createElement(
    'ul',
    { className: 'stocklist-entries' },
    stockItems
  );
};

var Stocklist = function Stocklist(props) {
  var stockListSections = props.data.socklist_data.map(function (item, i) {
    return _react2.default.createElement(
      'div',
      { className: 'stocklist-section', key: 'stocklist-section' + i },
      _react2.default.createElement(
        'h2',
        { className: 'stocklist-headline' },
        item.title
      ),
      _react2.default.createElement(SubItems, { SubItemList: item.entries })
    );
  });

  return _react2.default.createElement(
    'div',
    { id: 'stocklist-content' },
    stockListSections
  );
};

exports.default = Stocklist;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactScroll = __webpack_require__(132);

var Scroll = _interopRequireWildcard(_reactScroll);

var _reactRouterDom = __webpack_require__(7);

var _theme = __webpack_require__(1);

var _SocialIcons = __webpack_require__(80);

var _SocialIcons2 = _interopRequireDefault(_SocialIcons);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollToTop = function scrollToTop() {
  _reactScroll.animateScroll.scrollToTop({
    duration: 350
  });
};

var DesktopFooter = function DesktopFooter(props) {
  return _react2.default.createElement(
    'div',
    {
      className: _style2.default.dynamic([['2051506236', [_theme.fonts.footer_size, _theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'inner-footer'
    },
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['2051506236', [_theme.fonts.footer_size, _theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-column footer-left'
      },
      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '&#169; Bruce Weber' }, className: _style2.default.dynamic([['2051506236', [_theme.fonts.footer_size, _theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'copyright external-link'
      }),
      _react2.default.createElement(
        _reactRouterDom.Link,
        { className: 'terms external-link', to: '/terms' },
        'Terms'
      )
    ),
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['2051506236', [_theme.fonts.footer_size, _theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-column footer-center'
      },
      _react2.default.createElement(_SocialIcons2.default, null)
    ),
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['2051506236', [_theme.fonts.footer_size, _theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-column footer-right'
      },
      _react2.default.createElement(
        _reactRouterDom.Link,
        { className: 'contact external-link', to: '/contact' },
        'Contact'
      ),
      _react2.default.createElement(
        'div',
        { onClick: scrollToTop, className: _style2.default.dynamic([['2051506236', [_theme.fonts.footer_size, _theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'top external-link btt'
        },
        'Back to Top'
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '2051506236',
      css: ['.btt.__jsx-style-dynamic-selector{cursor:pointer;}', '.inner-footer.__jsx-style-dynamic-selector{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;padding:1.5rem 0;}', '.footer-column.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}', '.footer-left.__jsx-style-dynamic-selector,.footer-right.__jsx-style-dynamic-selector{width:24rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}', '.footer-right.__jsx-style-dynamic-selector{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;}', '.copyright.__jsx-style-dynamic-selector{font-size:' + _theme.fonts.footer_size + ';font-family:' + _theme.fonts.mallory + ';font-weight:700;text-transform:uppercase;font-size:1.2rem;border:0;}', '.top.__jsx-style-dynamic-selector,.terms.__jsx-style-dynamic-selector{margin-left:3rem;color:' + _theme.colors.black + ';display:block;}', '.top.__jsx-style-dynamic-selector,.contact.__jsx-style-dynamic-selector{color:' + _theme.colors.black + ';border-bottom:1px solid ' + _theme.colors.black + ';}'],
      dynamic: [_theme.fonts.footer_size, _theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]
    })
  );
};

exports.default = DesktopFooter;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _reactScroll = __webpack_require__(132);

var Scroll = _interopRequireWildcard(_reactScroll);

var _theme = __webpack_require__(1);

var _SocialIcons = __webpack_require__(80);

var _SocialIcons2 = _interopRequireDefault(_SocialIcons);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollToTop = function scrollToTop() {
  _reactScroll.animateScroll.scrollToTop({
    duration: 350
  });
};

var MobileFooter = function MobileFooter(props) {
  return _react2.default.createElement(
    'div',
    {
      className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'inner-footer'
    },
    _react2.default.createElement(
      'ul',
      {
        className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-items'
      },
      _react2.default.createElement(
        'li',
        {
          className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-item'
        },
        _react2.default.createElement(_SocialIcons2.default, null)
      ),
      _react2.default.createElement(
        'li',
        {
          className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-item'
        },
        _react2.default.createElement(
          _reactRouterDom.Link,
          { className: 'contact external-link', to: '/contact' },
          'Contact'
        )
      ),
      _react2.default.createElement(
        'li',
        {
          className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-item'
        },
        _react2.default.createElement(
          _reactRouterDom.Link,
          { className: 'external-link', to: '/terms' },
          _react2.default.createElement(
            'span',
            {
              className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]])
            },
            'Terms'
          )
        )
      ),
      _react2.default.createElement(
        'li',
        {
          className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-item'
        },
        _react2.default.createElement(
          'div',
          { onClick: scrollToTop, className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'top external-link btt'
          },
          'Back to Top'
        )
      ),
      _react2.default.createElement(
        'li',
        {
          className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'footer-item'
        },
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: '&#169; Bruce Weber' }, className: _style2.default.dynamic([['3852141817', [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'copyright'
        })
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '3852141817',
      css: ['.inner-footer.__jsx-style-dynamic-selector{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;padding:3rem;}', '.footer-items.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;list-style:none;}', '.footer-item.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;margin-bottom:1.5rem;}', '.footer-item.__jsx-style-dynamic-selector:first-child{margin-bottom:3rem;}', '.footer-item.__jsx-style-dynamic-selector:last-child{margin-top:1.5rem;margin-bottom:0;}', '.copyright.__jsx-style-dynamic-selector{font-size:1.2rem;font-family:' + _theme.fonts.mallory + ';text-transform:uppercase;font-weight:700;}', '.top.__jsx-style-dynamic-selector,.terms.__jsx-style-dynamic-selector{color:' + _theme.colors.black + ';display:block;line-height:1.1;}', '.top.__jsx-style-dynamic-selector,.contact.__jsx-style-dynamic-selector{color:' + _theme.colors.black + ';border-bottom:1px solid ' + _theme.colors.black + ';}'],
      dynamic: [_theme.fonts.mallory, _theme.colors.black, _theme.colors.black, _theme.colors.black]
    })
  );
};

exports.default = MobileFooter;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size_int = 4;
var size_unit = 'rem';

var burger_styles = {
  size: size_int + size_unit, // Size of Hamburger
  middle: size_int / 2 + size_unit, // For middle line in hamburger - should be 1/2 of size.
  offset: size_int / 4 + size_unit, // Top and bottome offset.
  top: 1 + size_unit,
  right: 3 + size_unit,
  transition_time: '250ms',
  thickness: '2px',
  color: '#010101'
};

var Hamburger = function Hamburger(_ref) {
  var onClick = _ref.onClick,
      clickState = _ref.clickState;
  return _react2.default.createElement(
    'button',
    { onClick: onClick, className: _style2.default.dynamic([['3630533344', [burger_styles.size, burger_styles.size, burger_styles.top, burger_styles.right, burger_styles.middle, burger_styles.thickness, burger_styles.color, burger_styles.thickness, burger_styles.color, burger_styles.offset, burger_styles.offset, burger_styles.size, burger_styles.size, burger_styles.size, burger_styles.size, burger_styles.size]]]) + ' ' + ((clickState ? 'hamburger hamburger_htx active' : 'hamburger hamburger_htx') || '')
    },
    _react2.default.createElement(
      'span',
      {
        className: _style2.default.dynamic([['3630533344', [burger_styles.size, burger_styles.size, burger_styles.top, burger_styles.right, burger_styles.middle, burger_styles.thickness, burger_styles.color, burger_styles.thickness, burger_styles.color, burger_styles.offset, burger_styles.offset, burger_styles.size, burger_styles.size, burger_styles.size, burger_styles.size, burger_styles.size]]])
      },
      'Menu'
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '3630533344',
      css: ['.hamburger.__jsx-style-dynamic-selector{width:' + burger_styles.size + ';height:' + burger_styles.size + ';top:' + burger_styles.top + ';right:' + burger_styles.right + ';display:block;position:absolute;overflow:hidden;margin:0;padding:0;font-size:0;text-indent:-9999px;-webkit-appearance:none;-moz-appearance:none;appearance:none;box-shadow:none;border-radius:none;border:none;-webkit-transition:all 350ms ease;transition:all 350ms ease;background-color:rgba(0,0,0,0);cursor:pointer;z-index:12000;}', '.hamburger.__jsx-style-dynamic-selector:focus{outline:none;}', '.hamburger.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{-webkit-transition:all 350ms ease;transition:all 350ms ease;display:block;position:absolute;top:' + burger_styles.middle + ';left:0;right:0;height:' + burger_styles.thickness + ';background:' + burger_styles.color + ';}', '.hamburger.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::before,.hamburger.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::after{-webkit-transition:all 350ms ease;transition:all 350ms ease;position:absolute;display:block;left:0;width:100%;height:' + burger_styles.thickness + ';background-color:' + burger_styles.color + ';content:"";}', '.hamburger.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::before{top:' + burger_styles.offset + ';}', '.hamburger.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::after{bottom:' + burger_styles.offset + ';}', '.hamburger_htx.__jsx-style-dynamic-selector{background-color:rgba (255,255,255,0);}', '.hamburger_htx.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{-webkit-transition:background 0s ' + burger_styles.size + ';transition:background 0s ' + burger_styles.size + ';}', '.hamburger_htx.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::before,.hamburger_htx.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::after{-webkit-transition-duration:' + burger_styles.size + ';transition-duration:' + burger_styles.size + ';,' + burger_styles.size + ';-webkit-transition-delay:' + burger_styles.size + ';transition-delay:' + burger_styles.size + ';,0s;}', '.hamburger_htx.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::before{-webkit-transition-property:top,-webkit-transform;-webkit-transition-property:top,transform;transition-property:top,transform;}', '.hamburger_htx.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::after{-webkit-transition-property:bottom,-webkit-transform;-webkit-transition-property:bottom,transform;transition-property:bottom,transform;}', '.hamburger_htx.active.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{background:none;}', '.hamburger_htx.active.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::before{top:0;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);}', '.hamburger_htx.active.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::after{bottom:0;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);}', '.hamburger_htx.active.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::before,.hamburger_htx.active.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector::after{-webkit-transition-delay:0s,' + burger_styles.size + ';transition-delay:0s,' + burger_styles.size + ';}'],
      dynamic: [burger_styles.size, burger_styles.size, burger_styles.top, burger_styles.right, burger_styles.middle, burger_styles.thickness, burger_styles.color, burger_styles.thickness, burger_styles.color, burger_styles.offset, burger_styles.offset, burger_styles.size, burger_styles.size, burger_styles.size, burger_styles.size, burger_styles.size]
    })
  );
};

exports.default = Hamburger;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

var _HeaderNav = __webpack_require__(267);

var _HeaderNav2 = _interopRequireDefault(_HeaderNav);

var _CategoryNavWrapper = __webpack_require__(45);

var _CategoryNavWrapper2 = _interopRequireDefault(_CategoryNavWrapper);

var _theme = __webpack_require__(1);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderLayout = function (_Component) {
  _inherits(HeaderLayout, _Component);

  function HeaderLayout() {
    _classCallCheck(this, HeaderLayout);

    return _possibleConstructorReturn(this, (HeaderLayout.__proto__ || Object.getPrototypeOf(HeaderLayout)).apply(this, arguments));
  }

  _createClass(HeaderLayout, [{
    key: '_headerUpdate',
    value: function _headerUpdate(location) {
      this.props.updateHeaderNav(location);
      this.props.updateHeaderStyle(location);
      this._closeHandler = this._closeHandler.bind(this);
      this._openHandler = this._openHandler.bind(this);
    }
  }, {
    key: '_closeHandler',
    value: function _closeHandler() {
      this.props.setScrollDirection('scrolling-down');
      this.props.forceCollapseMenu();
    }
  }, {
    key: '_openHandler',
    value: function _openHandler() {
      this.props.setScrollDirection('scrolling-up');
      this.props.forceCollapseMenu();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._headerUpdate(nextProps.location.pathname);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      this._headerUpdate(this.props.location.pathname);
      (0, _scripts.scrollWatcher)(function () {
        return _this2._closeHandler();
      }, function () {
        return _this2._openHandler();
      }, 15 // DELAY - AMOUT OF SCROLL
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'header',
        {
          style: { zIndex: '1000' },
          className: this.props.isOpen ? this.props.headerStyle + ' nav-drop ' + this.props.scrollDirection + ' ' + this.props.belowHero + ' ' + this.props.video_header_state : this.props.headerStyle + ' ' + this.props.scrollDirection + ' ' + this.props.belowHero + ' ' + this.props.video_header_state },
        _react2.default.createElement(_HeaderNav2.default, null),
        this.props.cat_page && this.props.belowHero != null && this.props.window_width >= _theme.breakpoints.desktop && _react2.default.createElement(
          'div',
          { id: 'category-menu-wrapper-header' },
          _react2.default.createElement(_CategoryNavWrapper2.default, null)
        )
      );
    }
  }]);

  return HeaderLayout;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    headerStyle: state.header_style,
    scrollDirection: state.scroll_direction,
    belowHero: state.scroll_state.cat_menu_wrapper,
    isOpen: state.menu_state,
    cat_nav: state.category_nav,
    cat_page: state.category_nav_page,
    window_width: state.window_dimensions.window_width,
    video_header_state: state.video_state.header_style
  };
}, function (dispatch) {
  return {
    updateHeaderNav: function updateHeaderNav(location) {
      return dispatch((0, _actions.setHeaderNavLocation)(location));
    },
    updateHeaderStyle: function updateHeaderStyle(location) {
      return dispatch((0, _actions.setHeaderStyle)(location));
    },
    setScrollDirection: function setScrollDirection(direction) {
      return dispatch((0, _actions.setScrollDirection)(direction));
    },
    forceCollapseMenu: function forceCollapseMenu() {
      return dispatch((0, _actions.forceCollapseMenu)());
    }
  };
})(HeaderLayout);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactRouterDom = __webpack_require__(7);

var _DATA = __webpack_require__(241);

var _actions = __webpack_require__(10);

var _theme = __webpack_require__(1);

var _Hamburger = __webpack_require__(265);

var _Hamburger2 = _interopRequireDefault(_Hamburger);

var _SocialIcons = __webpack_require__(80);

var _SocialIcons2 = _interopRequireDefault(_SocialIcons);

var _HeaderDropNav = __webpack_require__(143);

var _HeaderDropNav2 = _interopRequireDefault(_HeaderDropNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderNav = function HeaderNav(props) {
  var navLinks = _DATA.primary_nav.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { className: 'menu-item', key: item.page + i },
      _react2.default.createElement(
        _reactRouterDom.NavLink,
        { to: item.link, className: 'top-nav-link', onClick: function onClick(e) {
            return props.menuDrop(e);
          } },
        _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: item.page } })
      )
    );
  });

  var MobileNavigation = function MobileNavigation() {
    return _react2.default.createElement(
      'nav',
      { className: props.isOpen ? 'mobile-nav active' : 'mobile-nav' },
      _react2.default.createElement(_Hamburger2.default, { clickState: props.isOpen, onClick: function onClick(e) {
          return props.menuDrop(e);
        } }),
      _react2.default.createElement(
        'div',
        { className: 'mobile-menu-wrapper' },
        _react2.default.createElement(
          'ul',
          { className: 'mobile-menu' },
          navLinks
        ),
        _react2.default.createElement(_SocialIcons2.default, null)
      )
    );
  };

  var DesktopNavigation = function DesktopNavigation() {
    return _react2.default.createElement(
      'nav',
      { className: 'desktop-nav' },
      _react2.default.createElement(_HeaderDropNav2.default, { currentPage: props.navLocation, onClick: function onClick(e) {
          return props.menuDrop(e);
        }, linkClass: 'top-nav-link' }),
      _react2.default.createElement(
        'div',
        { className: 'nav-dropdown' },
        _react2.default.createElement(
          'ul',
          { className: 'desk-menu' },
          navLinks
        )
      )
    );
  };

  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'inner-header' },
      _react2.default.createElement(
        'div',
        { id: 'logo' },
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/' },
          _react2.default.createElement(
            'span',
            null,
            _DATA.TITLE
          )
        )
      ),
      props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(DesktopNavigation, null) : _react2.default.createElement(MobileNavigation, null)
    ),
    props.window_width >= _theme.breakpoints.desktop && _react2.default.createElement('div', { className: 'header-bg-gradient' }),
    _react2.default.createElement('div', { className: 'header-bg' })
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    navLocation: state.nav_location,
    headerStyle: state.header_style,
    scrollDirection: state.scroll_direction,
    belowHero: state.scroll_state.cat_menu_wrapper,
    isOpen: state.menu_state,
    window_width: state.window_dimensions.window_width
  };
}, function (dispatch) {
  return {
    menuDrop: function menuDrop() {
      return dispatch((0, _actions.setMenuState)());
    }
  };
})(HeaderNav);

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroSliderCaption = function HeroSliderCaption(props) {
  return _react2.default.createElement(
    'div',
    {
      className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]]) + ' ' + 'caption-out'
    },
    props.caption.link.slug ? _react2.default.createElement(
      _reactRouterDom.Link,
      { to: props.caption.link.postType != 'page' ? '/' + props.caption.link.postType + '/' + props.caption.link.slug : '/' + props.caption.link.slug },
      _react2.default.createElement('div', {
        className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]]) + ' ' + 'big-link'
      })
    ) : null,
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]]) + ' ' + 'caption-wrapper'
      },
      _react2.default.createElement(
        'div',
        {
          className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]]) + ' ' + 'caption'
        },
        _react2.default.createElement(
          'div',
          {
            className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]]) + ' ' + 'caption-content'
          },
          _react2.default.createElement(
            'h4',
            {
              className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]])
            },
            props.caption.header
          ),
          _react2.default.createElement(
            'h5',
            {
              className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]])
            },
            props.caption.title
          ),
          props.caption.additional_info && _react2.default.createElement(
            'h5',
            {
              className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]])
            },
            props.caption.additional_info
          ),
          props.caption.link.slug && props.caption.link_type == 'Internal' && _react2.default.createElement(
            _reactRouterDom.Link,
            { to: props.caption.link.postType != 'page' ? '/' + props.caption.link.postType + '/' + props.caption.link.slug : '/' + props.caption.link.slug, className: 'slider-caption-link' },
            props.caption.link.postType == 'films' ? _react2.default.createElement(
              'span',
              {
                className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]])
              },
              'WATCH'
            ) : _react2.default.createElement(
              'span',
              {
                className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]])
              },
              'VIEW'
            )
          ),
          props.caption.link_type == 'External' && _react2.default.createElement(
            'a',
            { target: '_blank', href: props.caption.external_link, className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]]) + ' ' + 'slider-caption-link'
            },
            _react2.default.createElement(
              'span',
              {
                className: _style2.default.dynamic([['2433845623', [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]]])
              },
              props.caption.external_link_text
            )
          )
        )
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '2433845623',
      css: ['.big-link.__jsx-style-dynamic-selector{position:absolute;top:0;left:0;right:0;height:100vh;display:block;z-index:100;}', '@media only screen and (max-width:640px){.big-link.__jsx-style-dynamic-selector{display:block;}}', '.caption-wrapper.__jsx-style-dynamic-selector{position:absolute;bottom:8rem;right:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;width:100vw;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;padding-left:' + _theme.widths.double_pad + ';padding-right:' + _theme.widths.double_pad + ';}', '.caption.__jsx-style-dynamic-selector{color:#FFF;z-index:100;text-transform:uppercase;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:flex-start;-webkit-box-align:flex-start;-ms-flex-align:flex-start;align-items:flex-start;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;text-align:center;}', '.caption-content.__jsx-style-dynamic-selector{width:100%;}', 'h4.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';margin-bottom:.25rem;font-size:1.5rem;font-weight:700;-webkit-letter-spacing:' + _theme.fonts.caption_spacing + ';-moz-letter-spacing:' + _theme.fonts.caption_spacing + ';-ms-letter-spacing:' + _theme.fonts.caption_spacing + ';letter-spacing:' + _theme.fonts.caption_spacing + ';line-height:1.25;}', 'h5.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';font-size:1.5rem;font-weight:300;-webkit-letter-spacing:' + _theme.fonts.caption_spacing + ';-moz-letter-spacing:' + _theme.fonts.caption_spacing + ';-ms-letter-spacing:' + _theme.fonts.caption_spacing + ';letter-spacing:' + _theme.fonts.caption_spacing + ';line-height:1.25;}', '@media only screen and (min-width:640px){.caption.__jsx-style-dynamic-selector{text-align:left;}.caption-wrapper.__jsx-style-dynamic-selector{height:' + _theme.heights.slider_caption + ';bottom:0;}}'],
      dynamic: [_theme.widths.double_pad, _theme.widths.double_pad, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.fonts.mallory, _theme.fonts.caption_spacing, _theme.heights.slider_caption]
    })
  );
};

exports.default = HeroSliderCaption;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _custom = __webpack_require__(568);

var _custom2 = _interopRequireDefault(_custom);

var _reactWaypoint = __webpack_require__(75);

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _HeroSwiperSlide = __webpack_require__(152);

var _HeroSwiperSlide2 = _interopRequireDefault(_HeroSwiperSlide);

var _BgImage = __webpack_require__(35);

var _BgImage2 = _interopRequireDefault(_BgImage);

var _reactPlayer = __webpack_require__(72);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeroSwiper = function (_Component) {
  _inherits(HeroSwiper, _Component);

  function HeroSwiper(props) {
    _classCallCheck(this, HeroSwiper);

    var _this = _possibleConstructorReturn(this, (HeroSwiper.__proto__ || Object.getPrototypeOf(HeroSwiper)).call(this, props));

    _this.state = {
      playing: false
    };
    _this._wayPointEnter = _this._wayPointEnter.bind(_this);
    _this._wayPointLeft = _this._wayPointLeft.bind(_this);
    _this._slideChange = _this._slideChange.bind(_this);
    return _this;
  }

  _createClass(HeroSwiper, [{
    key: '_wayPointEnter',
    value: function _wayPointEnter() {
      this.swiper.autoplay.start();
    }
  }, {
    key: '_wayPointLeft',
    value: function _wayPointLeft() {
      this.swiper.autoplay.stop();
      this._stop();
    }
  }, {
    key: '_slideChange',
    value: function _slideChange() {
      var slideIndex = this.swiper.realIndex;
      var slideType = this.swiper.slides[slideIndex].dataset.slidetype;
      if (slideType === 'video-media-library' && this.player != undefined) {
        this._onPlay();
      } else {
        this._stop();
      }
    }
  }, {
    key: '_onPlay',
    value: function _onPlay() {
      this.player.seekTo(0);
      this.setState({
        playing: true
      });
    }
  }, {
    key: '_stop',
    value: function _stop() {
      var _this2 = this;

      if (this.state.playing) {
        setTimeout(function () {
          _this2.player.seekTo(0);
          _this2.setState({
            playing: false
          });
        }, 1750);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._slideChange();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var swiperParams = {
        on: {
          slideChange: function slideChange() {
            _this3._slideChange();
          }
        },
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: '.hero-swiper-pagination',
          type: 'bullets',
          dynamicBullets: false,
          clickable: true
        },
        navigation: {
          nextEl: null,
          prevEl: null
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 3500
      };

      var HeroSlides = this.props.slides.map(function (slide, i) {
        return _react2.default.createElement(
          'div',
          { className: 'hero-slide', key: i, 'data-slidetype': slide.media_type },
          _react2.default.createElement(
            _HeroSwiperSlide2.default,
            { slideData: slide },
            slide.media_type === 'video-media-library' && _react2.default.createElement(
              _react.Fragment,
              null,
              _this3.props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(_reactPlayer2.default, {
                ref: function ref(node) {
                  if (node) _this3.player = node.player;
                },
                url: slide.slideshow_video_media_library,
                className: 'hero-player',
                width: '100%',
                height: '100%',
                muted: true,
                loop: true,
                playing: _this3.state.playing
              }) : _react2.default.createElement(_BgImage2.default, { source: slide.slideshow_video_media_library_cover_image.small })
            )
          )
        );
      });

      return _react2.default.createElement(
        'div',
        { id: 'hero-slider', style: this.props.height ? { height: this.props.height } : { height: '100vh' }, className: 'jsx-3396181389'
        },
        _react2.default.createElement(
          _custom2.default,
          _extends({}, swiperParams, { ref: function ref(node) {
              if (node) _this3.swiper = node.swiper;
            } }),
          HeroSlides
        ),
        _react2.default.createElement(_reactWaypoint2.default, {
          onEnter: this._wayPointEnter,
          onLeave: this._wayPointLeft,
          topOffset: '50%'
        }),
        _react2.default.createElement(_style2.default, {
          styleId: '3396181389',
          css: ['#hero-slider.jsx-3396181389{width:100vw;position:absolute;top:0;left:0;}', '.hero-slide.jsx-3396181389{width:100%;height:100vh;}', '.hero-player{position:absolute;top:0;left:0;width:100%;height:100%;z-index:100;}', 'video{position:absolute;top:0;left:0;bottom:0;right:0;margin:auto;width:100%;height:100%;object-fit:cover;}', '.hero-swiper-pagination{position:absolute;bottom:3rem!important;width:auto!important;padding:0;list-style:none;text-align:right;left:auto!important;right:3rem;z-index:9000;height:1.2rem;}', '.swiper-pagination-bullet{border:1px solid #fff;background-color:rgba(255,255,255,0);width:8px;height:8px;margin:0 .5rem!important;opacity:1!important;}', '.swiper-pagination-bullet-active{background-color:rgba(255,255,255,1);}']
        })
      );
    }
  }]);

  return HeroSwiper;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    below_hero: state.scroll_state.cat_menu_wrapper,
    window_width: state.window_dimensions.window_width
  };
})(HeroSwiper);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Image = __webpack_require__(29);

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Awards = function Awards(props) {
  var AwardsItems = props.AwardsData.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { key: 'award-' + i, className: 'jsx-3361133167' + ' ' + 'awards-item'
      },
      _react2.default.createElement(
        'div',
        {
          className: 'jsx-3361133167' + ' ' + 'award-wrapper'
        },
        _react2.default.createElement(_Image2.default, { source: item.award_logo.large })
      ),
      _react2.default.createElement(_style2.default, {
        styleId: '3361133167',
        css: ['.awards-item.jsx-3361133167{margin-bottom:1rem;width:50%;}', '.awards-item.jsx-3361133167:nth-child(odd)>.award-wrapper.jsx-3361133167{padding-right:1rem;}', '.awards-item.jsx-3361133167:nth-child(even)>.award-wrapper.jsx-3361133167{padding-left:1rem;}']
      })
    );
  });
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-2386550246' + ' ' + 'awards-repeater'
    },
    _react2.default.createElement(
      'h3',
      {
        className: 'jsx-2386550246' + ' ' + 'small-header'
      },
      'Awards'
    ),
    _react2.default.createElement(
      'ul',
      {
        className: 'jsx-2386550246' + ' ' + 'awards'
      },
      AwardsItems
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '2386550246',
      css: ['.awards-repeater.jsx-2386550246{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}', '.awards.jsx-2386550246{margin-top:1rem;list-style:none;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}']
    })
  );
};

exports.default = Awards;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _scripts = __webpack_require__(5);

var _Press = __webpack_require__(145);

var _Press2 = _interopRequireDefault(_Press);

var _Awards = __webpack_require__(270);

var _Awards2 = _interopRequireDefault(_Awards);

var _ItunesButton = __webpack_require__(273);

var _ItunesButton2 = _interopRequireDefault(_ItunesButton);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilmProjectInfo = function FilmProjectInfo(props) {
  var Information = false;
  if (props.ProjectInfo.information_sections) {
    Information = props.ProjectInfo.information_sections.map(function (item, i) {
      return _react2.default.createElement(
        'div',
        { key: 'info-' + i, className: 'jsx-968715813' + ' ' + 'information-section'
        },
        _react2.default.createElement(
          'h3',
          {
            className: 'jsx-968715813' + ' ' + 'small-header'
          },
          item.title
        ),
        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: item.content }, className: 'jsx-968715813' + ' ' + 'film-detail-markup'
        }),
        _react2.default.createElement(_style2.default, {
          styleId: '968715813',
          css: ['.information-section.jsx-968715813{margin-bottom:5rem;}', '.information-section.jsx-968715813:last-child{margin-bottom:0;}']
        })
      );
    });
  };
  return _react2.default.createElement(
    'article',
    { id: 'film-info', className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]])
    },
    _react2.default.createElement(
      'div',
      {
        className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'row'
      },
      _react2.default.createElement(
        'div',
        {
          className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'content-left'
        },
        _react2.default.createElement(
          'div',
          {
            className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'content-left-wrapper'
          },
          _react2.default.createElement(
            'h3',
            {
              className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'small-header'
            },
            props.ProjectInfo.video_date
          ),
          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: props.ProjectInfo.content }, className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'film-top-item formatted-markup'
          }),
          props.ProjectInfo.press && props.window_width >= _theme.breakpoints.desktop && _react2.default.createElement(
            'div',
            {
              className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'film-top-item'
            },
            _react2.default.createElement(_Press2.default, { PressData: props.ProjectInfo.press })
          ),
          props.ProjectInfo.itunes_link && props.window_width >= _theme.breakpoints.desktop && _react2.default.createElement(_ItunesButton2.default, { ItunesLink: props.ProjectInfo.itunes_link })
        )
      ),
      Information && _react2.default.createElement(
        'div',
        {
          className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'content-right'
        },
        Information,
        props.ProjectInfo.press && props.window_width < _theme.breakpoints.desktop && _react2.default.createElement(
          'div',
          {
            className: _style2.default.dynamic([['1641993507', [_theme.widths.global_max_width]]]) + ' ' + 'film-top-item'
          },
          _react2.default.createElement(_Press2.default, { PressData: props.ProjectInfo.press })
        ),
        props.ProjectInfo.awards && _react2.default.createElement(_Awards2.default, { AwardsData: props.ProjectInfo.awards }),
        props.ProjectInfo.itunes_link && props.window_width < _theme.breakpoints.desktop && _react2.default.createElement(_ItunesButton2.default, { ItunesLink: props.ProjectInfo.itunes_link })
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '1641993507',
      css: ['#film-info.__jsx-style-dynamic-selector{width:100%;max-width:' + _theme.widths.global_max_width + ';margin-bottom:3rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}', '.row.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}', '.row.__jsx-style-dynamic-selector:first-child{margin-bottom:5rem;}', '.content-left.__jsx-style-dynamic-selector{width:100%;}', '.content-left-wrapper.__jsx-style-dynamic-selector{width:100%;margin-bottom:5rem;}', '.content-right.__jsx-style-dynamic-selector{width:100%;}', '.awards-mobile.__jsx-style-dynamic-selector{margin-top:3rem;}', '.film-top-item.__jsx-style-dynamic-selector{margin-bottom:5rem;}', '@media (min-width:640px){.content-left.__jsx-style-dynamic-selector{width:calc((100% / 3) * 2);padding-right:3rem;}.content-left-wrapper.__jsx-style-dynamic-selector{margin-bottom:0;}.content-right.__jsx-style-dynamic-selector{width:calc(100% / 3);}.row.__jsx-style-dynamic-selector{-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;}.row.__jsx-style-dynamic-selector:first-child{margin-bottom:5rem;}.content-left.__jsx-style-dynamic-selector{padding-right:3rem;}}'],
      dynamic: [_theme.widths.global_max_width]
    })
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(FilmProjectInfo);

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _Image = __webpack_require__(29);

var _Image2 = _interopRequireDefault(_Image);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GridItemMobile = function (_Component) {
  _inherits(GridItemMobile, _Component);

  function GridItemMobile(props) {
    _classCallCheck(this, GridItemMobile);

    var _this = _possibleConstructorReturn(this, (GridItemMobile.__proto__ || Object.getPrototypeOf(GridItemMobile)).call(this, props));

    _this.state = {
      clickCount: 0,
      showIcon: false
    };
    _this.clickCounter = _this.clickCounter.bind(_this);
    return _this;
  }

  _createClass(GridItemMobile, [{
    key: 'clickCounter',
    value: function clickCounter(id) {
      var t = this;
      if (this.state.clickCount == 0) {
        t.setState({
          clickCount: 1,
          showIcon: true
        });
      } else if (this.state.clickCount == 1) {
        t.setState({
          clickCount: 0,
          showIcon: false
        });
        this.props.clickFunction(id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { onClick: function onClick() {
            _this2.clickCounter(_this2.props.ImgData.urls.id);
          }, className: 'jsx-329460588' + ' ' + 'flexible-image-wrapper'
        },
        _react2.default.createElement(
          'div',
          {
            className: 'jsx-329460588' + ' ' + 'image-inner'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'jsx-329460588' + ' ' + ((this.state.showIcon ? 'enlarge active' : 'enlarge') || '')
            },
            _react2.default.createElement('div', { style: (0, _scripts.bgImage)('/static/icons/expand.svg'), className: 'jsx-329460588' + ' ' + 'expand-icon'
            })
          ),
          _react2.default.createElement(_Image2.default, { source: this.props.ImgData.urls.small })
        ),
        _react2.default.createElement(_SingleLineCaption2.default, { Headline: this.props.ImgData.metadata.title, Description: this.props.ImgData.metadata.caption, Stacked: true }),
        _react2.default.createElement(_style2.default, {
          styleId: '329460588',
          css: ['.enlarge.jsx-329460588{-webkit-transition:opacity 250ms ease;transition:opacity 250ms ease;position:absolute;top:0;left:0;height:100%;width:100%;padding:1.5rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:flex-end;-webkit-box-align:flex-end;-ms-flex-align:flex-end;align-items:flex-end;-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;opacity:0;}', '.enlarge.active.jsx-329460588{opacity:1;}', '.expand-icon.jsx-329460588{height:2rem;width:2rem;}']
        })
      );
    }
  }]);

  return GridItemMobile;
}(_react.Component);

exports.default = GridItemMobile;
;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _bgImage = __webpack_require__(84);

var _bgImage2 = _interopRequireDefault(_bgImage);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItunesButton = function ItunesButton(props) {
  return _react2.default.createElement(
    'div',
    {
      className: _style2.default.dynamic([['3369028841', [_theme.fonts.small, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'itunes-button'
    },
    _react2.default.createElement(
      'a',
      { href: props.ItunesLink, target: '_blank', className: _style2.default.dynamic([['3369028841', [_theme.fonts.small, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'itunes-link'
      },
      _react2.default.createElement('span', { style: (0, _bgImage2.default)('/static/icons/apple.png'), className: _style2.default.dynamic([['3369028841', [_theme.fonts.small, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'apple-icon'
      }),
      _react2.default.createElement(
        'span',
        {
          className: _style2.default.dynamic([['3369028841', [_theme.fonts.small, _theme.colors.black, _theme.colors.black]]]) + ' ' + 'itunes-text'
        },
        'View in iTunes'
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '3369028841',
      css: ['.itunes-button.__jsx-style-dynamic-selector{margin-bottom:5rem;}', '.itunes-link.__jsx-style-dynamic-selector{padding:1.15rem 2.518rem;font-size:' + _theme.fonts.small + ';color:' + _theme.colors.black + ';border:1px solid ' + _theme.colors.black + ';font-weight:700;display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}', '.itunes-text.__jsx-style-dynamic-selector{padding-top:.2rem;}', '.apple-icon.__jsx-style-dynamic-selector{width:1.2rem;height:1.4rem;background-size:contain;display:block;position:relative;margin-right:.4rem;}', '@media (max-width:640px){}', '@media (min-width:640px){.itunes-button.__jsx-style-dynamic-selector{margin-bottom:0;}}'],
      dynamic: [_theme.fonts.small, _theme.colors.black, _theme.colors.black]
    })
  );
};

exports.default = ItunesButton;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _PortfolioHeader = __webpack_require__(154);

var _PortfolioHeader2 = _interopRequireDefault(_PortfolioHeader);

var _FilmProjectTop = __webpack_require__(153);

var _FilmProjectTop2 = _interopRequireDefault(_FilmProjectTop);

var _FlexiblePortfolioLayout = __webpack_require__(50);

var _FlexiblePortfolioLayout2 = _interopRequireDefault(_FlexiblePortfolioLayout);

var _SocialShare = __webpack_require__(81);

var _SocialShare2 = _interopRequireDefault(_SocialShare);

var _HelmetWrap = __webpack_require__(82);

var _HelmetWrap2 = _interopRequireDefault(_HelmetWrap);

var _RelatedPosts = __webpack_require__(79);

var _RelatedPosts2 = _interopRequireDefault(_RelatedPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PhotoFilmProjectDetail = function (_PureComponent) {
  _inherits(PhotoFilmProjectDetail, _PureComponent);

  function PhotoFilmProjectDetail() {
    _classCallCheck(this, PhotoFilmProjectDetail);

    return _possibleConstructorReturn(this, (PhotoFilmProjectDetail.__proto__ || Object.getPrototypeOf(PhotoFilmProjectDetail)).apply(this, arguments));
  }

  _createClass(PhotoFilmProjectDetail, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _PageWrapper2.default,
        { pageId: 'photo-film-project' },
        this.props.layout == 'portfolio' ? _react2.default.createElement(_PortfolioHeader2.default, { HeaderData: {
            headline: this.props.data.headline,
            description: this.props.data.description
          } }) : _react2.default.createElement(_FilmProjectTop2.default, { FilmData: this.props.data }),
        this.props.data.portfolio_layout.length != 0 && _react2.default.createElement(_FlexiblePortfolioLayout2.default, { LayoutItems: this.props.data.portfolio_layout }),
        _react2.default.createElement(_HelmetWrap2.default, { pageMeta: this.props.data.page_meta }),
        _react2.default.createElement(_SocialShare2.default, { Meta: this.props.data.page_meta }),
        _react2.default.createElement(_RelatedPosts2.default, { Posts: this.props.data.related_posts.posts })
      );
    }
  }]);

  return PhotoFilmProjectDetail;
}(_react.PureComponent);

exports.default = PhotoFilmProjectDetail;
;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var modalId = document.getElementById('slideshow-modal');

var PopoverModal = function (_React$Component) {
  _inherits(PopoverModal, _React$Component);

  function PopoverModal(props) {
    _classCallCheck(this, PopoverModal);

    var _this = _possibleConstructorReturn(this, (PopoverModal.__proto__ || Object.getPrototypeOf(PopoverModal)).call(this, props));

    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(PopoverModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      modalId.appendChild(this.el);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      modalId.removeChild(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      return _reactDom2.default.createPortal(this.props.children, this.el);
    }
  }]);

  return PopoverModal;
}(_react2.default.Component);

exports.default = PopoverModal;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _reactIdSwiper = __webpack_require__(216);

var _reactIdSwiper2 = _interopRequireDefault(_reactIdSwiper);

var _BgImage = __webpack_require__(35);

var _BgImage2 = _interopRequireDefault(_BgImage);

var _theme = __webpack_require__(1);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverSwiper = function (_Component) {
  _inherits(PopoverSwiper, _Component);

  function PopoverSwiper(props) {
    _classCallCheck(this, PopoverSwiper);

    var _this = _possibleConstructorReturn(this, (PopoverSwiper.__proto__ || Object.getPrototypeOf(PopoverSwiper)).call(this, props));

    _this.state = {
      revealSlider: false,
      startPosition: (0, _scripts.arrayPosition)(_this.props.PortfolioImages, _this.props.currentImage),
      currentSlide: (0, _scripts.arrayPosition)(_this.props.PortfolioImages, _this.props.currentImage),
      navOpen: false,
      portfolioImageCount: 0
    };
    _this.keydown = _this._handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(PopoverSwiper, [{
    key: '_slideNav',
    value: function _slideNav(id) {
      this.swiper.slideTo(id);
    }
  }, {
    key: '_slideChange',
    value: function _slideChange() {
      this.setState({ currentSlide: this.swiper.realIndex });
    }
  }, {
    key: '_mouseOut',
    value: function _mouseOut() {
      this.setState({
        navOpen: false
      });
    }
  }, {
    key: '_mouseOver',
    value: function _mouseOver() {
      this.setState({
        navOpen: true
      });
    }
  }, {
    key: '_handleKeyDown',
    value: function _handleKeyDown(event) {
      switch (event.keyCode) {
        case 38:
          this.setState({
            navOpen: true
          });
          break;
        case 40:
          this.setState({
            navOpen: false
          });
          break;
        default:
          break;
      };
    }
  }, {
    key: '_getThumbWidth',
    value: function _getThumbWidth() {
      var thumbCount = this.props.PortfolioImages.length;
      if (thumbCount < 10) {
        var thumbWidth = Math.round(100 / thumbCount * 100) / 100;
        return {
          thumb_width: {
            width: thumbWidth + 'vw'
          },
          overflow: {
            overflow: 'hidden'
          }
        };
      } else {
        return {
          thumb_width: {
            width: '10vw'
          },
          overflow: {
            overflowX: 'scroll',
            overflowY: 'hidden'
          }
        };
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          revealSlider: true
        });
        _this2.swiper.slideTo(_this2.state.startPosition);
      }, 250);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('keydown', this.keydown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.keydown);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var ImgBar = this.props.PortfolioImages.map(function (item, i) {
        return _react2.default.createElement(
          'li',
          { style: _this3._getThumbWidth().thumb_width, key: 'img-bar-thumb-' + item.urls.id + i, className: _style2.default.dynamic([['2945704329', [_theme.heights.slider_thumb_height, _theme.colors.black]]]) + ' ' + ((_this3.state.currentSlide == i ? 'image-bar-item active' : 'image-bar-item') || '')
          },
          _react2.default.createElement(
            'button',
            { onClick: function onClick() {
                return _this3._slideNav(i);
              }, className: _style2.default.dynamic([['2945704329', [_theme.heights.slider_thumb_height, _theme.colors.black]]]) + ' ' + 'slider-nav'
            },
            _react2.default.createElement('img', { src: item.urls.large, className: _style2.default.dynamic([['2945704329', [_theme.heights.slider_thumb_height, _theme.colors.black]]]) + ' ' + 'slider-nav-image'
            })
          ),
          _react2.default.createElement(_style2.default, {
            styleId: '2945704329',
            css: ['.image-bar-item.__jsx-style-dynamic-selector{height:' + _theme.heights.slider_thumb_height + ';-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;-webkit-box-flex:0;-webkit-flex-grow:0;-ms-flex-positive:0;flex-grow:0;position:relative;overflow:hidden;}', '.image-bar-item.active.__jsx-style-dynamic-selector>.slider-nav.__jsx-style-dynamic-selector{opacity:1!important;}', '.slider-nav.__jsx-style-dynamic-selector{-webkit-transition:opacity 250ms ease;transition:opacity 250ms ease;border:0;cursor:pointer;background-color:' + _theme.colors.black + ';opacity:0.25;height:100%;width:100%;position:absolute;overflow:hidden;border-right:2px solid black;}', '.slider-nav-image.__jsx-style-dynamic-selector{width:100%;height:100%;position:absolute;top:0;left:0;right:0;bottom:0;object-fit:cover;margin:auto;}', '.slider-nav.__jsx-style-dynamic-selector:hover{opacity:1;}', '.thumb-wrapper.__jsx-style-dynamic-selector{width:100%;}'],
            dynamic: [_theme.heights.slider_thumb_height, _theme.colors.black]
          })
        );
      });

      var GalleryItems = this.props.PortfolioImages.map(function (item, i) {
        return _react2.default.createElement(
          'div',
          { key: 'slider-img-' + item.urls.id + i, className: _style2.default.dynamic([['896543481', [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height]]]) + ' ' + 'slider-image'
          },
          _react2.default.createElement(
            'div',
            {
              className: _style2.default.dynamic([['896543481', [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height]]]) + ' ' + 'image-wrapper'
            },
            _react2.default.createElement(_BgImage2.default, { source: item.urls.large, bgSize: 'contain' })
          ),
          _react2.default.createElement(_style2.default, {
            styleId: '896543481',
            css: ['.slider-image.__jsx-style-dynamic-selector{height:100vh;}', '.image-wrapper.__jsx-style-dynamic-selector{width:100vw;height:100%;padding-top:0;padding-left:0;padding-right:0;padding-bottom:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}', '.caption-wrap.__jsx-style-dynamic-selector{padding-top:2rem;width:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;text-align:left;}', '@media (min-width:640px){.image-wrapper.__jsx-style-dynamic-selector{padding-top:0;padding-left:' + _theme.heights.slider_thumb_height + ';padding-right:' + _theme.heights.slider_thumb_height + ';padding-bottom:0;}.caption-wrap.__jsx-style-dynamic-selector{padding-top:2rem;margin:auto;}}'],
            dynamic: [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height]
          })
        );
      });

      var swiperParams = {
        on: {
          slideChange: function slideChange() {
            _this3._slideChange();
          }
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        },
        spaceBetween: 30,
        pagination: {
          type: 'bullets',
          dynamicBullets: false,
          clickable: true
        },
        keyboard: true
      };

      return _react2.default.createElement(
        'div',
        { id: 'portfolio-popover', className: _style2.default.dynamic([['245294538', [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height, _theme.heights.thumb_hl_height, _theme.heights.slider_thumb_height]]])
        },
        this.state.revealSlider && _react2.default.createElement(
          'div',
          { id: 'popover-slider', className: _style2.default.dynamic([['245294538', [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height, _theme.heights.thumb_hl_height, _theme.heights.slider_thumb_height]]]) + ' ' + ((this.state.navOpen ? 'nav-open pop-in' : 'pop-in') || '')
          },
          _react2.default.createElement(
            _reactIdSwiper2.default,
            _extends({}, swiperParams, { ref: function ref(node) {
                if (node) _this3.swiper = node.swiper;
              } }),
            GalleryItems
          )
        ),
        this.props.window_width >= _theme.breakpoints.desktop && _react2.default.createElement(
          'div',
          { id: 'slider-nav',
            onMouseOut: function onMouseOut() {
              return _this3._mouseOut();
            },
            onMouseOver: function onMouseOver() {
              return _this3._mouseOver();
            },
            style: this._getThumbWidth().overflow,
            className: _style2.default.dynamic([['245294538', [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height, _theme.heights.thumb_hl_height, _theme.heights.slider_thumb_height]]]) + ' ' + ((this.state.navOpen ? 'slider-nav-active' : '') || '')
          },
          _react2.default.createElement(
            'ul',
            { id: 'image-bar', className: _style2.default.dynamic([['245294538', [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height, _theme.heights.thumb_hl_height, _theme.heights.slider_thumb_height]]])
            },
            ImgBar
          )
        ),
        _react2.default.createElement(_style2.default, {
          styleId: '245294538',
          css: ['#popover-slider.__jsx-style-dynamic-selector{height:100vh;width:100vw;position:absolute;top:0;left:0;-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);-webkit-transition:-webkit-transform 350ms ease;-webkit-transition:transform 350ms ease;transition:transform 350ms ease;will-change:transition;}', '.nav-open.__jsx-style-dynamic-selector{-webkit-transform:translateY(-5rem)!important;-ms-transform:translateY(-5rem)!important;transform:translateY(-5rem)!important;}', '.swiper-next,.swiper-prev{display:none;position:absolute;height:3rem;width:3.5rem;cursor:pointer;background-size:contain;background-repeat:no-repeat;background-position:center;color:transparent;background-color:transparent;top:50%;border:none;outline:none;z-index:12000;opacity:.85;text-transform:uppercase;}', '.swiper-prev{left:1.5rem;background-image:url(\'/static/icons/arrow-left-white.svg\');}', '.swiper-next{right:1.5rem;background-image:url(\'/static/icons/arrow-right-white.svg\');}', '@media (min-width:640px){.swiper-next,.swiper-prev{display:block;}}', '#portfolio-popover.__jsx-style-dynamic-selector{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;position:absolute;z-index:10000;top:0;left:0;}', '#slider-nav.__jsx-style-dynamic-selector{height:' + _theme.heights.slider_thumb_height + ';position:absolute;bottom:0;left:0;width:100vw;cursor:pointer;border-right:2px solid black;border-left:2px solid black;}', '.slider-nav-active.__jsx-style-dynamic-selector>#image-bar.__jsx-style-dynamic-selector{-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}', '#image-bar.__jsx-style-dynamic-selector{background-color:black;-webkit-transition:-webkit-transform 350ms ease;-webkit-transition:transform 350ms ease;transition:transform 350ms ease;will-change:transition;-webkit-transform:translateY(calc(' + _theme.heights.slider_thumb_height + ' - ' + _theme.heights.thumb_hl_height + '));-ms-transform:translateY(calc(' + _theme.heights.slider_thumb_height + ' - ' + _theme.heights.thumb_hl_height + '));transform:translateY(calc(' + _theme.heights.slider_thumb_height + ' - ' + _theme.heights.thumb_hl_height + '));list-style:none;display:block;height:' + _theme.heights.slider_thumb_height + ';z-index:2;padding:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;position:relative;cursor:pointer;}'],
          dynamic: [_theme.heights.slider_thumb_height, _theme.heights.slider_thumb_height, _theme.heights.thumb_hl_height, _theme.heights.slider_thumb_height]
        })
      );
    }
  }]);

  return PopoverSwiper;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(PopoverSwiper);

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  return _react2.default.createElement(
    'button',
    { onClick: props.PlayFunction, className: _style2.default.dynamic([['26589999', [_theme.fonts.mallory, _theme.fonts.caption_size]]]) + ' ' + 'video__player-button'
    },
    _react2.default.createElement(
      'svg',
      { version: '1.1', viewBox: '0 0 64 64', width: '64', height: '64', className: _style2.default.dynamic([['26589999', [_theme.fonts.mallory, _theme.fonts.caption_size]]]) + ' ' + 'play-svg'
      },
      _react2.default.createElement(
        'g',
        {
          className: _style2.default.dynamic([['26589999', [_theme.fonts.mallory, _theme.fonts.caption_size]]]) + ' ' + 'play-wrapper'
        },
        _react2.default.createElement('path', { d: 'M13.593,3.195c-0.303-0.224-0.708-0.257-1.044-0.087C12.212,3.278,12,3.623,12,4v56 c0,0.377,0.212,0.722,0.549,0.893C12.691,60.964,12.846,61,13,61c0.21,0,0.418-0.066,0.593-0.195l38-28 C51.849,32.617,52,32.318,52,32s-0.151-0.617-0.407-0.805L13.593,3.195z', className: _style2.default.dynamic([['26589999', [_theme.fonts.mallory, _theme.fonts.caption_size]]]) + ' ' + 'play-path'
        })
      )
    ),
    props.CTA && _react2.default.createElement(
      'span',
      {
        className: _style2.default.dynamic([['26589999', [_theme.fonts.mallory, _theme.fonts.caption_size]]]) + ' ' + 'cta'
      },
      props.CTA
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '26589999',
      css: ['.video__player-button.__jsx-style-dynamic-selector{width:64px;height:50px;position:absolute;top:0;left:0;bottom:0;right:0;margin:auto;z-index:1000;-webkit-tap-highlight-color:rgba(255,255,255,0);border:0;background:rgba(255,255,255,0);border-radius:0, appearance:none;cursor:pointer;will-change:opacity;-webkit-transition:opacity 250ms ease;transition:opacity 250ms ease;opacity:1;}', '.cta.__jsx-style-dynamic-selector{font-family:' + _theme.fonts.mallory + ';font-size:' + _theme.fonts.caption_size + ';font-weight:700;color:#fff;-webkit-letter-spacing:.1rem;-moz-letter-spacing:.1rem;-ms-letter-spacing:.1rem;letter-spacing:.1rem;text-align:center;text-transform:uppercase;width:100%;padding-top:5px;}', '.video__player-button.__jsx-style-dynamic-selector:hover{opacity:.5;}', '.play-svg.__jsx-style-dynamic-selector{display:block;position:relative;margin:auto;width:100%;height:100%;}', '.nc-icon-wrapper.__jsx-style-dynamic-selector{fill:rgba(255,255,255,0.85);}', '.play-path.__jsx-style-dynamic-selector{fill:rgba(255,255,255,0.85);}'],
      dynamic: [_theme.fonts.mallory, _theme.fonts.caption_size]
    })
  );
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(245);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _App = __webpack_require__(242);

var _App2 = _interopRequireDefault(_App);

var _throttle = __webpack_require__(244);

var _throttle2 = _interopRequireDefault(_throttle);

var _mixin = __webpack_require__(138);

var _mixin2 = _interopRequireDefault(_mixin);

var _wrapperLodash = __webpack_require__(139);

var _wrapperLodash2 = _interopRequireDefault(_wrapperLodash);

var _actions = __webpack_require__(10);

var _theme = __webpack_require__(1);

var _reactRedux = __webpack_require__(3);

var _configureStore = __webpack_require__(243);

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _mixin2.default)(_wrapperLodash2.default, {
  throttle: _throttle2.default
});

// REDUX


var store = (0, _configureStore2.default)();
var API = "https://api.bruceweber.com/wp-json/bwapi/v1/";
store.dispatch((0, _actions.staticContentFetchData)(API + 'main'));

var resizeHandler = function resizeHandler() {
  store.dispatch((0, _actions.setResizeState)());
};
var scrollHandler = function scrollHandler() {
  store.dispatch((0, _actions.setScrollState)());
};
// INITIALIZE
resizeHandler();
scrollHandler();
// ADD EVENT LISTENERS
window.addEventListener('resize', _wrapperLodash2.default.throttle(resizeHandler, 75));

if (store.getState().window_dimensions.window_width >= _theme.breakpoints.desktop) {
  window.addEventListener('wheel', _wrapperLodash2.default.throttle(scrollHandler, 100));
} else {
  window.addEventListener('scroll', _wrapperLodash2.default.throttle(scrollHandler, 100));
}

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store },
  _react2.default.createElement(_App2.default, null)
), document.getElementById('root'));

console.log('BW2020');

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _Hero = __webpack_require__(46);

var _Hero2 = _interopRequireDefault(_Hero);

var _CategoryNavWrapper = __webpack_require__(45);

var _CategoryNavWrapper2 = _interopRequireDefault(_CategoryNavWrapper);

var _FilmArtGrid = __webpack_require__(150);

var _FilmArtGrid2 = _interopRequireDefault(_FilmArtGrid);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilmLanding = function (_Component) {
  _inherits(FilmLanding, _Component);

  function FilmLanding() {
    _classCallCheck(this, FilmLanding);

    return _possibleConstructorReturn(this, (FilmLanding.__proto__ || Object.getPrototypeOf(FilmLanding)).apply(this, arguments));
  }

  _createClass(FilmLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.setCatNav(this.props.staticContent.filmData.data.film_landing_category_navigation);
      this.props.categorySelected((0, _scripts.splitString)(this.props.route));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _PageWrapper2.default,
        { pageId: 'portfolio-landing' },
        _react2.default.createElement(_Hero2.default, { sliderContent: this.props.staticContent.filmData.data.hero_slider }),
        _react2.default.createElement(_CategoryNavWrapper2.default, null),
        _react2.default.createElement(_FilmArtGrid2.default, {
          GridItems: (0, _scripts.filterCategory)((0, _scripts.removeHidden)(this.props.staticContent.filmData.data.film_grid), this.props.category),
          Page: 'film'
        })
      );
    }
  }]);

  return FilmLanding;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    route: state.router.location_data.pathname,
    staticContent: state.staticContent,
    category: state.current_sub_category
  };
}, function (dispatch) {
  return {
    setCatNav: function setCatNav(navigation) {
      return dispatch((0, _actions.setCatNav)(navigation));
    },
    categorySelected: function categorySelected(category) {
      return dispatch((0, _actions.categorySelectedTrigger)(category));
    }
  };
})(FilmLanding);

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _Hero = __webpack_require__(46);

var _Hero2 = _interopRequireDefault(_Hero);

var _CategoryNavWrapper = __webpack_require__(45);

var _CategoryNavWrapper2 = _interopRequireDefault(_CategoryNavWrapper);

var _FilmArtGrid = __webpack_require__(150);

var _FilmArtGrid2 = _interopRequireDefault(_FilmArtGrid);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FineArtLanding = function (_Component) {
  _inherits(FineArtLanding, _Component);

  function FineArtLanding() {
    _classCallCheck(this, FineArtLanding);

    return _possibleConstructorReturn(this, (FineArtLanding.__proto__ || Object.getPrototypeOf(FineArtLanding)).apply(this, arguments));
  }

  _createClass(FineArtLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.setCatNav([]);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _PageWrapper2.default,
        { pageId: 'portfolio-landing' },
        _react2.default.createElement(_Hero2.default, { sliderContent: this.props.staticContent.fineArtData.data.hero_slider }),
        _react2.default.createElement(_CategoryNavWrapper2.default, null),
        _react2.default.createElement(_FilmArtGrid2.default, {
          GridItems: (0, _scripts.filterCategory)((0, _scripts.removeHidden)(this.props.staticContent.fineArtData.data.exhibition_grid), this.props.category),
          Page: 'fine-art'
        })
      );
    }
  }]);

  return FineArtLanding;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    staticContent: state.staticContent,
    route: state.router.location_data.pathname,
    category: state.current_sub_category
  };
}, function (dispatch) {
  return {
    setCatNav: function setCatNav(navigation) {
      return dispatch((0, _actions.setCatNav)(navigation));
    }
  };
})(FineArtLanding);

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'no-match' },
    _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(
        'h1',
        { className: 'medium-header hl-primary' },
        '404 Not Found.'
      ),
      _react2.default.createElement(
        'h2',
        { className: 'light-header hl-secondary' },
        'We\'re sorry this page doesn\'t exist.'
      ),
      _react2.default.createElement(
        _reactRouterDom.NavLink,
        { to: '/' },
        'Click here to return home.'
      )
    )
  );
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _Hero = __webpack_require__(46);

var _Hero2 = _interopRequireDefault(_Hero);

var _CategoryNavWrapper = __webpack_require__(45);

var _CategoryNavWrapper2 = _interopRequireDefault(_CategoryNavWrapper);

var _MasonryGrid = __webpack_require__(259);

var _MasonryGrid2 = _interopRequireDefault(_MasonryGrid);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PhotoLanding = function (_Component) {
  _inherits(PhotoLanding, _Component);

  function PhotoLanding() {
    _classCallCheck(this, PhotoLanding);

    return _possibleConstructorReturn(this, (PhotoLanding.__proto__ || Object.getPrototypeOf(PhotoLanding)).apply(this, arguments));
  }

  _createClass(PhotoLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.setCatNav(this.props.staticContent.photoData.data.photo_landing_category_navigation);
      this.props.categorySelected((0, _scripts.splitString)(this.props.route));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _PageWrapper2.default,
        { pageId: 'portfolio-landing' },
        _react2.default.createElement(_Hero2.default, { sliderContent: this.props.staticContent.photoData.data.hero_slider }),
        _react2.default.createElement(_CategoryNavWrapper2.default, null),
        _react2.default.createElement(_MasonryGrid2.default, { GridItems: (0, _scripts.filterCategory)((0, _scripts.removeHidden)(this.props.staticContent.photoData.data.photo_grid), this.props.category) })
      );
    }
  }]);

  return PhotoLanding;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    route: state.router.location_data.pathname,
    staticContent: state.staticContent,
    category: state.current_sub_category
  };
}, function (dispatch) {
  return {
    setCatNav: function setCatNav(navigation) {
      return dispatch((0, _actions.setCatNav)(navigation));
    },
    categorySelected: function categorySelected(category) {
      return dispatch((0, _actions.categorySelectedTrigger)(category));
    }
  };
})(PhotoLanding);

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _actions = __webpack_require__(10);

var _PageWrapper = __webpack_require__(21);

var _PageWrapper2 = _interopRequireDefault(_PageWrapper);

var _Hero = __webpack_require__(46);

var _Hero2 = _interopRequireDefault(_Hero);

var _CategoryNavWrapper = __webpack_require__(45);

var _CategoryNavWrapper2 = _interopRequireDefault(_CategoryNavWrapper);

var _PublicationsGrid = __webpack_require__(261);

var _PublicationsGrid2 = _interopRequireDefault(_PublicationsGrid);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PublicationsLanding = function (_Component) {
  _inherits(PublicationsLanding, _Component);

  function PublicationsLanding() {
    _classCallCheck(this, PublicationsLanding);

    return _possibleConstructorReturn(this, (PublicationsLanding.__proto__ || Object.getPrototypeOf(PublicationsLanding)).apply(this, arguments));
  }

  _createClass(PublicationsLanding, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.setCatNav(this.props.staticContent.publicationsData.data.publications_landing_category_navigation);
      this.props.categorySelected((0, _scripts.splitString)(this.props.route));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _PageWrapper2.default,
        { pageId: 'portfolio-landing' },
        _react2.default.createElement(_Hero2.default, { sliderContent: this.props.staticContent.publicationsData.data.hero_slider }),
        _react2.default.createElement(_CategoryNavWrapper2.default, null),
        _react2.default.createElement(_PublicationsGrid2.default, {
          GridItems: (0, _scripts.filterCategory)((0, _scripts.removeHidden)(this.props.staticContent.publicationsData.data.publications_grid), this.props.category),
          StocklistData: this.props.staticContent.stockListData.data,
          Locations: this.props.route
        })
      );
    }
  }]);

  return PublicationsLanding;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    route: state.router.location_data.pathname,
    staticContent: state.staticContent,
    category: state.current_sub_category
  };
}, function (dispatch) {
  return {
    setCatNav: function setCatNav(navigation) {
      return dispatch((0, _actions.setCatNav)(navigation));
    },
    categorySelected: function categorySelected(category) {
      return dispatch((0, _actions.categorySelectedTrigger)(category));
    }
  };
})(PublicationsLanding);

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _article_hero = __webpack_require__(295);

var _article_hero2 = _interopRequireDefault(_article_hero);

var _article_flex_layout = __webpack_require__(294);

var _article_flex_layout2 = _interopRequireDefault(_article_flex_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    _this.slug = "https://api.bruceweber.com/wp-json/bwapi/v1/" + 'article/?name=';
    return _this;
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._apiRequest('' + this.slug + this.props.match.params.pageSlug + '&type=' + this.props.postType);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._apiRequest('' + this.slug + nextProps.match.params.pageSlug + '&type=' + this.props.postType);
    }
  }, {
    key: '_apiRequest',
    value: function _apiRequest(url) {
      var _this2 = this;

      fetch(url).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      }).then(function (res) {
        _this2.setState({
          wpData: res.data,
          loading: false,
          error: false
        });
      }).catch(function () {
        _this2.setState({
          error: true,
          loading: false,
          wpData: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.loading ? _react2.default.createElement(_components.PageLoader, null) : this.state.error ? _react2.default.createElement(_components.ErrorRedirect, null) : _react2.default.createElement(ArticleContent, { data: this.state.wpData })
      );
    }
  }]);

  return _class;
}(_react.Component);

exports.default = _class;
;

var ArticleContent = function ArticleContent(props) {
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'blog-article' },
    !props.data.hide_hero && _react2.default.createElement(_article_hero2.default, { heroData: props.data }),
    _react2.default.createElement(_article_flex_layout2.default, { hideHero: props.data.hide_hero, flexData: props.data.flexible_layout, pageId: props.data.page_id })
  );
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _ExPubDetail = __webpack_require__(156);

var _ExPubDetail2 = _interopRequireDefault(_ExPubDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    _this.slug = "https://api.bruceweber.com/wp-json/bwapi/v1/" + 'exhibition/?name=';
    return _this;
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._apiRequest('' + this.slug + this.props.match.params.pageSlug);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._apiRequest('' + this.slug + nextProps.match.params.pageSlug);
    }
  }, {
    key: '_apiRequest',
    value: function _apiRequest(url) {
      var _this2 = this;

      fetch(url).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      }).then(function (res) {
        _this2.setState({
          wpData: res.data,
          loading: false,
          error: false
        });
      }).catch(function () {
        _this2.setState({
          error: true,
          loading: false,
          wpData: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.loading ? _react2.default.createElement(_components.PageLoader, null) : this.state.error ? _react2.default.createElement(_components.ErrorRedirect, null) : _react2.default.createElement(ExhibitionContent, { data: this.state.wpData })
      );
    }
  }]);

  return _class;
}(_react.Component);

exports.default = _class;
;

var ExhibitionContent = function ExhibitionContent(props) {
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'publication-detail' },
    _react2.default.createElement(
      _ExPubDetail2.default,
      { data: props.data },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'date' },
          props.data.exhibition_date
        ),
        _react2.default.createElement('div', { className: 'text', dangerouslySetInnerHTML: { __html: props.data.side_info } }),
        props.data.gallery_url && _react2.default.createElement(
          'p',
          { className: 'text gallery-url' },
          _react2.default.createElement(
            'a',
            { href: props.data.gallery_url },
            props.data.gallery_url
          )
        )
      )
    ),
    _react2.default.createElement(_components.SocialShare, { Meta: props.data.page_meta }),
    _react2.default.createElement(_components.RelatedPosts, { Posts: props.data.related_posts.posts })
  );
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _FilmProjectTop = __webpack_require__(153);

var _FilmProjectTop2 = _interopRequireDefault(_FilmProjectTop);

var _FlexiblePortfolioLayout = __webpack_require__(50);

var _FlexiblePortfolioLayout2 = _interopRequireDefault(_FlexiblePortfolioLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    _this.slug = "https://api.bruceweber.com/wp-json/bwapi/v1/" + 'film/?name=';
    return _this;
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._apiRequest('' + this.slug + this.props.match.params.pageSlug);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._apiRequest('' + this.slug + nextProps.match.params.pageSlug);
    }
  }, {
    key: '_apiRequest',
    value: function _apiRequest(url) {
      var _this2 = this;

      fetch(url).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      }).then(function (res) {
        _this2.setState({
          wpData: res.data,
          loading: false,
          error: false
        });
      }).catch(function () {
        _this2.setState({
          error: true,
          loading: false,
          wpData: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.loading ? _react2.default.createElement(_components.PageLoader, null) : this.state.error ? _react2.default.createElement(_components.ErrorRedirect, null) : _react2.default.createElement(FilmContent, { data: this.state.wpData })
      );
    }
  }]);

  return _class;
}(_react.Component);

exports.default = _class;
;

var FilmContent = function FilmContent(props) {
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'photo-film-project' },
    _react2.default.createElement(_FilmProjectTop2.default, { FilmData: props.data }),
    props.data.portfolio_layout.length !== 0 && _react2.default.createElement(_FlexiblePortfolioLayout2.default, { LayoutItems: props.data.portfolio_layout }),
    _react2.default.createElement(_components.SocialShare, { Meta: props.data.page_meta }),
    _react2.default.createElement(_components.RelatedPosts, { Posts: props.data.related_posts.posts })
  );
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _PortfolioHeader = __webpack_require__(154);

var _PortfolioHeader2 = _interopRequireDefault(_PortfolioHeader);

var _FlexiblePortfolioLayout = __webpack_require__(50);

var _FlexiblePortfolioLayout2 = _interopRequireDefault(_FlexiblePortfolioLayout);

var _SocialShare = __webpack_require__(81);

var _SocialShare2 = _interopRequireDefault(_SocialShare);

var _RelatedPosts = __webpack_require__(79);

var _RelatedPosts2 = _interopRequireDefault(_RelatedPosts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    _this.slug = "https://api.bruceweber.com/wp-json/bwapi/v1/" + 'portfolio/?name=';
    return _this;
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._apiRequest('' + this.slug + this.props.match.params.pageSlug);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._apiRequest('' + this.slug + nextProps.match.params.pageSlug);
    }
  }, {
    key: '_apiRequest',
    value: function _apiRequest(url) {
      var _this2 = this;

      fetch(url).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      }).then(function (res) {
        _this2.setState({
          wpData: res.data,
          loading: false,
          error: false
        });
      }).catch(function () {
        _this2.setState({
          error: true,
          loading: false,
          wpData: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.loading ? _react2.default.createElement(_components.PageLoader, null) : this.state.error ? _react2.default.createElement(_components.ErrorRedirect, null) : _react2.default.createElement(PortfolioContent, { data: this.state.wpData })
      );
    }
  }]);

  return _class;
}(_react.Component);

exports.default = _class;
;

var PortfolioContent = function PortfolioContent(props) {
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'photo-film-project' },
    _react2.default.createElement(_PortfolioHeader2.default, { HeaderData: {
        headline: props.data.headline,
        description: props.data.description
      } }),
    _react2.default.createElement(_FlexiblePortfolioLayout2.default, { LayoutItems: props.data.portfolio_layout }),
    _react2.default.createElement(_SocialShare2.default, { Meta: props.data.page_meta }),
    _react2.default.createElement(_RelatedPosts2.default, { Posts: props.data.related_posts.posts })
  );
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _ExPubDetail = __webpack_require__(156);

var _ExPubDetail2 = _interopRequireDefault(_ExPubDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    _this.slug = "https://api.bruceweber.com/wp-json/bwapi/v1/" + 'publication/?name=';
    return _this;
  }

  _createClass(_class, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._apiRequest('' + this.slug + this.props.match.params.pageSlug);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._apiRequest('' + this.slug + nextProps.match.params.pageSlug);
    }
  }, {
    key: '_apiRequest',
    value: function _apiRequest(url) {
      var _this2 = this;

      fetch(url).then(function (response) {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      }).then(function (res) {
        _this2.setState({
          wpData: res.data,
          loading: false,
          error: false
        });
      }).catch(function () {
        _this2.setState({
          error: true,
          loading: false,
          wpData: false
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.state.loading ? _react2.default.createElement(_components.PageLoader, null) : this.state.error ? _react2.default.createElement(_components.ErrorRedirect, null) : _react2.default.createElement(PublicationContent, { data: this.state.wpData })
      );
    }
  }]);

  return _class;
}(_react.Component);

exports.default = _class;
;

var PublicationContent = function PublicationContent(props) {
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'publication-detail' },
    _react2.default.createElement(
      _ExPubDetail2.default,
      { data: props.data },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('h2', { className: 'medium-header publication-subhead', dangerouslySetInnerHTML: { __html: props.data.description } }),
        _react2.default.createElement('div', { className: 'text', dangerouslySetInnerHTML: { __html: props.data.publisher_info } })
      )
    ),
    _react2.default.createElement(_components.SocialShare, { Meta: props.data.page_meta }),
    _react2.default.createElement(_components.RelatedPosts, { Posts: props.data.related_posts.posts })
  );
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _components = __webpack_require__(6);

var _reactWaypoint = __webpack_require__(75);

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var About = function (_PureComponent) {
  _inherits(About, _PureComponent);

  function About(props) {
    _classCallCheck(this, About);

    var _this = _possibleConstructorReturn(this, (About.__proto__ || Object.getPrototypeOf(About)).call(this, props));

    _this.onUpdate = function (val) {
      _this.setState({
        scrollDown: val
      });
    };

    _this.state = {
      scrollDown: null,
      imageStackStauts: 'fixed'
    };
    return _this;
  }

  _createClass(About, [{
    key: 'parkImageStack',
    value: function parkImageStack() {
      this.setState({
        imageStackStauts: 'parked'
      });
    }
  }, {
    key: 'fixImageStack',
    value: function fixImageStack() {
      this.setState({
        imageStackStauts: 'fixed'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _components.PageWrapper,
        { pageId: 'page-about' },
        _react2.default.createElement(_components.HelmetWrap, { pageMeta: this.props.data.page_meta }),
        _react2.default.createElement(
          'section',
          { className: 'main-content' },
          _react2.default.createElement('article', { className: 'copy-content formatted-markup', dangerouslySetInnerHTML: { __html: this.props.data.content } }),
          _react2.default.createElement(
            'div',
            { className: this.state.imageStackStauts + ' gallery-wrap' },
            _react2.default.createElement(_components.ImageStack, { imgs: this.props.data.gallery })
          )
        ),
        _react2.default.createElement(_reactWaypoint2.default, { onEnter: this.parkImageStack.bind(this, true), onLeave: this.fixImageStack.bind(this, true) }),
        _react2.default.createElement(
          'section',
          { className: 'dropdown-wrapper' },
          this.props.data.sections.map(function (item, i) {
            return _react2.default.createElement(_components.DropdownContent, { key: 'gen-section-' + i, header: item.section_title, body: '<div class="formatted-markup">' + item.section_content + '</div>' });
          })
        )
      );
    }
  }]);

  return About;
}(_react.PureComponent);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    scrollDirection: state.scroll_direction
  };
})(About);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Contact;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Contact(props) {
  var ContactItems = props.data.contact_items.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { className: 'contact-item', id: 'contact-item-' + i, key: 'contact-item-' + i },
      _react2.default.createElement(
        'div',
        { className: 'contact-item-title' },
        _react2.default.createElement(
          'span',
          { className: 'primary' },
          item.contact_label
        ),
        ' ',
        _react2.default.createElement(
          'span',
          { className: 'secondary' },
          item.contact_label_secondary
        )
      ),
      item.emails.map(function (subitem, i) {
        return _react2.default.createElement(
          'a',
          { className: 'contact-email', href: 'mailto:' + subitem.email, key: i },
          subitem.email
        );
      })
    );
  });
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'page-about' },
    _react2.default.createElement(_components.HelmetWrap, { pageMeta: props.data.page_meta }),
    _react2.default.createElement(
      'section',
      { className: 'contact-section' },
      _react2.default.createElement(
        'h3',
        null,
        props.data.contact_title
      ),
      _react2.default.createElement(
        'ul',
        { className: 'contact-list' },
        ContactItems
      )
    )
  );
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _BlogLandingGrid = __webpack_require__(292);

var _BlogLandingGrid2 = _interopRequireDefault(_BlogLandingGrid);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlogLanding = function BlogLanding(props) {
  return _react2.default.createElement(
    _components.PageWrapper,
    null,
    _react2.default.createElement(_BlogLandingGrid2.default, { blogLandingData: props.data })
  );
};

exports.default = BlogLanding;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BlogLink = __webpack_require__(293);

var _BlogLink2 = _interopRequireDefault(_BlogLink);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlogLandingGrid = function BlogLandingGrid(props) {
  var Articles = props.blogLandingData.map(function (item, i) {
    return _react2.default.createElement(_BlogLink2.default, { data: item, key: item.image.id + '-id-' + i });
  });
  return _react2.default.createElement(
    'section',
    { id: 'blog-landing', className: _style2.default.dynamic([['794205222', [_theme.heights.header, _theme.widths.global_max_width, _theme.widths.double_pad, _theme.widths.double_pad]]])
    },
    _react2.default.createElement(
      'ul',
      { id: 'blog-repeater', className: _style2.default.dynamic([['794205222', [_theme.heights.header, _theme.widths.global_max_width, _theme.widths.double_pad, _theme.widths.double_pad]]])
      },
      Articles
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '794205222',
      css: ['#blog-landing.__jsx-style-dynamic-selector{margin-top:' + _theme.heights.header + ';max-width:calc(' + _theme.widths.global_max_width + ' + (' + _theme.widths.double_pad + ' * 2));text-align:center;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;min-height:calc(100vh - 12rem);}', '#blog-repeater.__jsx-style-dynamic-selector{list-style:none;}'],
      dynamic: [_theme.heights.header, _theme.widths.global_max_width, _theme.widths.double_pad, _theme.widths.double_pad]
    })
  );
};

exports.default = BlogLandingGrid;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _components = __webpack_require__(6);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlogLink = function BlogLink(props) {

  return _react2.default.createElement(
    'li',
    { className: 'blog_landing_item ' + props.data.layout_style },
    _react2.default.createElement(
      _reactRouterDom.Link,
      { className: 'blog_landing_link', to: '/' + props.data.link.postType + '/' + props.data.link.slug },
      _react2.default.createElement(
        'div',
        { className: 'blog_image-wrapper' },
        _react2.default.createElement(_components.Image, { source: props.data.image.large })
      ),
      _react2.default.createElement(
        'div',
        { className: 'blog_landing_caption_wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'blog_landing_caption' },
          _react2.default.createElement(
            'h2',
            { className: 'blog_caption_title medium-header' },
            props.data.link.title
          ),
          _react2.default.createElement(
            'p',
            { className: 'blog_caption_date' },
            props.data.date
          )
        )
      )
    )
  );
};

exports.default = BlogLink;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _flex_item = __webpack_require__(297);

var _flex_item2 = _interopRequireDefault(_flex_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArticleFlexLayout = function (_Component) {
  _inherits(ArticleFlexLayout, _Component);

  function ArticleFlexLayout(props) {
    _classCallCheck(this, ArticleFlexLayout);

    return _possibleConstructorReturn(this, (ArticleFlexLayout.__proto__ || Object.getPrototypeOf(ArticleFlexLayout)).call(this, props));
  }

  _createClass(ArticleFlexLayout, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var FlexItems = this.props.flexData.map(function (item, i) {
        return _react2.default.createElement(_flex_item2.default, { Item: item, key: i + 'blog_post' + _this2.props.pageId });
      });
      return _react2.default.createElement(
        'section',
        { id: 'flexible-layout', className: this.props.hideHero ? 'hide-hero flex-layout-blog' : 'flex-layout-blog' },
        _react2.default.createElement(
          'div',
          { id: 'layout' },
          FlexItems
        )
      );
    }
  }]);

  return ArticleFlexLayout;
}(_react.Component);

;

exports.default = ArticleFlexLayout;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

var _theme = __webpack_require__(1);

var _ScrollPrompt = __webpack_require__(147);

var _ScrollPrompt2 = _interopRequireDefault(_ScrollPrompt);

var _theme2 = __webpack_require__(1);

var _scripts = __webpack_require__(5);

var _reactRedux = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleHero = function ArticleHero(props) {
  var gradientStyle = {
    opacity: (0, _scripts.returnOpacity)(props.heroData.gradient_opacity)
  };

  return _react2.default.createElement(
    'section',
    { id: 'article-hero' },
    props.heroData.headline_options !== 'no_headline' && _react2.default.createElement(
      'div',
      { className: 'article-title-wrapper ' + props.heroData.hero_fonts + ' ' + props.heroData.hero_text_size + ' ' + props.heroData.headline_options + ' ' + props.heroData.headline_align },
      _react2.default.createElement(
        'div',
        { className: props.heroData.drop_shadow ? 'article-title text-shadow' : 'article-title' },
        _react2.default.createElement(
          'h1',
          { className: 'blog-header' },
          props.heroData.headline
        ),
        props.heroData.hero_image_caption && _react2.default.createElement(
          'p',
          { className: 'hero-caption' },
          props.heroData.hero_image_caption
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'hero-image' },
      _react2.default.createElement(_components.BgImage, { source: props.heroData.hero_image.large }),
      _react2.default.createElement('div', { className: 'slide-gradient', style: gradientStyle })
    ),
    props.window_width >= _theme2.breakpoints.desktop && _react2.default.createElement(_ScrollPrompt2.default, null)
  );
};

// export default ArticleHero;
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(ArticleHero);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _components = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyWrapper = function CopyWrapper(props) {
  return _react2.default.createElement(
    'div',
    { className: 'formatted-markup copy ' + props.Copy.fonts + ' ' + props.Copy.text_size + ' ' + props.Style },
    props.Style == 'single_column_copy' ? _react2.default.createElement('div', { className: 'copy-wrapper', dangerouslySetInnerHTML: { __html: props.Copy.copy } }) : props.Style == 'full_column_copy' ? _react2.default.createElement('div', { className: 'copy-wrapper', dangerouslySetInnerHTML: { __html: props.Copy.copy } }) : props.Style == 'single_column_copy_with_image' ? _react2.default.createElement(
      'div',
      { className: 'copy-w-image-wrapper ' + props.Copy.image_placement },
      _react2.default.createElement('div', { className: 'copy-wrapper', dangerouslySetInnerHTML: { __html: props.Copy.copy } }),
      _react2.default.createElement(
        'div',
        { className: 'image-container' },
        _react2.default.createElement(_components.Image, { source: props.Copy.urls.small }),
        _react2.default.createElement(_components.SingleLineCaption, {
          Headline: props.Copy.metadata.title,
          Description: props.Copy.metadata.caption,
          Stacked: true
        })
      )
    ) : props.Style == 'two_column_text_with_blockquote' ? _react2.default.createElement(
      'div',
      { className: 'two-col-blockquote-wrapper' },
      _react2.default.createElement('div', { className: 'blockquote-wrapper', dangerouslySetInnerHTML: { __html: props.Copy.blockquote } }),
      _react2.default.createElement('div', { className: 'two-col-copy-wrapper', dangerouslySetInnerHTML: { __html: props.Copy.text_column } })
    ) : null
  );
};

exports.default = CopyWrapper;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactPlayer = __webpack_require__(72);

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _VideoPlayer = __webpack_require__(51);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

var _ImageStack = __webpack_require__(144);

var _ImageStack2 = _interopRequireDefault(_ImageStack);

var _copy_wrapper = __webpack_require__(296);

var _copy_wrapper2 = _interopRequireDefault(_copy_wrapper);

var _grid_item = __webpack_require__(298);

var _grid_item2 = _interopRequireDefault(_grid_item);

var _ExPubSwiper = __webpack_require__(157);

var _ExPubSwiper2 = _interopRequireDefault(_ExPubSwiper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlexItem = function FlexItem(props) {
  return _react2.default.createElement(
    'div',
    { className: props.Item.copy ? 'copy-row flexible-row' : props.Item.video ? 'video-row flexible-row' : props.Item.audio ? 'audio-row flexible-row' : props.Item.image_stack ? 'image-stack-row flexible-row' : props.Item.slideshow ? 'slideshow-row flexible-row' : 'flexible-row' },
    props.Item.two_column ? _react2.default.createElement(
      'div',
      { className: 'two_column flex-row-wrapper' },
      _react2.default.createElement(_grid_item2.default, { ImgData: props.Item.two_column[0], ImgSize: 'two_column' }),
      _react2.default.createElement(_grid_item2.default, { ImgData: props.Item.two_column[1], ImgSize: 'two_column' })
    ) : props.Item.image ? _react2.default.createElement(
      'div',
      { className: props.Item.image.position + ' flex-row-wrapper' },
      _react2.default.createElement(_grid_item2.default, { ImgData: props.Item, ImgSize: props.Item.image.position })
    ) : props.Item.copy ? _react2.default.createElement(_copy_wrapper2.default, { Style: props.Item.copy.style, Copy: props.Item.copy }) : props.Item.audio ? _react2.default.createElement(_reactPlayer2.default, {
      url: props.Item.audio.soundcloud_url,
      playing: false,
      config: {
        soundcloud: {
          options: {
            color: '#000000',
            sharing: false,
            show_artwork: false,
            show_user: false
          }
        }
      }
    }) : props.Item.video ? _react2.default.createElement(_VideoPlayer2.default, { videoId: props.Item.video.vimeo_id, videoUrl: 'https://vimeo.com/' + props.Item.video.vimeo_id, videoPoster: props.Item.video.video_img.large, cta: 'PLAY' }) : props.Item.slideshow ? _react2.default.createElement(_ExPubSwiper2.default, { Slides: props.Item.slideshow.slideshow_images }) : props.Item.image_stack ? _react2.default.createElement(
      'div',
      { className: 'flexible-image-stack copy' },
      _react2.default.createElement('div', { className: 'text-col', dangerouslySetInnerHTML: { __html: props.Item.image_stack.copy } }),
      _react2.default.createElement(_ImageStack2.default, { imgs: props.Item.image_stack.images })
    ) : null
  );
};

exports.default = FlexItem;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _components = __webpack_require__(6);

var _ProjectDetailCaption = __webpack_require__(146);

var _ProjectDetailCaption2 = _interopRequireDefault(_ProjectDetailCaption);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridItem = function GridItem(props) {
  return _react2.default.createElement(
    'div',
    { className: 'flexible-image-wrapper' },
    props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(_ProjectDetailCaption2.default, { ProjectName: props.ImgData.image.metadata.title, ImageDescription: props.ImgData.image.metadata.caption, ExpandIcon: false }),
      _react2.default.createElement(
        'div',
        { className: 'image-inner' },
        props.ImgSize == 'full_row' ? _react2.default.createElement(_components.Image, { source: props.ImgData.image.urls.large }) : props.ImgSize == 'full_bleed' ? _react2.default.createElement(_components.Image, { source: props.ImgData.image.urls.large }) : _react2.default.createElement(_components.Image, { source: props.ImgData.image.urls.small }),
        _react2.default.createElement(
          'div',
          { className: 'gradient-wrapper' },
          _react2.default.createElement('div', { className: 'bg-gradient' })
        )
      )
    ) : _react2.default.createElement(
      _react.Fragment,
      null,
      _react2.default.createElement(
        'div',
        { className: 'image-inner' },
        _react2.default.createElement(_components.Image, { source: props.ImgData.image.urls.small })
      ),
      _react2.default.createElement(_components.SingleLineCaption, { Headline: props.ImgData.image.metadata.title, Description: props.ImgData.image.metadata.caption, Stacked: true })
    )
  );
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    window_width: state.window_dimensions.window_width
  };
})(GridItem);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _components = __webpack_require__(6);

var _theme = __webpack_require__(1);

var _bgImage = __webpack_require__(84);

var _bgImage2 = _interopRequireDefault(_bgImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var big_space = '9.5rem';

var GalleryList = function GalleryList(props) {
  var Galleries = props.data.gallery_list.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { key: 'gallery-' + i, className: _style2.default.dynamic([['3343586342', [big_space, _theme.widths.single_pad]]]) + ' ' + 'gallery'
      },
      _react2.default.createElement(
        'h2',
        {
          className: _style2.default.dynamic([['3343586342', [big_space, _theme.widths.single_pad]]]) + ' ' + 'medium-header gallery-title'
        },
        item.gallery_name
      ),
      _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: item.gallery_address }, className: _style2.default.dynamic([['3343586342', [big_space, _theme.widths.single_pad]]])
      }),
      _react2.default.createElement(
        'p',
        {
          className: _style2.default.dynamic([['3343586342', [big_space, _theme.widths.single_pad]]])
        },
        item.gallery_phone
      ),
      _react2.default.createElement(
        'p',
        {
          className: _style2.default.dynamic([['3343586342', [big_space, _theme.widths.single_pad]]])
        },
        _react2.default.createElement(
          'a',
          { href: item.gallery_url, target: '_blank', className: _style2.default.dynamic([['3343586342', [big_space, _theme.widths.single_pad]]]) + ' ' + 'external-link-lg'
          },
          item.gallery_url
        )
      ),
      _react2.default.createElement(_style2.default, {
        styleId: '3343586342',
        css: ['.gallery.__jsx-style-dynamic-selector{margin-bottom:' + big_space + ';}', '.gallery-title.__jsx-style-dynamic-selector{margin-bottom:' + _theme.widths.single_pad + ';}', 'p.__jsx-style-dynamic-selector{line-height:1.5;font-size:1.4rem;}'],
        dynamic: [big_space, _theme.widths.single_pad]
      })
    );
  });
  var Contacts = props.data.inquiries_contacts.map(function (item, i) {
    return _react2.default.createElement(
      'li',
      { key: 'gallery-' + i, className: 'jsx-1219938245' + ' ' + 'contact-li'
      },
      _react2.default.createElement(
        'p',
        {
          className: 'jsx-1219938245'
        },
        item.name
      ),
      _react2.default.createElement(
        'p',
        {
          className: 'jsx-1219938245'
        },
        _react2.default.createElement(
          'a',
          { href: item.email, target: '_blank', className: 'jsx-1219938245' + ' ' + 'external-link-lg'
          },
          item.email
        )
      ),
      _react2.default.createElement(_style2.default, {
        styleId: '1219938245',
        css: ['p.jsx-1219938245{line-height:1.45;font-size:1.4rem;}']
      })
    );
  });
  return _react2.default.createElement(
    _components.PageWrapper,
    { pageId: 'gallery-list' },
    _react2.default.createElement(
      'section',
      { id: 'gallery-list', className: _style2.default.dynamic([['700115941', [_theme.heights.header, _theme.widths.global_max_width, big_space]]])
      },
      _react2.default.createElement(
        'ul',
        { id: 'galleries', className: _style2.default.dynamic([['700115941', [_theme.heights.header, _theme.widths.global_max_width, big_space]]])
        },
        Galleries
      ),
      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: props.data.additional_inquiries_message }, className: _style2.default.dynamic([['700115941', [_theme.heights.header, _theme.widths.global_max_width, big_space]]]) + ' ' + 'info'
      }),
      _react2.default.createElement(
        'ul',
        { id: 'contacts', className: _style2.default.dynamic([['700115941', [_theme.heights.header, _theme.widths.global_max_width, big_space]]])
        },
        Contacts
      ),
      _react2.default.createElement(
        'div',
        {
          className: _style2.default.dynamic([['700115941', [_theme.heights.header, _theme.widths.global_max_width, big_space]]]) + ' ' + 'back'
        },
        _react2.default.createElement(
          _reactRouterDom.Link,
          { className: 'bold-small-link', to: '/fine-art' },
          _react2.default.createElement('span', { style: (0, _bgImage2.default)('/static/icons/back-arrow.png'), className: _style2.default.dynamic([['700115941', [_theme.heights.header, _theme.widths.global_max_width, big_space]]]) + ' ' + 'back-arrow'
          }),
          _react2.default.createElement(
            'span',
            {
              className: _style2.default.dynamic([['700115941', [_theme.heights.header, _theme.widths.global_max_width, big_space]]])
            },
            'Back to Exhibitions'
          )
        )
      )
    ),
    _react2.default.createElement(_style2.default, {
      styleId: '700115941',
      css: ['#gallery-list.__jsx-style-dynamic-selector{margin-top:' + _theme.heights.header + ';max-width:' + _theme.widths.global_max_width + ';text-align:center;padding:5rem 2.5rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;min-height:calc(100vh - 12rem);}', '#galleries.__jsx-style-dynamic-selector,#contacts.__jsx-style-dynamic-selector{list-style:none;width:100%;}', '#contacts.__jsx-style-dynamic-selector{margin-bottom:' + big_space + ';}', '.info.__jsx-style-dynamic-selector{margin:0 auto .5rem;max-width:28rem;}', '@media (min-width:640px){.info.__jsx-style-dynamic-selector{margin:0 auto 1.25rem;max-width:100%;}}'],
      dynamic: [_theme.heights.header, _theme.widths.global_max_width, big_space]
    })
  );
};

exports.default = GalleryList;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ErrorBoundary = __webpack_require__(142);

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

var _scripts = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.toggleCaption = _this.toggleCaption.bind(_this);
    _this.truncatedString = null;
    _this.state = {
      description: _this.props.linkData.description,
      longCaption: false
    };
    _this.gradientOpacity = {
      opacity: (0, _scripts.returnOpacity)(_this.props.opacity)
    };
    return _this;
  }

  _createClass(Caption, [{
    key: 'toggleCaption',
    value: function toggleCaption() {
      this.setState({
        longCaption: true,
        description: this.state.description == this.truncatedString ? this.props.linkData.description : this.truncatedString
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var desc = this.props.linkData.description;
      // MORE OR LESS TRUNCATE
      var descLength = desc.length;
      if (descLength > 130) {
        this.truncatedString = (0, _scripts.truncateText)(desc) + '...';;
        (0, _scripts.truncateText)(desc);
        this.setState({
          longCaption: true,
          description: this.truncatedString
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          _ErrorBoundary2.default,
          null,
          _react2.default.createElement(
            'div',
            { className: 'hp-caption-text-wrap' },
            _react2.default.createElement(
              'h3',
              { className: 'hp-image-caption-primary' },
              _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.linkData.title } })
            ),
            _react2.default.createElement(
              'h4',
              { className: 'hp-image-caption-secondary' },
              _react2.default.createElement('span', { className: 'hp-image-caption-secondary-span', dangerouslySetInnerHTML: { __html: this.state.description } }),
              this.state.longCaption && _react2.default.createElement(
                'span',
                { onClick: function onClick() {
                    return _this2.toggleCaption();
                  }, className: 'long-caption-toggle' },
                this.state.description == this.truncatedString ? 'MORE' : 'LESS'
              )
            )
          )
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

exports.default = Caption;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _components = __webpack_require__(6);

var _DesktopGrid = __webpack_require__(158);

var _DesktopGrid2 = _interopRequireDefault(_DesktopGrid);

var _MobileGrid = __webpack_require__(159);

var _MobileGrid2 = _interopRequireDefault(_MobileGrid);

var _theme = __webpack_require__(1);

var _reactScrollToComponent = __webpack_require__(229);

var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);

var _reactWaypoint = __webpack_require__(75);

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home(props) {
    _classCallCheck(this, Home);

    var _this = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this._handleWaypointEnter = function (e) {
      if (_this.props.scrollDirection == 'scrolling-up' && _this.isDesktop) {
        (0, _reactScrollToComponent2.default)(_this.PageTopScrollpoint, { offset: 0, align: 'top', duration: 500, ease: 'linear' });
      }
    };

    _this._scrollHandler = function (e) {
      if (document.scrollingElement.scrollTop > 150 && _this.isDesktop) {
        (0, _reactScrollToComponent2.default)(_this.DesktopGridScrollpoint, { offset: 0, align: 'top', duration: 500, ease: 'linear' });
        window.removeEventListener('scroll', _this._scrollHandler);
      }
    };

    _this._scrollHandler = _this._scrollHandler.bind(_this);
    _this._handleWaypointEnter = _this._handleWaypointEnter.bind(_this);
    _this.isDesktop = _this.props.window_width >= _theme.breakpoints.desktop ? true : false;
    return _this;
  }

  _createClass(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isDesktop) {
        window.addEventListener('scroll', this._scrollHandler);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.isDesktop) {
        window.removeEventListener('scroll', this._scrollHandler);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.scrollDirection == 'top' && this.isDesktop) {
        window.addEventListener('scroll', this._scrollHandler);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _components.PageWrapper,
        { pageId: 'home' },
        _react2.default.createElement('div', { ref: function ref(div) {
            _this2.PageTopScrollpoint = div;
          } }),
        _react2.default.createElement(_components.HelmetWrap, { pageMeta: this.props.data.homeData.data.page_meta }),
        _react2.default.createElement(_components.Hero, { sliderContent: this.props.data.homeData.data.hero_slider }),
        _react2.default.createElement('div', { ref: function ref(div) {
            _this2.DesktopGridScrollpoint = div;
          } }),
        _react2.default.createElement(_reactWaypoint2.default, { onEnter: this._handleWaypointEnter }),
        this.props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(_DesktopGrid2.default, { data: this.props.data.homeData.data.latest }) : _react2.default.createElement(_MobileGrid2.default, { data: this.props.data.homeData.data.latest })
      );
    }
  }]);

  return Home;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.staticContent,
    window_width: state.window_dimensions.window_width,
    window_height: state.window_dimensions.window_height,
    scrollDirection: state.scroll_direction
  };
})(Home);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _components = __webpack_require__(6);

var _DesktopGrid = __webpack_require__(158);

var _DesktopGrid2 = _interopRequireDefault(_DesktopGrid);

var _MobileGrid = __webpack_require__(159);

var _MobileGrid2 = _interopRequireDefault(_MobileGrid);

var _theme = __webpack_require__(1);

var _reactScrollToComponent = __webpack_require__(229);

var _reactScrollToComponent2 = _interopRequireDefault(_reactScrollToComponent);

var _reactWaypoint = __webpack_require__(75);

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HomeJack = function (_Component) {
  _inherits(HomeJack, _Component);

  function HomeJack(props) {
    _classCallCheck(this, HomeJack);

    var _this = _possibleConstructorReturn(this, (HomeJack.__proto__ || Object.getPrototypeOf(HomeJack)).call(this, props));

    _this._handleWaypointEnter = function (e) {
      if (_this.props.scrollDirection == 'scrolling-up' && _this.isDesktop) {
        (0, _reactScrollToComponent2.default)(_this.PageTopScrollpoint, { offset: 0, align: 'top', duration: 500, ease: 'linear' });
      }
    };

    _this._scrollHandler = function (e) {
      if (document.scrollingElement.scrollTop > 150 && _this.isDesktop) {
        (0, _reactScrollToComponent2.default)(_this.DesktopGridScrollpoint, { offset: 0, align: 'top', duration: 500, ease: 'linear' });
        window.removeEventListener('scroll', _this._scrollHandler);
      }
    };

    _this._scrollHandler = _this._scrollHandler.bind(_this);
    _this._handleWaypointEnter = _this._handleWaypointEnter.bind(_this);
    _this.isDesktop = _this.props.window_width >= _theme.breakpoints.desktop ? true : false;
    return _this;
  }

  _createClass(HomeJack, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isDesktop) {
        window.addEventListener('scroll', this._scrollHandler);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.isDesktop) {
        window.removeEventListener('scroll', this._scrollHandler);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.scrollDirection == 'top' && this.isDesktop) {
        window.addEventListener('scroll', this._scrollHandler);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _components.PageWrapper,
        { pageId: 'home' },
        this.props.data && _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement('div', { ref: function ref(div) {
              _this2.PageTopScrollpoint = div;
            } }),
          _react2.default.createElement(_components.HelmetWrap, { pageMeta: this.props.data.homeData.data.page_meta }),
          _react2.default.createElement(_components.Hero, { sliderContent: this.props.data.homeData.data.hero_slider }),
          _react2.default.createElement('div', { ref: function ref(div) {
              _this2.DesktopGridScrollpoint = div;
            } }),
          _react2.default.createElement(_reactWaypoint2.default, { onEnter: this._handleWaypointEnter }),
          this.props.window_width >= _theme.breakpoints.desktop ? _react2.default.createElement(_DesktopGrid2.default, { data: this.props.data.homeData.data.latest }) : _react2.default.createElement(_MobileGrid2.default, { data: this.props.data.homeData.data.latest })
        )
      );
    }
  }]);

  return HomeJack;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.staticContent,
    window_width: state.window_dimensions.window_width,
    window_height: state.window_dimensions.window_height,
    scrollDirection: state.scroll_direction
  };
})(HomeJack);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _HomeModalWrapper = __webpack_require__(304);

var _HomeModalWrapper2 = _interopRequireDefault(_HomeModalWrapper);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _BgImage = __webpack_require__(35);

var _BgImage2 = _interopRequireDefault(_BgImage);

var _theme = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class(props) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

    _this.keydown = _this._handleKeyDown.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: '_handleKeyDown',
    value: function _handleKeyDown(event) {
      switch (event.keyCode) {
        case 27:
          this.props.ClickFunction();
          break;
        default:
          break;
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.addEventListener('keydown', this.keydown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.keydown);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _HomeModalWrapper2.default,
        null,
        _react2.default.createElement(
          'div',
          { id: 'popover-wrapper', className: _style2.default.dynamic([['1939026183', [_theme.colors.black, _theme.widths.global_max_width]]])
          },
          _react2.default.createElement('button', { id: 'close-popover', onClick: this.props.ClickFunction, className: _style2.default.dynamic([['1939026183', [_theme.colors.black, _theme.widths.global_max_width]]])
          }),
          _react2.default.createElement(
            'div',
            { id: 'popover-img-wrapper', className: _style2.default.dynamic([['1939026183', [_theme.colors.black, _theme.widths.global_max_width]]])
            },
            _react2.default.createElement(
              'div',
              { id: 'image-wrap', className: _style2.default.dynamic([['1939026183', [_theme.colors.black, _theme.widths.global_max_width]]])
              },
              _react2.default.createElement(_BgImage2.default, { source: this.props.popoverData.image.large, bgSize: 'contain' })
            )
          ),
          _react2.default.createElement(_style2.default, {
            styleId: '1939026183',
            css: ['#homepage-modal{width:100%;height:100vh;position:fixed;top:0;left:0;z-index:10000;background:' + _theme.colors.black + ';}', 'h1.__jsx-style-dynamic-selector{color:white;}', '#popover-wrapper.__jsx-style-dynamic-selector{width:100%;height:100%;position:absolute;top:0;left:0;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;}', '#close-popover.__jsx-style-dynamic-selector{position:fixed;top:2.5rem;right:2.5rem;height:2rem;width:3.5rem;border:0;background-color:rgba(0,0,0,0);z-index:12000;cursor:pointer;}', '#close-popover.__jsx-style-dynamic-selector:after{position:absolute;top:0;right:0;z-index:12001;content:\'CLOSE\';color:white;font-weight:bold;}', '#caption-wrap.__jsx-style-dynamic-selector{padding-top:2rem;width:100%;max-width:' + _theme.widths.global_max_width + ';}', '#image-wrap.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex:1;-ms-flex:1;flex:1;width:100%;height:100%;}', '#popover-img-wrapper.__jsx-style-dynamic-selector{width:100%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;}'],
            dynamic: [_theme.colors.black, _theme.widths.global_max_width]
          })
        )
      );
    }
  }]);

  return _class;
}(_react.Component);

exports.default = _class;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var modalId = document.getElementById('homepage-modal');

var HomepageModalWrapper = function (_Component) {
  _inherits(HomepageModalWrapper, _Component);

  function HomepageModalWrapper(props) {
    _classCallCheck(this, HomepageModalWrapper);

    var _this = _possibleConstructorReturn(this, (HomepageModalWrapper.__proto__ || Object.getPrototypeOf(HomepageModalWrapper)).call(this, props));

    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(HomepageModalWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      modalId.appendChild(this.el);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      modalId.removeChild(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      return _reactDom2.default.createPortal(this.props.children, this.el);
    }
  }]);

  return HomepageModalWrapper;
}(_react.Component);

exports.default = HomepageModalWrapper;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _style = __webpack_require__(2);

var _style2 = _interopRequireDefault(_style);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _LinkWrapper = __webpack_require__(83);

var _LinkWrapper2 = _interopRequireDefault(_LinkWrapper);

var _Spinner = __webpack_require__(148);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _VideoPlayer = __webpack_require__(51);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DesktopGridItem = function (_Component) {
  _inherits(DesktopGridItem, _Component);

  function DesktopGridItem(props) {
    _classCallCheck(this, DesktopGridItem);

    var _this = _possibleConstructorReturn(this, (DesktopGridItem.__proto__ || Object.getPrototypeOf(DesktopGridItem)).call(this, props));

    _this.state = {
      loaded: false,
      itemStyle: {
        opacity: 0
      },
      borderStyle: {}
    };
    return _this;
  }

  _createClass(DesktopGridItem, [{
    key: 'handleImageLoaded',
    value: function handleImageLoaded() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.props.itemData.type !== 'border') {
          var image = _this2.props.itemData.image.large;
          if (_this2.props.itemData.type == 'landscape') {
            image = _this2.props.itemData.image_landscape;
          } else if (_this2.props.itemData.type == 'portrait') {
            image = _this2.props.itemData.image_portrait;
          }
          _this2.setState({
            loaded: true,
            itemStyle: {
              opacity: 1,
              backgroundImage: 'url(' + image + ')'
            }
          });
        } else {
          var _image = null;
          if (_this2.props.itemData.type == 'landscape') {
            _image = _this2.props.itemData.image_landscape;
          } else {
            _image = _this2.props.itemData.image_portrait;
          }
          _this2.setState({
            loaded: true,
            itemStyle: {
              opacity: 1,
              backgroundColor: _this2.props.itemData.bgColor
            },
            borderStyle: {
              backgroundImage: 'url(' + _this2.props.itemData.image.large + ')'
            }
          });
        }
      }, 150);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: this.props.itemData.black_caption ? 'grid-item-desktop black-caption' : 'grid-item-desktop', style: this.state.itemStyle },
          _react2.default.createElement(
            _LinkWrapper2.default,
            {
              linkData: this.props.itemData,
              linkClass: !this.props.itemData.video && this.props.video_header_state == 'video-playing' && true,
              hideCaption: !this.props.itemData.video && (this.props.video_header_state == 'video-playing' || this.props.video_header_state == 'video-paused') && true
            },
            this.props.itemData.video ? _react2.default.createElement(
              'div',
              {
                className: 'jsx-972628393' + ' ' + 'video-wrapper'
              },
              _react2.default.createElement(_VideoPlayer2.default, { videoId: this.props.itemData.video, videoUrl: 'https://vimeo.com/' + this.props.itemData.video, videoPoster: this.props.itemData.image.large, videoCover: false, cta: 'PLAY' }),
              _react2.default.createElement('img', { src: this.props.itemData.image_landscape, onLoad: this.handleImageLoaded.bind(this), className: 'jsx-972628393' + ' ' + 'hp-image__loader'
              })
            ) : _react2.default.createElement('img', { src: this.props.itemData.type == 'portrait' ? this.props.itemData.image_portrait : this.props.itemData.image_landscape, onLoad: this.handleImageLoaded.bind(this), className: 'jsx-972628393' + ' ' + 'hp-image__loader thiswork'
            }),
            this.props.itemData.type === 'border' && _react2.default.createElement('div', { style: this.state.borderStyle, className: 'jsx-972628393' + ' ' + 'hp-image__border-inner'
            }),
            _react2.default.createElement(_style2.default, {
              styleId: '972628393',
              css: ['.video-wrapper.jsx-972628393{width:103.5%;height:100%;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;top:0;left:-1.75%;background-color:black;z-index:1;}', '.video-wrapper.jsx-972628393>.video__container{height:100%;}']
            })
          )
        ),
        !this.state.loaded && _react2.default.createElement(_Spinner2.default, null)
      );
    }
  }]);

  return DesktopGridItem;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    video_header_state: state.video_state.header_style
  };
})(DesktopGridItem);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var _Spinner = __webpack_require__(148);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _SingleLineCaption = __webpack_require__(14);

var _SingleLineCaption2 = _interopRequireDefault(_SingleLineCaption);

var _LinkWrapper = __webpack_require__(83);

var _LinkWrapper2 = _interopRequireDefault(_LinkWrapper);

var _VideoPlayer = __webpack_require__(51);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MobileGridItem = function (_Component) {
  _inherits(MobileGridItem, _Component);

  function MobileGridItem(props) {
    _classCallCheck(this, MobileGridItem);

    var _this = _possibleConstructorReturn(this, (MobileGridItem.__proto__ || Object.getPrototypeOf(MobileGridItem)).call(this, props));

    _this.state = {
      loaded: false,
      itemStyle: {
        opacity: 0
      },
      bgStyle: {}
    };
    return _this;
  }

  _createClass(MobileGridItem, [{
    key: 'handleImageLoaded',
    value: function handleImageLoaded() {
      var _this2 = this;

      this.setState({
        bgStyle: {
          backgroundImage: 'url(' + this.props.itemData.image.large + ')'
        }
      });
      setTimeout(function () {
        _this2.setState({
          loaded: true,
          itemStyle: {
            opacity: 1
          }
        });
      }, 250);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _LinkWrapper2.default,
        {
          linkData: this.props.itemData,
          linkClass: !this.props.itemData.video && this.props.video_header_state == 'video-playing' && true,
          hideCaption: !this.props.itemData.video && (this.props.video_header_state == 'video-playing' || this.props.video_header_state == 'video-paused') && true
        },
        _react2.default.createElement(
          'div',
          { className: 'hp-image-wrapper', style: this.state.itemStyle },
          _react2.default.createElement(
            'div',
            { className: 'c-' + this.props.itemData.type + ' hp-mobile-grid-item', style: this.state.bgStyle },
            this.props.itemData.video ? _react2.default.createElement(
              'div',
              { className: 'video-wrapper' },
              _react2.default.createElement(_VideoPlayer2.default, { videoId: this.props.itemData.video, videoUrl: 'https://vimeo.com/' + this.props.itemData.video, videoPoster: this.props.itemData.image.large, videoCover: true, cta: 'PLAY' }),
              _react2.default.createElement('img', { className: 'hp-image__loader', src: this.props.itemData.image.large, onLoad: this.handleImageLoaded.bind(this) })
            ) : _react2.default.createElement('img', { className: 'hp-image__loader', src: this.props.itemData.image.large, onLoad: this.handleImageLoaded.bind(this) })
          ),
          _react2.default.createElement(
            'div',
            { className: 'hp-caption-wrapper' },
            this.props.itemData.linkType == 'instagram' ? _react2.default.createElement(
              'div',
              { onClick: function onClick(e) {
                  e.stopPropagation();
                } },
              _react2.default.createElement(_SingleLineCaption2.default, { Headline: this.props.itemData.title, Description: this.props.itemData.description, Stacked: true })
            ) : _react2.default.createElement(_SingleLineCaption2.default, { Headline: this.props.itemData.title, Description: this.props.itemData.description, Stacked: true })
          )
        ),
        !this.state.loaded && _react2.default.createElement(_Spinner2.default, null)
      );
    }
  }]);

  return MobileGridItem;
}(_react.Component);

;

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    video_header_state: state.video_state.header_style
  };
}, function (dispatch) {
  return {};
})(MobileGridItem);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleArticle = exports.SingleExhibition = exports.SinglePublication = exports.SingleFilm = exports.SinglePortfolio = exports.PublicationsLanding = exports.FineArtLanding = exports.FilmLanding = exports.PhotoLanding = exports.NoMatch = exports.Contact = exports.BlogLanding = exports.About = exports.GalleryList = exports.HomeJack = exports.Home = undefined;

var _Home = __webpack_require__(301);

var _Home2 = _interopRequireDefault(_Home);

var _HomeJack = __webpack_require__(302);

var _HomeJack2 = _interopRequireDefault(_HomeJack);

var _GalleryList = __webpack_require__(299);

var _GalleryList2 = _interopRequireDefault(_GalleryList);

var _About = __webpack_require__(289);

var _About2 = _interopRequireDefault(_About);

var _Contact = __webpack_require__(290);

var _Contact2 = _interopRequireDefault(_Contact);

var _BlogLanding = __webpack_require__(291);

var _BlogLanding2 = _interopRequireDefault(_BlogLanding);

var _NoMatch = __webpack_require__(281);

var _NoMatch2 = _interopRequireDefault(_NoMatch);

var _PhotoLanding = __webpack_require__(282);

var _PhotoLanding2 = _interopRequireDefault(_PhotoLanding);

var _FilmLanding = __webpack_require__(279);

var _FilmLanding2 = _interopRequireDefault(_FilmLanding);

var _FineArtLanding = __webpack_require__(280);

var _FineArtLanding2 = _interopRequireDefault(_FineArtLanding);

var _PublicationsLanding = __webpack_require__(283);

var _PublicationsLanding2 = _interopRequireDefault(_PublicationsLanding);

var _SinglePortfolio = __webpack_require__(287);

var _SinglePortfolio2 = _interopRequireDefault(_SinglePortfolio);

var _SingleFilm = __webpack_require__(286);

var _SingleFilm2 = _interopRequireDefault(_SingleFilm);

var _SinglePublication = __webpack_require__(288);

var _SinglePublication2 = _interopRequireDefault(_SinglePublication);

var _SingleExhibition = __webpack_require__(285);

var _SingleExhibition2 = _interopRequireDefault(_SingleExhibition);

var _SingleArticle = __webpack_require__(284);

var _SingleArticle2 = _interopRequireDefault(_SingleArticle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Home = _Home2.default;
exports.HomeJack = _HomeJack2.default;
exports.GalleryList = _GalleryList2.default;
exports.About = _About2.default;
exports.BlogLanding = _BlogLanding2.default;
exports.Contact = _Contact2.default;
exports.NoMatch = _NoMatch2.default;
exports.PhotoLanding = _PhotoLanding2.default;
exports.FilmLanding = _FilmLanding2.default;
exports.FineArtLanding = _FineArtLanding2.default;
exports.PublicationsLanding = _PublicationsLanding2.default;
exports.SinglePortfolio = _SinglePortfolio2.default;
exports.SingleFilm = _SingleFilm2.default;
exports.SinglePublication = _SinglePublication2.default;
exports.SingleExhibition = _SingleExhibition2.default;
exports.SingleArticle = _SingleArticle2.default;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categorySelectedTrigger = exports.setCatPage = exports.setCatNav = undefined;

var _history = __webpack_require__(160);

var _history2 = _interopRequireDefault(_history);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function catPage(url) {
  return {
    type: 'CATEGORY_NAV_PAGE',
    url: url
  };
}

function catNav(navigation) {
  return {
    type: 'CATEGORY_NAV',
    navigation: navigation
  };
}

function categorySelected(category) {
  return {
    type: 'CATEGORY_SELECTED',
    category: category
  };
}

var setCatPage = function setCatPage(url) {
  var split = function split(input) {
    var path = '/' + input.split('/')[1];
    var route = '';
    switch (path) {
      case '/photography':
      case '/film':
      case '/fine-art':
      case '/publications':
        route = path;
        break;
      default:
        route = false;
        break;
    };
    return route;
  };
  var catRoute = split(url);
  return function (dispatch) {
    dispatch(catPage(catRoute));
  };
};

var setCatNav = function setCatNav(navigation) {
  return function (dispatch) {
    dispatch(catNav(navigation));
  };
};

var categorySelectedTrigger = function categorySelectedTrigger(category) {
  return function (dispatch, getState) {
    var catNav = getState().category_nav;
    var catsFlat = catNav.map(function (catNav) {
      return catNav.slug;
    });
    if (catsFlat.includes(category) === false) {
      _history2.default.push(getState().category_nav_page);
      dispatch(categorySelected('everything'));
    } else {
      dispatch(categorySelected(category));
    }
  };
};

exports.setCatNav = setCatNav;
exports.setCatPage = setCatPage;
exports.categorySelectedTrigger = categorySelectedTrigger;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setVideoPlaying = setVideoPlaying;
function setVideoPlaying(state) {
  return {
    type: 'VIDEO_PLAYING',
    state: state
  };
}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// RESIZE DATA
function resizeData(resize_state) {
  return {
    type: 'RESIZE_STATE',
    resize_state: resize_state
  };
}

var setResizeState = function setResizeState() {
  return function (dispatch) {
    dispatch(resizeData({
      window_width: window.innerWidth,
      window_height: window.innerHeight
    }));
  };
};

// SCROLL DATA
function scrollData(scroll_state) {
  return {
    type: 'SCROLL_STATE',
    scroll_state: scroll_state
  };
}

function scrollDirection(direction) {
  return {
    type: 'SCROLL_DIRECTION',
    direction: direction
  };
}

var setDirectionDown = function setDirectionDown() {
  return function (dispatch, getState) {
    if (getState().scroll_direction == 'scrolling-up' || 'top') {
      setTimeout(function () {
        dispatch(scrollDirection('scrolling-down'));
      }, 50);
    }
  };
};

var setScrollDirection = function setScrollDirection(direction) {
  return function (dispatch) {
    dispatch(scrollDirection(direction));
  };
};

var setScrollState = function setScrollState() {
  return function (dispatch, getState) {
    var st = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    if (st < 100) {
      dispatch(scrollDirection('top'));
    }
    if (st > getState().window_dimensions.window_height) {
      dispatch(scrollData({
        cat_menu_wrapper: 'stick-it',
        portfolio_wrapper: 'add-margin'
      }));
    } else {
      dispatch(scrollData({
        cat_menu_wrapper: null,
        portfolio_wrapper: null
      }));
    }
  };
};

// EXPORTS
exports.setScrollState = setScrollState;
exports.setResizeState = setResizeState;
exports.setDirectionDown = setDirectionDown;
exports.scrollDirection = scrollDirection;
exports.scrollData = scrollData;
exports.setScrollDirection = setScrollDirection;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMenuState = setMenuState;
exports.collapseMenu = collapseMenu;
exports.forceCollapseMenu = forceCollapseMenu;
exports.setSlugState = setSlugState;
exports.setRouterState = setRouterState;
exports.rootLocation = rootLocation;
exports.setHeaderNavLocation = setHeaderNavLocation;
exports.setHeaderStyle = setHeaderStyle;
exports.setHeaderVideo = setHeaderVideo;

var _scripts = __webpack_require__(5);

var headerNav = function headerNav(navLocation) {
  return {
    type: 'HEADER_NAV_LOCATION',
    navLocation: navLocation
  };
};

var headerStyle = function headerStyle(_headerStyle) {
  return {
    type: 'HEADER_STYLE',
    headerStyle: _headerStyle
  };
};

var menuExpand = function menuExpand(bool) {
  return {
    type: 'MENU_STATE',
    bool: bool
  };
};

var headerVideo = function headerVideo(style) {
  return {
    type: 'HEADER_VIDEO',
    style: style
  };
};

var setSlug = function setSlug(route) {
  return {
    type: 'SLUG_STATE',
    route: route
  };
};

var setRouter = function setRouter(data) {
  return {
    type: 'ROUTER_STATE',
    data: data
  };
};

// FUNCTIONS
function setMenuState() {
  return function (dispatch, getState) {
    var isOpen = !getState().menu_state;
    dispatch(menuExpand(isOpen));
  };
};

function collapseMenu() {
  return function (dispatch, getState) {
    if (getState().menu_state) ;
    dispatch(menuExpand(false));
  };
};

function forceCollapseMenu() {
  return function (dispatch) {
    dispatch(menuExpand(false));
  };
};

function setSlugState(route) {
  return function (dispatch) {
    dispatch(setSlug(route));
  };
};

function setRouterState(data) {
  return function (dispatch) {
    dispatch(setRouter(data));
  };
};

function rootLocation(location) {
  return location.split('/')[1];
};

function setHeaderNavLocation(location) {
  var returnLocation = function returnLocation(location) {
    return location === '/' ? 'Latest' : rootLocation(location) === 'portfolio' ? 'Photography' : rootLocation(location) === 'films' ? 'Film' : rootLocation(location) === 'publication' ? 'Publications' : rootLocation(location) === 'article' ? 'Journal' : rootLocation(location) === 'fine-art' ? 'Fine Art' : rootLocation(location) === 'exhibition' ? 'Fine Art' : (0, _scripts.upperCase)(rootLocation(location));
  };
  return function (dispatch) {
    dispatch(headerNav(returnLocation(location)));
  };
};

function setHeaderStyle(location) {
  return function (dispatch) {
    if (rootLocation(location) == 'photography' || rootLocation(location) == 'film' || rootLocation(location) == 'films' || rootLocation(location) == 'fine-art' || rootLocation(location) == 'publications' || rootLocation(location) == 'publication' || rootLocation(location) == 'exhibition' || rootLocation(location) == 'article' || location == '/') {
      dispatch(headerStyle('wht-no-bg'));
    } else {
      dispatch(headerStyle('blk-with-bg'));
    };
  };
};

function setHeaderVideo() {
  return function (dispatch, getState) {
    if (getState().video_playing == null) ;
    dispatch(headerVideo('video-playing'));
  };
};

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homeIncrement = homeIncrement;
exports.allHomeImagesLoaded = allHomeImagesLoaded;
function homeIncrement(increment) {
  return {
    type: 'HOME_COUNTER',
    increment: increment
  };
}

function allHomeImagesLoaded(bool) {
  return {
    type: 'ALL_HOME_IMAGES_LOADED',
    allLoaded: bool
  };
}

var homeIncrementTrigger = function homeIncrementTrigger(limit, imgCount) {
  return function (dispatch, getState) {
    var imageLoaded = function imageLoaded() {
      if (getState().homeCounter + limit <= imgCount - 5) {
        return limit = getState().homeCounter + limit;
      } else {
        dispatch(allHomeImagesLoaded(true));
        return limit = imgCount;
      }
    };
    dispatch(homeIncrement(imageLoaded()));
  };
};

exports.default = homeIncrementTrigger;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticContentHasErrored = staticContentHasErrored;
exports.staticContentIsLoading = staticContentIsLoading;
exports.staticContentFetchDataSuccess = staticContentFetchDataSuccess;
function staticContentHasErrored(bool) {
  return {
    type: 'STATIC_CONTENT_HAS_ERRORED',
    hasErrored: bool
  };
}

function staticContentIsLoading(bool) {
  return {
    type: 'STATIC_CONTENT_IS_LOADING',
    isLoading: bool
  };
}

function staticContentFetchDataSuccess(staticContent) {
  return {
    type: 'STATIC_CONTENT_FETCH_DATA_SUCCESS',
    staticContent: staticContent
  };
}

var staticContentFetchData = function staticContentFetchData(url) {
  return function (dispatch) {
    dispatch(staticContentIsLoading(true));
    fetch(url).then(function (response) {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      dispatch(staticContentIsLoading(false));
      return response;
    }).then(function (response) {
      return response.json();
    }).then(function (staticContent) {
      return dispatch(staticContentFetchDataSuccess(staticContent));
    }).catch(function () {
      return dispatch(staticContentHasErrored(true));
    });
  };
};

exports.default = staticContentFetchData;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categorySelector = categorySelector;
function categorySelector() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'everything';
  var action = arguments[1];

  switch (action.type) {
    case 'CATEGORY_SELECTED':
      return action.category;
    default:
      return state;
  }
}

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerNavLocation = headerNavLocation;
exports.headerNavStyle = headerNavStyle;
exports.menuState = menuState;
exports.slugState = slugState;
exports.routerState = routerState;
function headerNavLocation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'HEADER_NAV_LOCATION':
      return action.navLocation;
    default:
      return state;
  }
}

function headerNavStyle() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case 'HEADER_STYLE':
      return action.headerStyle;
    default:
      return state;
  }
}

function menuState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'MENU_STATE':
      return action.bool;
    default:
      return state;
  }
}

function slugState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'SLUG_STATE':
      return action.route;
    default:
      return state;
  }
}

function routerState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'ROUTER_STATE':
      return action.data;
    default:
      return state;
  }
}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homeImagesLoaded = homeImagesLoaded;
exports.homeCounter = homeCounter;
function homeImagesLoaded() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'ALL_HOME_IMAGES_LOADED':
      return action.allLoaded;
    default:
      return state;
  }
}

function homeCounter() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  var action = arguments[1];

  switch (action.type) {
    case 'HOME_COUNTER':
      return action.increment;
    default:
      return state;
  }
}

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(137);

var _header_nav_location = __webpack_require__(315);

var _home_counter = __webpack_require__(316);

var _category_selected = __webpack_require__(314);

var _static_content = __webpack_require__(321);

var _r_window_data = __webpack_require__(320);

var _r_cateogory_nav = __webpack_require__(318);

var _r_media_controls = __webpack_require__(319);

var reducers = (0, _redux.combineReducers)({
  nav_location: _header_nav_location.headerNavLocation,
  header_style: _header_nav_location.headerNavStyle,
  scroll_state: _r_window_data.scrollState,
  scroll_direction: _r_window_data.scrollDirectionState,
  past_hero: _r_window_data.heroState,
  window_dimensions: _r_window_data.resizeState,
  menu_state: _header_nav_location.menuState,
  route: _header_nav_location.slugState,
  router: _header_nav_location.routerState,
  current_category_slug: _r_cateogory_nav.categoryNavSubRoute,
  current_sub_category: _category_selected.categorySelector,
  category_nav_page: _r_cateogory_nav.categoryNavPageState,
  category_nav: _r_cateogory_nav.categoryNavState,
  video_state: _r_media_controls.setVideoState,
  homeCounter: _home_counter.homeCounter,
  homeImagesLoaded: _home_counter.homeImagesLoaded,
  staticContent: _static_content.staticContent,
  staticContentHasErrored: _static_content.staticContentHasErrored,
  staticContentIsLoading: _static_content.staticContentIsLoading
});

exports.default = reducers;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryNavPageState = categoryNavPageState;
exports.categoryNavState = categoryNavState;
exports.categoryNavSubRoute = categoryNavSubRoute;
function categoryNavPageState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'CATEGORY_NAV_PAGE':
      return action.url;
    default:
      return state;
  }
}

function categoryNavState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'CATEGORY_NAV':
      return action.navigation;
    default:
      return state;
  }
}

function categoryNavSubRoute() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'CATEGORY_SUBROUTE':
      return action.slug;
    default:
      return state;
  }
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setVideoState = setVideoState;
function setVideoState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { url: null, header_style: '' };
  var action = arguments[1];

  switch (action.type) {
    case 'VIDEO_PLAYING':
      return action.state;
    default:
      return state;
  }
}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollState = scrollState;
exports.scrollDirectionState = scrollDirectionState;
exports.resizeState = resizeState;
exports.heroState = heroState;
function scrollState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'SCROLL_STATE':
      return action.scroll_state;
    default:
      return state;
  }
}

function scrollDirectionState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'top';
  var action = arguments[1];

  switch (action.type) {
    case 'SCROLL_DIRECTION':
      return action.direction;
    default:
      return state;
  }
}

function resizeState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case 'RESIZE_STATE':
      return action.resize_state;
    default:
      return state;
  }
}

function heroState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'HOME_HERO':
      return action.bool;
    default:
      return state;
  }
}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticContentHasErrored = staticContentHasErrored;
exports.staticContentIsLoading = staticContentIsLoading;
exports.staticContent = staticContent;
function staticContentHasErrored() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'STATIC_CONTENT_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

function staticContentIsLoading() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'STATIC_CONTENT_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

function staticContent() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case 'STATIC_CONTENT_FETCH_DATA_SUCCESS':
      return action.staticContent;
    default:
      return state;
  }
}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__(7);

var _history = __webpack_require__(160);

var _history2 = _interopRequireDefault(_history);

var _components = __webpack_require__(6);

var _pages = __webpack_require__(307);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Routes = function Routes(props) {
  return _react2.default.createElement(
    _reactRouterDom.Router,
    { history: _history2.default },
    _react2.default.createElement(_reactRouterDom.Route, { render: function render(_ref) {
        var location = _ref.location,
            match = _ref.match;
        return _react2.default.createElement(
          _components.Layout,
          { routeData: location, matchData: match },
          _react2.default.createElement(
            _reactRouterDom.Switch,
            null,
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: function component(props) {
                return _react2.default.createElement(_pages.Home, props);
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/photography', component: _pages.PhotoLanding }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/film', component: _pages.FilmLanding }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/fine-art', component: _pages.FineArtLanding }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/publications', component: _pages.PublicationsLanding }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/journal', render: function render(routeProps) {
                return _react2.default.createElement(_pages.BlogLanding, _extends({}, routeProps, { data: props.staticContent.blogLanding.data }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/studio-conversations', render: function render(routeProps) {
                return _react2.default.createElement(_pages.BlogLanding, _extends({}, routeProps, { data: props.staticContent.conversationsLanding.data }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/galleries', render: function render(routeProps) {
                return _react2.default.createElement(_pages.GalleryList, _extends({}, routeProps, { data: props.staticContent.galleryData.data }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/about', render: function render(routeProps) {
                return _react2.default.createElement(_pages.About, _extends({}, routeProps, { data: props.staticContent.aboutData.data }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/contact', render: function render(routeProps) {
                return _react2.default.createElement(_pages.Contact, _extends({}, routeProps, { data: props.staticContent.aboutData.data }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/terms', render: function render(routeProps) {
                return _react2.default.createElement(_components.WysywgPage, _extends({}, routeProps, { data: props.staticContent.termsData.data }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/portfolio/:pageSlug', component: function component(props) {
                return _react2.default.createElement(_pages.SinglePortfolio, props);
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/films/:pageSlug', component: function component(props) {
                return _react2.default.createElement(_pages.SingleFilm, props);
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/publication/:pageSlug', component: function component(props) {
                return _react2.default.createElement(_pages.SinglePublication, props);
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/exhibition/:pageSlug', component: function component(props) {
                return _react2.default.createElement(_pages.SingleExhibition, props);
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/article/:pageSlug', component: function component(props) {
                return _react2.default.createElement(_pages.SingleArticle, _extends({}, props, { postType: 'post' }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/studio-conversation/:pageSlug', component: function component(props) {
                return _react2.default.createElement(_pages.SingleArticle, _extends({}, props, { postType: 'studio-conversations' }));
              } }),
            _react2.default.createElement(_reactRouterDom.Route, { path: '/404', component: _pages.NoMatch }),
            _react2.default.createElement(_reactRouterDom.Route, { component: _components.ErrorRedirect })
          )
        );
      } })
  );
};

exports.default = Routes;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(549);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import findIndex from 'lodash/findIndex';
// import mixin from 'lodash/mixin';
// import _ from 'lodash/wrapperLodash';

// mixin(_, {
//   chain: chain,
//   findIndex: findIndex
// });

var arrayPosition = function arrayPosition(array, current) {
  var flattenArray = function flattenArray(data, key) {
    return _lodash2.default.chain(data).map(key).flatten().value();
  };
  var flattened = flattenArray(flattenArray(array), 'urls');
  var position = _lodash2.default.findIndex(flattened, { id: current });
  return position;
}; // import chain from 'lodash/chain';
exports.default = arrayPosition;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var dropFirstItem = function dropFirstItem(array) {
  return array.slice(1);
};

exports.default = dropFirstItem;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _random = __webpack_require__(555);

var _random2 = _interopRequireDefault(_random);

var _filter = __webpack_require__(541);

var _filter2 = _interopRequireDefault(_filter);

var _map = __webpack_require__(550);

var _map2 = _interopRequireDefault(_map);

var _extend = __webpack_require__(540);

var _extend2 = _interopRequireDefault(_extend);

var _mixin = __webpack_require__(138);

var _mixin2 = _interopRequireDefault(_mixin);

var _wrapperLodash = __webpack_require__(139);

var _wrapperLodash2 = _interopRequireDefault(_wrapperLodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _mixin2.default)(_wrapperLodash2.default, {
  random: _random2.default,
  filter: _filter2.default,
  map: _map2.default,
  extend: _extend2.default
});

var filterCategory = function filterCategory(array, filter) {
  var randomKey = function randomKey() {
    return 'imgkey_' + _wrapperLodash2.default.random(0, 10000) + '-' + _wrapperLodash2.default.random(0, 100);
  };
  var filterArray = function filterArray(array, filter) {
    return _wrapperLodash2.default.filter(array, {
      nav_categories: [filter]
    });
  };
  var filtered = filterArray(array, filter);
  var newArray = _wrapperLodash2.default.map(filtered, function (i) {
    return _wrapperLodash2.default.extend({ new_key: randomKey() }, i);
  });
  return newArray;
};

exports.default = filterCategory;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitString = splitString;
exports.removeHidden = removeHidden;
function splitString(txt) {
  var txtArray = txt.split('/');
  return txtArray.length == 2 ? 'everything' : txtArray.slice(-1).pop();
};

function removeHidden(array) {
  var filtered = _.filter(array, {
    is_hidden: false
  });
  return filtered.length != 0 ? filtered : array;
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
String.prototype.parseHashtag = function () {
  return this.replace(/[#]+[A-Za-z0-9-_]+/g, function (t) {
    var tag = t.replace('#', '');
    return '<a href="https://www.instagram.com/explore/tags/' + tag + '" target="_blank">#' + tag + '</a>';
  });
};

String.prototype.parseAts = function () {
  return this.replace(/[@]+[A-Za-z0-9-_]+/g, function (t) {
    var at = t.replace('@', '');
    return '<a href="https://www.instagram.com/' + at + '" target="_blank">@' + at + '</a>';
  });
};

var instagramFormat = {
  instaLink: function instaLink(linkUrl) {
    var eString = linkUrl.match(new RegExp('<div class="insta-link">' + '(.*)' + '</div>'));
    window.open(eString[1], '_blank');
  },
  title: function title(_title) {
    var instaCaptionFull = _title.match(new RegExp('<div class="insta-caption">' + '(.*)' + '</div>'));
    var instaCaptionText = instaCaptionFull[1];
    instaCaptionText = instaCaptionText.parseHashtag();
    instaCaptionText = instaCaptionText.parseAts();
    return {
      headline: 'Instagram',
      hash_tag: instaCaptionText
    };
  }
};

exports.default = instagramFormat;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getKey = __webpack_require__(161);

var _getKey2 = _interopRequireDefault(_getKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var photoArray = function photoArray(array) {
  var collect = function collect(array) {
    var result = [];
    array.forEach(function (el) {
      if ((0, _getKey2.default)(el) == 'two_column') {
        result.push(el.two_column[0].image);
        result.push(el.two_column[1].image);
      } else {
        result.push(el.image);
      }
    });
    return result;
  };

  return {
    carousel_array: collect(array),
    flex_array: array
  };
};

exports.default = photoArray;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var returnCategories = function returnCategories(cat) {
  return cat.join(' ');
};

exports.default = returnCategories;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var returnOpacity = function returnOpacity(value) {
  var valueInt = parseInt(value, 10);
  if (value === '100') {
    return '1.0';
  } else {
    return '0.' + valueInt;
  }
};

exports.default = returnOpacity;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (collapseFunction, openFunction, threshold) {
  var currentPixel = window.pageYOffset;
  var scrollTime = 0;
  var looper = function looper() {
    var newPixel = window.pageYOffset;
    var diff = newPixel - currentPixel;
    var speed = diff * 1.125;
    if (speed > diff) {
      scrollTime = scrollTime + 1;
      if (scrollTime === threshold) {
        collapseFunction();
      }
    } else if (speed < diff) {
      scrollTime = scrollTime + 1;
      if (scrollTime === threshold) {
        openFunction();
      }
    } else {
      scrollTime = 0;
    }
    currentPixel = newPixel;
    requestAnimationFrame(looper);
  };
  looper();
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var truncateText = function truncateText(textIn) {
    var regex = new RegExp(/^(.{100}[^\s]*).*/);
    var truncatedString = textIn.replace(regex, '$1');
    truncatedString = truncatedString.replace(/\s+$/, '');
    return truncatedString;
};

exports.default = truncateText;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var upperCase = function upperCase(str) {
  var lower = str.toLowerCase();
  return lower.replace(/(^| )(\w)/g, function (x) {
    return x.toUpperCase();
  });
};

exports.default = upperCase;

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(181)(false);
// imports


// module
exports.push([module.i, "#social-share{padding:6.5rem 0;width:100%}#share-links{list-style:none;display:block;background:#fff;position:relative}.share-li{display:inline-block}.share-li.mid{margin:0 .25em;-webkit-transition:all .5s ease-out;transition:all .5s ease-out}.share-label,.share-li a{font-weight:700;text-decoration:none;text-transform:uppercase;font-size:1rem;cursor:pointer}#share-links .animate .share-li.mid{margin:0 1.6em}", ""]);

// exports


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(181)(false);
// imports


// module
exports.push([module.i, "@charset \"UTF-8\";.swiper-container{margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1}.swiper-container-no-flexbox .swiper-slide{float:left}.swiper-container-vertical>.swiper-wrapper{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform;-webkit-box-sizing:content-box;box-sizing:content-box}.swiper-container-android .swiper-slide,.swiper-wrapper{-webkit-transform:translateZ(0);transform:translateZ(0)}.swiper-container-multirow>.swiper-wrapper{-ms-flex-wrap:wrap;flex-wrap:wrap}.swiper-container-free-mode>.swiper-wrapper{-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out;margin:0 auto}.swiper-slide{-ms-flex-negative:0;flex-shrink:0;width:100%;height:100%;position:relative;-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;transition-property:transform;transition-property:transform,-webkit-transform}.swiper-slide-invisible-blank{visibility:hidden}.swiper-container-autoheight,.swiper-container-autoheight .swiper-slide{height:auto}.swiper-container-autoheight .swiper-wrapper{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-transition-property:height,-webkit-transform;transition-property:height,-webkit-transform;transition-property:transform,height;transition-property:transform,height,-webkit-transform}.swiper-container-3d{-webkit-perspective:1200px;perspective:1200px}.swiper-container-3d .swiper-cube-shadow,.swiper-container-3d .swiper-slide,.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top,.swiper-container-3d .swiper-wrapper{-webkit-transform-style:preserve-3d;transform-style:preserve-3d}.swiper-container-3d .swiper-slide-shadow-bottom,.swiper-container-3d .swiper-slide-shadow-left,.swiper-container-3d .swiper-slide-shadow-right,.swiper-container-3d .swiper-slide-shadow-top{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}.swiper-container-3d .swiper-slide-shadow-left{background-image:-webkit-gradient(linear,right top,left top,from(rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(270deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-right{background-image:-webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(90deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-top{background-image:-webkit-gradient(linear,left bottom,left top,from(rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(0deg,rgba(0,0,0,.5),transparent)}.swiper-container-3d .swiper-slide-shadow-bottom{background-image:-webkit-gradient(linear,left top,left bottom,from(rgba(0,0,0,.5)),to(transparent));background-image:linear-gradient(180deg,rgba(0,0,0,.5),transparent)}.swiper-container-wp8-horizontal,.swiper-container-wp8-horizontal>.swiper-wrapper{-ms-touch-action:pan-y;touch-action:pan-y}.swiper-container-wp8-vertical,.swiper-container-wp8-vertical>.swiper-wrapper{-ms-touch-action:pan-x;touch-action:pan-x}.swiper-button-next,.swiper-button-prev{position:absolute;top:50%;width:27px;height:44px;margin-top:-22px;z-index:10;cursor:pointer;background-size:27px 44px;background-position:50%;background-repeat:no-repeat}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-prev,.swiper-container-rtl .swiper-button-next{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23007aff'/%3E%3C/svg%3E\");left:10px;right:auto}.swiper-button-next,.swiper-container-rtl .swiper-button-prev{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23007aff'/%3E%3C/svg%3E\");right:10px;left:auto}.swiper-button-prev.swiper-button-white,.swiper-container-rtl .swiper-button-next.swiper-button-white{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z' fill='%23fff'/%3E%3C/svg%3E\")}.swiper-button-next.swiper-button-white,.swiper-container-rtl .swiper-button-prev.swiper-button-white{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z' fill='%23fff'/%3E%3C/svg%3E\")}.swiper-button-prev.swiper-button-black,.swiper-container-rtl .swiper-button-next.swiper-button-black{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M0 22L22 0l2.1 2.1L4.2 22l19.9 19.9L22 44 0 22z'/%3E%3C/svg%3E\")}.swiper-button-next.swiper-button-black,.swiper-container-rtl .swiper-button-prev.swiper-button-black{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 27 44'%3E%3Cpath d='M27 22L5 44l-2.1-2.1L22.8 22 2.9 2.1 5 0l22 22z'/%3E%3C/svg%3E\")}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;-webkit-transition:opacity .3s;transition:opacity .3s;-webkit-transform:translateZ(0);transform:translateZ(0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-container-horizontal>.swiper-pagination-bullets,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:10px;left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{-webkit-transform:scale(.33);transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active,.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{-webkit-transform:scale(1);transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{-webkit-transform:scale(.66);transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{-webkit-transform:scale(.33);transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{-webkit-transform:scale(.66);transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{-webkit-transform:scale(.33);transform:scale(.33)}.swiper-pagination-bullet{width:8px;height:8px;display:inline-block;border-radius:100%;background:#000;opacity:.2}button.swiper-pagination-bullet{border:none;margin:0;padding:0;-webkit-box-shadow:none;box-shadow:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet-active{opacity:1;background:#007aff}.swiper-container-vertical>.swiper-pagination-bullets{right:10px;top:50%;-webkit-transform:translate3d(0,-50%,0);transform:translate3d(0,-50%,0)}.swiper-container-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:6px 0;display:block}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:8px}.swiper-container-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;-webkit-transition:top .2s,-webkit-transform .2s;transition:top .2s,-webkit-transform .2s;transition:transform .2s,top .2s;transition:transform .2s,top .2s,-webkit-transform .2s}.swiper-container-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 4px}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);white-space:nowrap}.swiper-container-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{-webkit-transition:left .2s,-webkit-transform .2s;transition:left .2s,-webkit-transform .2s;transition:transform .2s,left .2s;transition:transform .2s,left .2s,-webkit-transform .2s}.swiper-container-horizontal.swiper-container-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{-webkit-transition:right .2s,-webkit-transform .2s;transition:right .2s,-webkit-transform .2s;transition:transform .2s,right .2s;transition:transform .2s,right .2s,-webkit-transform .2s}.swiper-pagination-progressbar{background:rgba(0,0,0,.25);position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:#007aff;position:absolute;left:0;top:0;width:100%;height:100%;-webkit-transform:scale(0);transform:scale(0);-webkit-transform-origin:left top;transform-origin:left top}.swiper-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{-webkit-transform-origin:right top;transform-origin:right top}.swiper-container-horizontal>.swiper-pagination-progressbar,.swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:4px;left:0;top:0}.swiper-container-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-container-vertical>.swiper-pagination-progressbar{width:4px;height:100%;left:0;top:0}.swiper-pagination-white .swiper-pagination-bullet-active{background:#fff}.swiper-pagination-progressbar.swiper-pagination-white{background:hsla(0,0%,100%,.25)}.swiper-pagination-progressbar.swiper-pagination-white .swiper-pagination-progressbar-fill{background:#fff}.swiper-pagination-black .swiper-pagination-bullet-active{background:#000}.swiper-pagination-progressbar.swiper-pagination-black{background:rgba(0,0,0,.25)}.swiper-pagination-progressbar.swiper-pagination-black .swiper-pagination-progressbar-fill{background:#000}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:10px;position:relative;-ms-touch-action:none;background:rgba(0,0,0,.1)}.swiper-container-horizontal>.swiper-scrollbar{position:absolute;left:1%;bottom:3px;z-index:50;height:5px;width:98%}.swiper-container-vertical>.swiper-scrollbar{position:absolute;right:3px;top:1%;z-index:50;width:5px;height:98%}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:rgba(0,0,0,.5);border-radius:10px;left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}.swiper-zoom-container{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center}.swiper-zoom-container>canvas,.swiper-zoom-container>img,.swiper-zoom-container>svg{max-width:100%;max-height:100%;-o-object-fit:contain;object-fit:contain}.swiper-slide-zoomed{cursor:move}.swiper-lazy-preloader{width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;-webkit-transform-origin:50%;transform-origin:50%;-webkit-animation:a 1s steps(12) infinite;animation:a 1s steps(12) infinite}.swiper-lazy-preloader:after{display:block;content:\"\";width:100%;height:100%;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%236c6c6c' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E\");background-position:50%;background-size:100%;background-repeat:no-repeat}.swiper-lazy-preloader-white:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' stroke='%23fff' stroke-width='11' stroke-linecap='round' d='M60 7v20'/%3E%3C/defs%3E%3Cuse xlink:href='%23a' opacity='.27'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(30 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(60 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(90 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(120 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.27' transform='rotate(150 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.37' transform='rotate(180 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.46' transform='rotate(210 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.56' transform='rotate(240 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.66' transform='rotate(270 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.75' transform='rotate(300 60 60)'/%3E%3Cuse xlink:href='%23a' opacity='.85' transform='rotate(330 60 60)'/%3E%3C/svg%3E\")}@-webkit-keyframes a{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes a{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.swiper-container .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-container-fade.swiper-container-free-mode .swiper-slide{-webkit-transition-timing-function:ease-out;transition-timing-function:ease-out}.swiper-container-fade .swiper-slide{pointer-events:none;-webkit-transition-property:opacity;transition-property:opacity}.swiper-container-fade .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-fade .swiper-slide-active,.swiper-container-fade .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube{overflow:visible}.swiper-container-cube .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;-webkit-transform-origin:0 0;transform-origin:0 0;width:100%;height:100%}.swiper-container-cube .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-cube.swiper-container-rtl .swiper-slide{-webkit-transform-origin:100% 0;transform-origin:100% 0}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-cube .swiper-slide-active,.swiper-container-cube .swiper-slide-next,.swiper-container-cube .swiper-slide-next+.swiper-slide,.swiper-container-cube .swiper-slide-prev{pointer-events:auto;visibility:visible}.swiper-container-cube .swiper-slide-shadow-bottom,.swiper-container-cube .swiper-slide-shadow-left,.swiper-container-cube .swiper-slide-shadow-right,.swiper-container-cube .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0;width:100%;height:100%;background:#000;opacity:.6;-webkit-filter:blur(50px);filter:blur(50px);z-index:0}.swiper-container-flip{overflow:visible}.swiper-container-flip .swiper-slide{pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-container-flip .swiper-slide .swiper-slide{pointer-events:none}.swiper-container-flip .swiper-slide-active,.swiper-container-flip .swiper-slide-active .swiper-slide-active{pointer-events:auto}.swiper-container-flip .swiper-slide-shadow-bottom,.swiper-container-flip .swiper-slide-shadow-left,.swiper-container-flip .swiper-slide-shadow-right,.swiper-container-flip .swiper-slide-shadow-top{z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-container-coverflow .swiper-wrapper{-ms-perspective:1200px}.formatted-markup blockquote,.formatted-markup h1,.formatted-markup h3,.formatted-markup h4,.formatted-markup h5,.formatted-markup h6,.formatted-markup img,.formatted-markup ol,.formatted-markup p,.formatted-markup ul{margin-bottom:2.5rem}.formatted-markup blockquote:last-child,.formatted-markup h1:last-child,.formatted-markup h3:last-child,.formatted-markup h4:last-child,.formatted-markup h5:last-child,.formatted-markup h6:last-child,.formatted-markup img:last-child,.formatted-markup ol:last-child,.formatted-markup p:last-child,.formatted-markup ul:last-child{margin-bottom:0}.formatted-markup h1{font-size:1.5em}.formatted-markup h2{font-size:1.3em}.formatted-markup h3{font-size:1.2em}.formatted-markup h4,.formatted-markup h5,.formatted-markup h6{font-family:mallory;line-height:1.75}.formatted-markup h4{font-size:1.5em}.formatted-markup h5{font-size:1.3em}.formatted-markup h6{font-size:1.2em}.formatted-markup em,.formatted-markup i{font-style:italic}.formatted-markup b,.formatted-markup strong{font-weight:700}.formatted-markup ol,.formatted-markup p,.formatted-markup ul{font-family:mallory;font-size:1.4rem;line-height:1.75}.formatted-markup blockquote{padding:2rem 0;margin-left:6rem;margin-right:3rem;text-align:right;font-size:3rem;position:relative;font-family:exchange}@media (min-width:640px){.formatted-markup blockquote{padding:4rem 0;margin-left:15rem;font-size:5rem}}.formatted-markup blockquote p{font-family:exchange;font-size:2rem;line-height:1.1em;font-style:italic}@media (min-width:640px){.formatted-markup blockquote p{font-size:3.5rem}}.film-detail-markup p{font-family:exchange;font-style:italic;font-size:1.2rem;line-height:1.8em;margin-bottom:1.2rem}.film-detail-markup p:last-child{margin-bottom:0}.mallory-book{font-family:mallory,arial;font-weight:400}.mallory-bold{font-family:mallory,arial;font-weight:700}a{text-decoration:none}.small-header{font-size:1rem;margin-bottom:1.25rem;width:100%}.medium-header,.small-header{font-family:mallory,arial;font-weight:700;text-transform:uppercase;letter-spacing:.125rem}.medium-header{font-size:1.6rem;line-height:1.35}.light-header{font-family:mallory,arial;font-weight:400;letter-spacing:.125rem;text-transform:uppercase;font-size:1.6rem}.external-link,.external-link-lg{color:#010101;border-bottom:1px solid #010101;display:inline-block;line-height:1;text-decoration:none!important}.external-link{font-size:1.2rem;text-transform:uppercase;font-weight:700;padding-bottom:.4rem;border-bottom:1px solid #000;letter-spacing:.1rem}footer .external-link{text-decoration:none;border:0!important}footer .terms{margin-left:3rem}.external-link-lg{font-size:1.4rem;font-weight:300}.bold-small-link{color:#010101;font-weight:700;font-size:1.2rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ex-pub-wrapper{margin-top:6rem;padding:0 3rem}.no-slider{margin-top:12rem!important}.ex-pub-primary{margin-bottom:3rem;margin:0 auto;width:100%}@media (min-width:640px){.ex-pub-primary{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.ex-pub-primary .ex-pub-info{margin-bottom:4rem}@media (min-width:640px){.ex-pub-primary .ex-pub-info{width:25%;margin-bottom:0}}.ex-pub-primary .exhibition-header{margin-bottom:3rem}.ex-pub-primary .publication-header{margin-bottom:.5rem}.ex-pub-primary .publication-subhead{font-weight:300!important}.ex-pub-primary .date{font-size:1rem;font-weight:700;letter-spacing:.05rem}.ex-pub-primary .text{margin-top:1.5rem;font-family:exchange;font-style:italic;line-height:1.75;font-size:1.3rem}.ex-pub-primary .text a{color:#010101!important;text-decoration:underline}.ex-pub-primary .text.gallery-url{margin-top:0!important}.ex-pub-primary .press-wrapper{margin-top:3rem}@media (min-width:640px){.ex-pub-primary .intro{width:65%}}@media (min-width:640px){.ex-pub-secondary{width:65%;margin-left:35%}}.ex-pub-slider{margin:6rem -3rem;position:relative}@media (max-width:640px){.ex-pub-slider{padding-bottom:0}}.ex-pub-slider .slick-list,.ex-pub-slider .slick-slider{width:100%;height:auto;z-index:100}.ex-pub-slider .slick-arrow{top:auto;display:none;top:0;height:100%;width:50%;-webkit-transform:translateY(0);transform:translateY(0);background-image:none!important;z-index:500}@media (min-width:960px){.ex-pub-slider .slick-arrow{display:block}}.ex-pub-slider .slick-arrow.slick-next{right:0;cursor:url(/static/icons/arrow-right-cursor.svg),auto}.ex-pub-slider .slick-arrow.slick-prev{left:0;cursor:url(/static/icons/arrow-left-cursor.svg),auto}.ex-pub-slider .expand-popover{position:absolute;bottom:-50px;left:50%;margin-left:-15px;z-index:1000;cursor:pointer;background-image:url(/static/icons/expand-arrow.svg);background-repeat:no-repeat;background-size:90%;background-position:50%;height:30px;width:30px;display:none;-webkit-transition:all .2s ease;transition:all .2s ease}.ex-pub-slider .expand-popover:hover{background-size:100%}@media (min-width:640px){.ex-pub-slider .expand-popover{display:block}}.ex-pub-slider .expand-slide{position:absolute;bottom:0;right:3rem;z-index:199;cursor:pointer}.ex-pub-slider .slider-counter{position:absolute;width:50px;right:0;bottom:0;font-size:1.2rem;font-weight:700}@media (min-width:960px){.ex-pub-slider .slider-counter{display:none}}.ex-pub-slider .ex-pub-slide{width:100%;position:relative;height:70vh}.ex-pub-slider .ex-pub-slide:after{content:\"\";display:block;padding-bottom:56%}.ex-pub-slider .ex-pub-slide .bg-image{position:absolute;top:0;left:0;right:0;bottom:30px;height:auto;background-size:contain;background-position:50%}.ex-pub-slider .ex-pub-slide .caption-wrapper{position:absolute;bottom:0;left:1rem;color:#fff;height:auto;width:auto;right:1rem;text-align:center}@media (max-width:640px){.ex-pub-slider .ex-pub-slide .caption-wrapper{text-align:left}}@media (max-width:640px){.ex-pub-slider .ex-pub-slide .caption-wrapper .primary{display:block}}@media (max-width:640px){.ex-pub-slider .ex-pub-slide .caption-wrapper .secondary{display:block;margin-left:-.5rem}}.ex-pub-slider .ex-pub-slide .caption-wrapper .sep{display:none}.info p{line-height:1.45}.empty{width:100vw;height:75vh;background:#000}.portfolio-wrapper{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:640px){.portfolio-wrapper.add-margin{margin-top:6rem}}.masonry-grid-wrapper,.portfolio-grid-wrapper,.publications-grid-wrapper{list-style:none;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}#filter-grid{padding:0 1.5rem;min-height:100vh;position:relative}@media (min-width:640px){#filter-grid{margin-top:0}}.photo-landing-image-wrapper{margin-bottom:2rem}.grid-wrapper{width:100%;-webkit-box-orient:horizontal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap}.external-link-list,.grid-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-direction:normal;list-style:none}.external-link-list{-webkit-box-orient:vertical;-ms-flex-direction:column;flex-direction:column;padding:4.5rem 0 5.5rem}.link-item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:3rem}@media (min-width:640px){.link-item{margin-bottom:2rem}}.link-item:last-child{margin-bottom:0}.img-grid-li{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;padding:0 1.5rem 3.3rem;width:100%}@media (min-width:640px){.img-grid-li{width:50%}}.img-grid-li.film .img-wrapper-film:after{content:\"\";display:block;border:20px solid transparent;border-left:40px solid #fff;position:absolute;top:50%;left:50%;margin-left:-10px;margin-top:-20px}@media (min-width:640px){.img-grid-li.film .img-wrapper-film:after{display:none}}.img-wrapper-film,.img-wrapper-fine-art{width:100%;height:0;overflow:hidden;background-size:cover;background-repeat:no-repeat;background-position:50%;position:relative}.img-wrapper-film{padding-bottom:56.3%}.img-wrapper-fine-art{padding-bottom:75%}.film-caption{margin-top:1.6rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.film-spacer{width:100%;display:block;padding:1rem}.film-thumb:hover .film-thumb__still{opacity:0}.film-thumb__still{position:absolute;top:0;left:0;z-index:100;width:100%;height:100%;background-repeat:no-repeat;background-position:50%;background-size:cover;opacity:1;-webkit-transition:opacity .35s ease;transition:opacity .35s ease;will-change:opacity}.film-thumb__player{overflow:hidden;position:absolute;top:0;left:0;z-index:50}.film-thumb__player video{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;-o-object-fit:cover;object-fit:cover}.masonry-grid-desktop{opacity:0;-webkit-transition:opacity 1s ease;transition:opacity 1s ease;will-change:opacity}.masonry-grid-desktop.loaded{opacity:1}.mg-li{padding:0 1.5rem 3.5rem;width:100%}@media only screen and (min-width:640px){.mg-li{width:50%}}@media only screen and (min-width:960px){.mg-li{width:33.33333%}}.mg-item{position:relative;overflow:hidden;opacity:0;-webkit-transition:opacity .75s ease;transition:opacity .75s ease;will-change:opacity}.mg-item__link{display:block;position:relative}.mg--image{width:100%;height:auto;margin-bottom:-3px}.mg__caption-wrapper{opacity:1;-webkit-transition:opacity .35s ease;transition:opacity .35s ease;will-change:opacity;z-index:100}.bg-gradient,.mg__caption-wrapper{position:absolute;bottom:0;left:0;width:100%}.bg-gradient{height:50%;background:-webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),color-stop(70%,hsla(0,0%,100%,0)),to(#4c4c4c));background:linear-gradient(180deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0) 70%,#4c4c4c);mix-blend-mode:multiply;z-index:0}.publications-grid-li{padding:1.5rem;display:block;width:100%}@media (min-width:640px){.publications-grid-li{width:50%}}@media (min-width:960px){.publications-grid-li{width:33.33333%}}.publications-grid-li .image-wrapper{padding:10% 15%;position:relative}.publications-grid-li .image-wrapper img{display:block;-webkit-box-shadow:9px 9px 15px 0 rgba(0,0,0,.27);box-shadow:9px 9px 15px 0 rgba(0,0,0,.27);-webkit-transition:transform .2s ease-out;transition:transform .2s ease-out;will-change:transform}.publications-grid-li .caption-wrapper{text-align:center!important;display:block!important;-webkit-transition:opacity .2s ease-out;transition:opacity .2s ease-out;will-change:opacity}@media (min-width:640px){.publications-grid-li .caption-wrapper{opacity:0}}.publications-grid-li:hover .image-wrapper img{-webkit-transform:scale(1.03);transform:scale(1.03)}.publications-grid-li:hover .caption-wrapper{opacity:1}#stocklist-content{width:100%;margin-top:3rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 1.5rem;text-align:center}@media (min-width:640px){#stocklist-content{text-align:left;margin-top:6rem}}.stocklist-headline{margin-bottom:5rem;font-size:2.8rem;font-weight:700}.stocklist-header{margin-bottom:.7rem;text-transform:uppercase;letter-spacing:.05rem;font-weight:700;font-size:12px}.stocklist-section{width:100%;margin-bottom:3rem}@media (min-width:640px){.stocklist-section{margin-bottom:6rem}}.stocklist-entries{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;list-style:none}.stocklist-entry{padding:0 1rem 1rem 0;margin-bottom:2.5rem;width:100%;font-size:1.45rem;line-height:1.5}@media (min-width:640px){.stocklist-entry{width:33.33333%}}.stocklist-entry-header{margin-bottom:.6rem}.stocklist-link{color:#000;display:inline-block;text-decoration:underline}#category-menu-wrapper{width:100%;padding:0 3rem;position:relative;z-index:1;background-color:#fff;height:6rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}#category-menu-wrapper-header{width:100%;padding-bottom:1.5rem;z-index:1;background-color:#fff}#category-menu-wrapper-header #category-menu-wrapper{padding:0!important;height:auto!important}.category-menu-desktop{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.category-menu-desktop,.category-nav-wrapper-desktop{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.category-nav-wrapper-desktop{list-style:none;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.category-button{font-size:1rem;text-transform:uppercase;font-family:mallory,arial;letter-spacing:.125rem;cursor:pointer;display:inline-block;position:relative;color:#010101;font-weight:regular}.category-button span:after{-webkit-transition:width .15s ease;transition:width .15s ease;content:\"\";border-bottom:1px solid #010101;position:absolute;left:0;bottom:-.35rem;width:0}.category-button:hover span:after{width:100%}.category-button.active{font-weight:600;letter-spacing:.075rem}.category-button.active span:after{width:100%;pointer-events:none}.categories{width:100%;max-width:117rem}.category-menu-item-desktop{-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-right:2rem}.category-menu-item-desktop,.mobile-category-link{display:-webkit-box;display:-ms-flexbox;display:flex}.mobile-category-link{color:#010101;font-family:mallory,arial;letter-spacing:.2rem;font-weight:700;text-transform:uppercase;font-size:1.4rem;margin-bottom:1.5rem}.mobile-category-link.drop-down{margin-bottom:0!important}menu.nav-drop .cat-nav-bg-gradient{opacity:1;height:48rem}.cat-nav-bg-gradient{height:0;width:100%;position:absolute;left:0;top:0;z-index:0;opacity:0;background:-webkit-gradient(linear,left top,left bottom,from(#fff),color-stop(60%,hsla(0,0%,100%,.8)),to(hsla(0,0%,100%,0)));background:linear-gradient(180deg,#fff 0,hsla(0,0%,100%,.8) 60%,hsla(0,0%,100%,0))}.category-menu-mobile{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;padding:2.5rem 3rem;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:absolute;top:0;left:0;height:6.5rem;background:#fff;z-index:9000}.category-menu-mobile .nav-divot{background-image:url(/static/icons/header-divot.svg)}.category-nav-wrapper-mobile{list-style:none;width:100%;height:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.cat-nav-dropdown,.category-nav-wrapper-mobile{display:-webkit-box;display:-ms-flexbox;display:flex}.cat-nav-dropdown{opacity:0;-webkit-transition:opacity .3s ease,-webkit-transform .3s ease;transition:opacity .3s ease,-webkit-transform .3s ease;transition:transform .3s ease,opacity .3s ease;transition:transform .3s ease,opacity .3s ease,-webkit-transform .3s ease;-webkit-transform:translateY(-1rem);transform:translateY(-1rem);pointer-events:none;will-change:transform,opacity}.category-menu-mobile.nav-drop>.cat-nav-dropdown{opacity:1;-webkit-transform:translateY(0);transform:translateY(0);height:auto;pointer-events:auto}#flexible-layout{width:100%;min-height:100vh}#flexible-layout #layout{list-style:none;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}#flexible-layout #layout .flexible-row{width:100%;min-height:35vh;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:640px){#flexible-layout #layout .flexible-row{margin-bottom:3rem}#flexible-layout #layout .flexible-row:last-child{margin-bottom:0}}@media (min-width:960px){#flexible-layout #layout .flexible-row{min-height:50vh}}#flexible-layout #layout .flexible-row.copy-row{min-height:0}@media (min-width:960px){#flexible-layout #layout .flexible-row.copy-row{min-height:0}}#flexible-layout #layout .flex-row-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative}@media (min-width:640px){#flexible-layout #layout .flex-row-wrapper{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}#flexible-layout #layout .centered,#flexible-layout #layout .full_row,#flexible-layout #layout .left,#flexible-layout #layout .right,#flexible-layout #layout .two_column{padding:0 1.5rem!important}#flexible-layout .flexible-image-wrapper{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-item-align:start;align-self:flex-start;margin-bottom:3.5rem!important;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;overflow:hidden}#flexible-layout .flexible-image-wrapper .caption-wrapper{margin-top:2rem}#flexible-layout .flexible-image-wrapper:hover .gradient-wrapper{opacity:1}@media (min-width:640px){#flexible-layout .flexible-image-wrapper{margin-bottom:0!important}#flexible-layout .flexible-image-wrapper .caption-wrapper{margin-top:0}}#flexible-layout .image-inner{top:0;left:0;height:auto;width:100%;height:100%;position:relative;overflow:hidden}#flexible-layout .image-inner .image-wrapper{z-index:5}#flexible-layout .gradient-wrapper{width:100%;height:100%;position:absolute;top:0;left:0;z-index:1;mix-blend-mode:multiply;opacity:0;-webkit-transition:opacity .5s ease-out;transition:opacity .5s ease-out;pointer-events:none}#flexible-layout .two_column{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}#flexible-layout .left{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}#flexible-layout .right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}#flexible-layout .centered,#flexible-layout .full_bleed,#flexible-layout .full_row{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}#flexible-layout .centered .flexible-image-wrapper,#flexible-layout .left .flexible-image-wrapper,#flexible-layout .right .flexible-image-wrapper,#flexible-layout .two_column .flexible-image-wrapper{padding:0 1.5rem;width:100%}@media (min-width:640px){#flexible-layout .centered .flexible-image-wrapper,#flexible-layout .left .flexible-image-wrapper,#flexible-layout .right .flexible-image-wrapper,#flexible-layout .two_column .flexible-image-wrapper{width:50%}}#flexible-layout .centered .caption-wrapper,#flexible-layout .left .caption-wrapper,#flexible-layout .right .caption-wrapper,#flexible-layout .two_column .caption-wrapper{width:calc(100% - 3rem);left:1.5rem}#flexible-layout .full_row .flexible-image-wrapper{padding:0 1.5rem}#flexible-layout .full_row .caption-wrapper{width:calc(100% - 3rem);left:1.5rem}#flexible-layout .full_bleed .flexible-image-wrapper,#flexible-layout .full_row .flexible-image-wrapper{width:100%}#flexible-layout .full_bleed{padding:0 3rem!important}@media (min-width:640px){#flexible-layout .full_bleed{padding:0!important}}.flex-layout-blog{width:100%;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin:3rem 0}@media (min-width:640px){.flex-layout-blog{margin:6rem 0}}.flex-layout-blog.hide-hero{margin-top:0}.flex-layout-blog .copy-row.flexible-row{margin-bottom:0!important}.flex-layout-blog .slick-slide{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (min-width:640px){.flex-layout-blog .ex-pub-slide .bg-image.contain.loaded{height:calc(100vh - 16rem);margin-top:8rem}}.flex-layout-blog .copy{width:100%;max-width:123rem;display:-webkit-box;display:-ms-flexbox;display:flex;padding:0 3rem 1.5rem}@media (min-width:640px){.flex-layout-blog .copy{padding:0 3rem 3rem}}.flex-layout-blog .copy p{font-family:mallory;font-size:1.4rem;line-height:1.75}.flex-layout-blog .copy p:last-child{padding-bottom:0}.flex-layout-blog .copy.size_a p{font-size:1.6rem}.flex-layout-blog .copy.size_b p{font-size:2rem}.flex-layout-blog .copy.size_c p{font-size:3rem}.flex-layout-blog .copy.font_a p{font-family:exchange}.flex-layout-blog .copy.font_b p{font-family:akzidenz-grotesk-bold,arial}.flex-layout-blog .copy blockquote{padding-top:3rem;padding-bottom:3rem;max-width:40rem;margin-left:auto;text-align:right;font-size:3rem;position:relative;font-family:exchange;margin-top:3rem;margin-bottom:4.5rem}@media (min-width:640px){.flex-layout-blog .copy blockquote{padding-top:3rem;padding-bottom:3rem;font-size:5rem;padding-right:0}}.flex-layout-blog .copy blockquote p{font-family:exchange;font-size:2rem;line-height:1.1em;font-style:italic}@media (min-width:640px){.flex-layout-blog .copy blockquote p{font-size:3.5rem}}.flex-layout-blog .audio-row,.flex-layout-blog .video-row{margin:3rem 0 4.5rem}@media (min-width:640px){.flex-layout-blog .audio-row,.flex-layout-blog .video-row{margin:6rem 0 7.5rem}}.flex-layout-blog.hide-hero .video-row{margin-top:0}.flex-layout-blog .copy-w-image-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.flex-layout-blog .copy-w-image-wrapper .image-container{padding-top:.5rem;width:100%;margin:3rem 0}@media (min-width:640px){.flex-layout-blog .copy-w-image-wrapper .image-container{width:50%;margin:0}}.flex-layout-blog .copy-w-image-wrapper .caption-wrapper{margin-top:1.5rem}.flex-layout-blog .copy-w-image-wrapper.right-align{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:640px){.flex-layout-blog .copy-w-image-wrapper.right-align{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}@media (min-width:640px){.flex-layout-blog .copy-w-image-wrapper.right-align .image-container{padding-left:6rem}}.flex-layout-blog .copy-w-image-wrapper.left-align{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:640px){.flex-layout-blog .copy-w-image-wrapper.left-align{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}}@media (min-width:640px){.flex-layout-blog .copy-w-image-wrapper.left-align .image-container{padding-right:6rem}}.flex-layout-blog .two_column_text_with_blockquote{padding-bottom:0;margin:3rem 0}@media (min-width:640px){.flex-layout-blog .two_column_text_with_blockquote{margin:6rem 0}}.flex-layout-blog .two-col-blockquote-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:640px){.flex-layout-blog .two-col-blockquote-wrapper{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.flex-layout-blog .two-col-blockquote-wrapper blockquote{max-width:100%;margin-top:0;margin-bottom:3rem}@media (min-width:640px){.flex-layout-blog .two-col-blockquote-wrapper blockquote{margin-bottom:0}}@media (min-width:640px){.flex-layout-blog .two-col-blockquote-wrapper .two-col-copy-wrapper{padding-left:6rem}}.flex-layout-blog .two-col-blockquote-wrapper .blockquote-wrapper,.flex-layout-blog .two-col-blockquote-wrapper .two-col-copy-wrapper{width:100%}@media (min-width:640px){.flex-layout-blog .two-col-blockquote-wrapper .blockquote-wrapper,.flex-layout-blog .two-col-blockquote-wrapper .two-col-copy-wrapper{width:50%}}.flex-layout-blog .full_column_copy .copy-wrapper{max-width:75rem}.flex-layout-blog .single_column_copy .copy-wrapper,.flex-layout-blog .single_column_copy_with_image .copy-wrapper{width:100%;margin-bottom:1.5rem}@media (min-width:640px){.flex-layout-blog .single_column_copy .copy-wrapper,.flex-layout-blog .single_column_copy_with_image .copy-wrapper{width:50%;padding-right:3rem;margin-bottom:0}}.flex-layout-blog .flexible-image-stack{position:relative;min-height:37rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.flex-layout-blog .flexible-image-stack .text-col{width:100%}.flex-layout-blog .flexible-image-stack .image-stack-wrap{width:100%;position:relative;margin-top:3rem;min-height:55vh}.flex-layout-blog .flexible-image-stack .image-stack-wrap .caption{width:100%;text-align:center}@media (min-width:640px){.flex-layout-blog .flexible-image-stack{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;min-height:60rem}.flex-layout-blog .flexible-image-stack .image-stack-wrap{width:50%;padding-right:3rem;margin-bottom:0}.flex-layout-blog .flexible-image-stack .text-col{width:50%;padding-right:6rem}}body.mobile-safari .slider-caption-link{padding-bottom:44px!important}.slider-caption-link{color:#fff;font-size:1.5rem;font-family:mallory,arial;font-weight:800;letter-spacing:.05rem;padding-top:1.2rem;display:inline-block;position:relative}.slider-caption-link span{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.slider-caption-link span:after{content:\"\";border-bottom:1px solid #fff;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0;flex:0;padding-top:.25rem;-webkit-transition:opacity .25s ease;transition:opacity .25s ease}.slider-caption-link:hover span:after{opacity:1}.slick-slider{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-slider,.slide{display:block;width:100vw}.slick-list{position:relative;display:block;overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:none}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translateZ(0);transform:translateZ(0)}.slick-track{position:relative;top:0;left:0;display:block;height:100%}.slick-track:after,.slick-track:before{display:table;content:\"\"}.slick-track:after{clear:both}.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;min-height:100%}[dir=rtl] .slick-slide{float:right}.slick-slide img{display:block}.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-initialized .slick-slide{display:block}.slick-loading .slick-slide{visibility:hidden}.slick-vertical .slick-slide{display:block;height:auto;border:1px solid transparent}.slick-arrow.slick-hidden{display:none}.slick-loading .slick-list{background-color:grey}.slick-next,.slick-prev{position:absolute;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:3rem;width:3rem;cursor:pointer;background-size:contain;background-repeat:no-repeat;background-position:50%;color:transparent;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);padding:0 0 .5rem;border:none;outline:none;z-index:12000;opacity:1;font-size:3rem;line-height:0;text-transform:uppercase;background-color:transparent}.slick-next:focus,.slick-next:hover,.slick-prev:focus,.slick-prev:hover{outline:none;opacity:1}.slick-prev{left:1.5rem}.slick-next{right:1.5rem}.slick-dots{position:absolute;bottom:3rem;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;width:100%;list-style:none;text-align:center;left:0}.slick-dots,.slick-dots li{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.slick-dots li{position:relative;width:2rem;height:2rem;margin:0 .5rem;cursor:pointer;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.slick-dots li button{width:100%;font-size:0;line-height:0;display:block;cursor:pointer;color:grey;border:0;outline:none;background:transparent;font-size:1.75rem;width:16px;height:16px;font-family:arial;opacity:.5;padding:0!important}.slick-dots li button:focus,.slick-dots li button:hover{outline:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before{opacity:1}.slick-dots li button:before{font-family:arial;font-size:4rem;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:\"\\2022\";text-align:center;opacity:.5;color:#000;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:none}.slick-dots li.slick-active button:before{opacity:1;color:#000}.slick-dots li.slick-active button{opacity:1}#hero .slick-dots{text-align:right;right:3rem;width:auto}#hero .slick-dots li{display:inline-block;width:auto;height:auto}#hero .slick-dots li button{height:8px;width:8px;border-radius:100%;background:transparent;border:1px solid #fff;opacity:1;text-indent:100%;white-space:nowrap;overflow:hidden}#hero .slick-dots li.slick-active button{background:#fff}#hero .slick-slide{pointer-events:none}#hero .slick-slide.slick-active{pointer-events:all}.copy-content{background-repeat:no-repeat;margin-top:10rem;width:100%;position:relative;z-index:100}@media (max-width:640px){.copy-content{padding-top:110vw}}@media (min-width:640px){.copy-content{padding-top:550px}}@media (min-width:960px){.copy-content{padding-top:0;width:56.5rem;width:calc(100% - 65rem)}}.gallery-wrap{position:absolute;width:calc(100% - 6rem);top:0}@media (min-width:960px){.gallery-wrap{width:47.5rem;position:relative;left:-5rem}.gallery-wrap.fixed .image-stack-wrap{position:fixed;bottom:0;top:auto}.gallery-wrap.parked .image-stack-wrap{position:absolute;bottom:0;top:auto}}.main-content{width:100%}@media (min-width:960px){.main-content{margin:0 auto;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}}.page-about .image-stack-wrap{position:relative}@media (min-width:960px){.page-about .image-stack-wrap{position:fixed;height:100vh;width:47.5rem}}.page-about .image-stack{top:120px}@media (min-width:960px){.page-about .image-stack{top:170px;left:calc(50% - 250px)}}.page-about .dropdown-wrapper{margin:0 auto;overflow:hidden;max-width:100%;background-color:#fff;width:100%;z-index:900;margin-top:5rem}@media (min-width:960px){.page-about .dropdown-wrapper{margin:0 auto}}@media (min-width:640px){.page-about .dropdown-wrapper{margin-top:10rem}}.dropdown-content{border-bottom:1px solid #000;margin-bottom:3rem}.dropdown-content p{margin-bottom:1rem}.dropdown-content .header{cursor:pointer;position:relative;font-weight:700;text-transform:uppercase;margin:1.2rem 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.dropdown-content .header:after{content:\"\";position:absolute;top:0;right:0;width:14px;height:14px;background-image:url(/static/icons/header-divot.svg);background-repeat:no-repeat;background-position:50%;background-size:contain;-webkit-transition:all .3s ease-out .1s;transition:all .3s ease-out .1s;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.dropdown-content .body{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;overflow:hidden;display:block;padding-bottom:5rem;padding-top:1.25rem;max-height:900vh}@media (min-width:640px){.dropdown-content .body{padding-right:20%}}.dropdown-content .body .formatted-markup{opacity:1;-webkit-transition:all .2s ease-out .2s;transition:all .2s ease-out .2s}.dropdown-content.closed .header:after{-webkit-transform:rotate(0deg);transform:rotate(0deg)}.dropdown-content.closed .body{-webkit-transition:all 0s;transition:all 0s;max-height:0}.dropdown-content.closed .body .formatted-markup{opacity:0;-webkit-transition:all .01s ease-out 0;transition:all .01s ease-out 0}.section-content{display:none}.contact-section{margin:10rem auto 0;padding:0;padding-bottom:100px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.contact-section h3{width:100%;font-weight:700;text-transform:uppercase;margin-bottom:6rem}.contact-email{display:block;color:#000;margin-bottom:.5em}.contact-item{font-size:.8em;margin-bottom:6rem}@media (min-width:640px){.contact-item{width:26%;margin-right:5%;display:inline-block;vertical-align:top}}.contact-item-title{margin-bottom:1rem;text-transform:uppercase;letter-spacing:.1em}.contact-item-title .primary{font-weight:500}.image-stack{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;height:40vh;position:absolute;top:0}@media (min-width:960px){.image-stack{width:500px;height:500px;right:0}}.image-stack .caption{position:absolute;bottom:-75px;right:0;z-index:100;background:#fff;font-size:.9em;padding:.3em}.image-stack .image-stack-image{position:absolute;top:0;bottom:0;left:0;right:0}.image-stack .image-stack-image .animate-wrapper{-webkit-transition:all .2s ease-in;transition:all .2s ease-in;-webkit-transform:scale(1.5) translateX(200px);transform:scale(1.5) translateX(200px);opacity:0}.image-stack .image-stack-image .animate-wrapper,.image-stack .image-stack-image .animate-wrapper img{top:0;bottom:0;left:0;right:0;position:absolute;-o-object-fit:contain;object-fit:contain}.image-stack .image-stack-image .animate-wrapper.animate{-webkit-transform:scale(1);transform:scale(1);opacity:1;-webkit-transform:rotate(5deg) translateX(0);transform:rotate(5deg) translateX(0)}.image-stack .image-stack-image .bg-image{position:absolute;top:0;bottom:0;left:0;right:0;background-position:50%;background-size:contain;background-repeat:no-repeat}.image-stack .image-stack-image:nth-of-type(4n+2) .animate-wrapper.animate{-webkit-transform:rotate(3deg);transform:rotate(3deg)}.image-stack .image-stack-image:nth-of-type(4n+3) .animate-wrapper.animate{-webkit-transform:rotate(-5deg);transform:rotate(-5deg)}.image-stack .image-stack-image:nth-of-type(4n+4) .animate-wrapper.animate{-webkit-transform:rotate(2deg);transform:rotate(2deg)}.blog_landing_item{width:100%;margin-bottom:3rem}@media (min-width:640px){.blog_landing_item{margin-bottom:6rem}}.blog_landing_link{text-decoration:none;color:#010101;width:100%;text-align:left}.blog_landing_caption,.blog_landing_caption_wrapper,.blog_landing_link{display:-webkit-box;display:-ms-flexbox;display:flex}@media (min-width:960px){.blog-header{font-size:8rem}}.blog_landing_caption,.image_right_caption_left .blog_landing_link{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:640px){.image_right_caption_left .blog_landing_link{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}}.image_left_caption_right .blog_landing_link{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}@media (min-width:640px){.image_left_caption_right .blog_landing_link{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}}@media (min-width:640px){.image_left_caption_right .blog_landing_caption_wrapper{padding-left:50px}}.full_width_bottom_caption .blog_image-wrapper{margin-bottom:1.5rem;width:100%}@media (min-width:640px){.full_width_bottom_caption .blog_image-wrapper{margin-bottom:3rem}}.full_width_bottom_caption .blog_landing_link{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.image_left_caption_right .blog_image-wrapper,.image_right_caption_left .blog_image-wrapper{width:100%;margin-bottom:1.5rem}@media (min-width:640px){.image_left_caption_right .blog_image-wrapper,.image_right_caption_left .blog_image-wrapper{width:60%;margin-bottom:0}}.image_left_caption_right .blog_landing_caption_wrapper,.image_right_caption_left .blog_landing_caption_wrapper{width:100%;margin-bottom:1.5rem}@media (min-width:640px){.image_left_caption_right .blog_landing_caption_wrapper,.image_right_caption_left .blog_landing_caption_wrapper{width:40%;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-bottom:0;padding-right:50px}}.blog_caption_title{margin-bottom:.5rem}.blog_caption_date{font-family:exchange;font-style:italic;font-size:1.2rem}.slideshow-row{position:relative;margin:3rem 0!important}@media (min-width:640px){.slideshow-row{margin:6rem 0 3rem!important}}#blog-slider{position:relative;width:100%}@media (min-width:640px){#blog-slider{height:calc(50vh + 6rem)}#blog-slider .blog-slide{height:calc(50vh - 3rem);padding:0 .75rem}#blog-slider .blog-slide img{height:100%;width:auto}}#blog-slider .ex-pub-slider{margin:0 0 6rem;padding-bottom:4rem}#blog-slider .ex-pub-slider .slick-list{overflow:visible}#blog-slider .ex-pub-slider .ex-pub-slide{margin-top:0;overflow-y:visible}#blog-slider .ex-pub-slider .caption-wrapper{bottom:-4.5rem;left:0;right:0;padding-left:3rem}#blog-slider .ex-pub-slider .caption-wrapper .row{padding-left:0}#blog-slider .caption-slider{height:4rem;position:absolute;left:6rem}#blog-slider .caption-slider .slick-list,#blog-slider .caption-slider .slide{height:4rem;padding:0!important}#blog-slider .caption-slider .slick-slide{min-height:auto;height:4rem;padding-top:1.5rem}#blog-slider .image-slider{height:50vh;position:relative}#blog-slider .image-slider .slick-list,#blog-slider .image-slider .slide{height:100%;padding:0!important}#blog-slider .image-slider .bg-image,#blog-slider .image-slider .slideshow-row{height:50vh}#blog-slider .slick-next,#blog-slider .slick-prev{top:auto;bottom:-5.5rem;padding-bottom:0}#blog-slider .slider-counter{position:absolute;right:6rem;bottom:2.6rem}#blog-slider .slick-dots{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;position:absolute;bottom:-3.65rem;width:2rem;overflow:hidden;width:100%;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;padding-right:5rem}#blog-slider .slick-dots li{border:0;pointer-events:none;display:none;padding:0;opacity:1}#blog-slider .slick-dots li button{margin:0;color:#010101;font-family:mallory;font-size:1rem;line-height:1.75;font-weight:700}#blog-slider .slick-dots li.slick-active{display:block}#article-hero{width:100vw;height:100vh;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}#article-hero,.article-title-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.article-title-wrapper{width:100%;z-index:1;text-align:center}.article-title-wrapper.aligned_left{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.article-title-wrapper.aligned_right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.article-title-wrapper.aligned_center,.article-title-wrapper.top_center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.article-title-wrapper.top_center{padding-top:10rem;-ms-flex-item-align:start;align-self:flex-start}.article-title-wrapper.top_right{padding-top:10rem;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-item-align:start;align-self:flex-start}.article-title-wrapper.top_left{padding-top:10rem;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-item-align:start;align-self:flex-start}.article-title-wrapper.bottom_right{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-item-align:end;align-self:flex-end;padding-bottom:3rem}.article-title-wrapper.bottom_left{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-item-align:end;align-self:flex-end;padding-bottom:3rem}.article-title-wrapper.size_a .blog-header{font-size:1.8rem}@media (min-width:640px){.article-title-wrapper.size_a .blog-header{font-size:2rem}}.article-title-wrapper.size_b .blog-header{font-size:3rem}@media (min-width:640px){.article-title-wrapper.size_b .blog-header{font-size:4.5rem}}.article-title-wrapper.size_c .blog-header{font-size:5rem}@media (min-width:640px){.article-title-wrapper.size_c .blog-header{font-size:8rem}}.article-title-wrapper.font_a .blog-header{font-family:mallory,arial}.article-title-wrapper.font_b .blog-header{font-family:akzidenz-grotesk-bold,arial}.article-title{width:100%;z-index:1;color:#fff}@media (min-width:960px){.article-title{width:60%}}.text_left{text-align:left}.text_right{text-align:right}.text_center{text-align:center}.bottom_center{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-ms-flex-item-align:end;align-self:flex-end;padding-bottom:3rem}.blog-header{text-transform:uppercase;font-weight:400;font-family:exchange;font-size:4rem;-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0;max-width:60rem;margin:auto;line-height:1.125}@media (min-width:640px){.blog-header{font-size:6rem}}.hero-caption{margin:1.5rem 0 0}.hero-image{top:0;left:0;z-index:0}.hero-image,.slide-gradient{width:100%;height:100%;position:absolute}.slide-gradient{content:\"\";background:-webkit-gradient(linear,left top,left bottom,from(#4c4c4c),color-stop(15%,hsla(0,0%,100%,0)),color-stop(70%,hsla(0,0%,100%,0)),to(#4c4c4c));background:linear-gradient(180deg,#4c4c4c 0,hsla(0,0%,100%,0) 15%,hsla(0,0%,100%,0) 70%,#4c4c4c);mix-blend-mode:multiply;bottom:0;z-index:10}.text-shadow{text-shadow:0 0 20px rgba(0,0,0,.15)}@media (min-width:1440px){.article-title{width:50%}}#logo{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:absolute;left:3rem;z-index:12000;font-family:mallory,arial;font-weight:700;text-transform:uppercase;font-size:1.8rem;letter-spacing:.15rem}#logo,#logo a{color:#010101}@media (min-width:640px){#logo{left:0;position:relative}}header{top:0;left:0;width:100vw;min-height:6rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0;will-change:transform;-webkit-transition:-webkit-transform .25s ease-out;transition:-webkit-transform .25s ease-out;transition:transform .25s ease-out;transition:transform .25s ease-out,-webkit-transform .25s ease-out;position:fixed}header,header.scrolling-up,header.top{-webkit-transform:translateY(0);transform:translateY(0)}header.scrolling-down,header.video-playing{-webkit-transform:translateY(-100%);transform:translateY(-100%)}header.wht-no-bg .nav-divot{background-image:url(/static/icons/header-divot-white.svg)}header.wht-no-bg .header-bg{background-color:hsla(0,0%,100%,0)}header.wht-no-bg #logo,header.wht-no-bg #logo a,header.wht-no-bg .top-nav-link{color:#fff}header.wht-no-bg .nav-header{border-color:#fff}header.wht-no-bg .hamburger span,header.wht-no-bg .hamburger span:after,header.wht-no-bg .hamburger span:before{background-color:#fff!important}header.wht-no-bg.nav-drop .hamburger span:after,header.wht-no-bg.nav-drop .hamburger span:before{background-color:#010101!important}header.blk-with-bg,header.stick-it{background-color:#fff}header.blk-with-bg #logo,header.blk-with-bg #logo a,header.blk-with-bg .top-nav-link,header.stick-it #logo,header.stick-it #logo a,header.stick-it .top-nav-link{color:#010101!important}header.blk-with-bg .nav-header,header.stick-it .nav-header{border-bottom:1px solid #010101}header.blk-with-bg .nav-divot,header.stick-it .nav-divot{background-image:url(/static/icons/header-divot.svg)}header.blk-with-bg .header-bg,header.stick-it .header-bg{background-color:#fff}header.blk-with-bg .hamburger span,header.blk-with-bg .hamburger span:after,header.blk-with-bg .hamburger span:before,header.stick-it .hamburger span,header.stick-it .hamburger span:after,header.stick-it .hamburger span:before{background-color:#000!important}header.blk-with-bg.nav-drop .hamburger span:after,header.blk-with-bg.nav-drop .hamburger span:before,header.stick-it.nav-drop .hamburger span:after,header.stick-it.nav-drop .hamburger span:before{background-color:#010101!important}header.blk-with-bg.nav-drop .hamburger span,header.stick-it.nav-drop .hamburger span{background-color:#fff!important}header.nav-drop .nav-divot,menu.nav-drop .nav-divot{background-image:url(/static/icons/header-divot.svg)!important;-webkit-transform:rotate(180deg)!important;transform:rotate(180deg)!important}header.nav-drop #logo,header.nav-drop #logo a,header.nav-drop .top-nav-link,menu.nav-drop #logo,menu.nav-drop #logo a,menu.nav-drop .top-nav-link{color:#010101!important}header.nav-drop #logo,menu.nav-drop #logo{display:none}@media (min-width:640px){header.nav-drop #logo,menu.nav-drop #logo{display:-webkit-box;display:-ms-flexbox;display:flex}}header.nav-drop .nav-header,menu.nav-drop .nav-header{border-color:#010101!important;padding-bottom:.35rem}header.nav-drop .nav-dropdown,menu.nav-drop .nav-dropdown{opacity:1;-webkit-transform:translateY(0);transform:translateY(0);height:auto;overflow:visible}header.nav-drop .header-bg,menu.nav-drop .header-bg{background-color:hsla(0,0%,100%,0)}header.nav-drop .header-bg-gradient,menu.nav-drop .header-bg-gradient{opacity:1}.inner-header{width:100%;height:6rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;position:relative;z-index:100}.nav-header{border-bottom:1px solid #010101;padding-bottom:.3rem!important;cursor:pointer;position:relative}.header-bg-gradient{height:41rem;-webkit-transition:opacity .5s ease;transition:opacity .5s ease;will-change:opacity;width:100%;position:absolute;left:0;top:0;opacity:0;pointer-events:none}.header-bg-gradient:after,.header-bg-gradient:before{content:\"\";position:absolute;left:0;width:100%}.header-bg-gradient:before{background-color:#fff;height:6rem;top:0}.header-bg-gradient:after{height:35rem;bottom:0;background:-webkit-gradient(linear,left top,left bottom,from(#fff),color-stop(60%,hsla(0,0%,100%,.8)),to(hsla(0,0%,100%,0)));background:linear-gradient(180deg,#fff 0,hsla(0,0%,100%,.8) 60%,hsla(0,0%,100%,0))}.menu-link{font-family:mallory,arial;font-weight:500;text-decoration:none;font-size:1.2rem}.nav-dropdown{-webkit-transition:all .5s ease 50ms;transition:all .5s ease 50ms;opacity:0;-webkit-transform:translateY(-1rem);transform:translateY(-1rem);height:0;overflow:hidden}.header-bg-fade .header-bg{opacity:0}.nav-divot{width:1.25rem;height:1.125rem;position:absolute;right:0;top:.05rem;background-repeat:no-repeat;background-position:50%;background-size:contain;-webkit-transition:all .3s ease-out .1s;transition:all .3s ease-out .1s}.header-bg{height:6rem;width:100%;position:absolute;top:0;left:0}.menu-item{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.top-nav-link{color:#010101;font-family:mallory,arial;letter-spacing:.2rem;font-weight:700;text-transform:uppercase}.desk-menu{list-style:none;width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding-top:1.5rem;z-index:1}.desktop-nav{width:100%;max-width:15.4rem;position:absolute;right:0;top:2.1rem;line-height:1.4}.desktop-nav .menu-item{margin-bottom:1.5rem}.desktop-nav .top-nav-link{font-size:1.2rem}.mobile-menu,.mobile-menu-wrapper{-webkit-transition:opacity .25s ease!important;transition:opacity .25s ease!important}.mobile-menu{margin:3rem 0!important;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;padding:0 15%!important;opacity:0}.mobile-menu-wrapper{background:#fff;position:fixed;width:100%;height:100vh;pointer-events:none;opacity:0;right:0;top:0;padding-top:5rem!important;padding-bottom:3rem!important;overflow:scroll}.mobile-nav{width:100vw;position:absolute;right:0;top:0}.mobile-nav .menu-item{text-align:center;padding:2.4rem 0;border-bottom:2px solid #010101;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.mobile-nav .menu-item:last-child{border:0}.mobile-nav .top-nav-link{font-size:1.8rem}.mobile-nav.active .mobile-menu-wrapper{opacity:1;pointer-events:auto}.mobile-nav.active .mobile-menu{opacity:1}.c-border,.c-instagram,.c-portrait{width:100vw;height:126vw}@media (min-width:640px){.c-border,.c-instagram,.c-portrait{height:0;width:33.33333%;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%}}.c-landscape{width:100vw;height:59vw}@media (min-width:640px){.c-landscape{height:0;width:66.66667%;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%}}.video-thumb-mobile .c-landscape{height:56.25vw!important}.c-border .grid-link{padding:6.75rem}.hp-image-gradient-wrapper{opacity:0;-webkit-transition:opacity .5s ease-out;transition:opacity .5s ease-out;mix-blend-mode:multiply;height:100%;top:0;z-index:100}.hp-image-gradient,.hp-image-gradient-wrapper{width:100%;position:absolute;left:0;pointer-events:none}.hp-image-gradient{bottom:0;z-index:10;background:-webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),color-stop(70%,hsla(0,0%,100%,0)),to(#4c4c4c));background:linear-gradient(180deg,hsla(0,0%,100%,0) 0,hsla(0,0%,100%,0) 70%,#4c4c4c);height:75%;min-height:15rem}.home-grid-item-wrapper{display:block;position:relative;margin-bottom:0;overflow:hidden;padding-bottom:38.7%}.home-grid-item-wrapper:hover .hp-image-caption-wrap,.home-grid-item-wrapper:hover .hp-image-gradient-wrapper{opacity:1}.grid-link{position:relative;width:100%;height:100%;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}@media (min-width:640px){.grid-link{position:absolute;display:block;top:0;left:0;z-index:90}}.block-out{width:100%;height:100%;z-index:1000;position:absolute}@media (min-width:640px){.block-out{background-color:rgba(0,0,0,.75);-webkit-animation-name:c;animation-name:c;-webkit-animation-duration:.75s;animation-duration:.75s;-webkit-animation-direction:normal;animation-direction:normal;-webkit-animation-fill-mode:both;animation-fill-mode:both}}#image-grid-desktop{-ms-flex-wrap:wrap;flex-wrap:wrap;position:relative;z-index:20}#image-grid-desktop,.grid-item-desktop{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.grid-item-desktop{-webkit-transition:opacity 1.5s ease .1s;transition:opacity 1.5s ease .1s;will-change:opacity;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden;background-size:cover;background-position:50%;background-repeat:no-repeat;height:100%;position:absolute;top:0;left:0}.hp-image-link{position:absolute;bottom:0;top:0;left:0;right:0;padding:2rem;z-index:8}.hp-image__loader{position:absolute;top:0;left:0;height:0;width:0;display:none;overflow:hidden}.hp-image__border-inner{width:100%;height:100%;background-position:50%;background-repeat:no-repeat;background-size:contain}.hp-image-caption-wrap{position:absolute;bottom:0;left:0;right:0;padding:2rem;z-index:150;opacity:0;-webkit-transition:opacity .25s ease-out;transition:opacity .25s ease-out;color:#fff;overflow-y:visible}.hp-image-caption-wrap.video-playing{opacity:0!important;pointer-events:none}.hp-image-caption-wrap.video-paused{opacity:1!important;pointer-events:none}.hp-image-caption-wrap a{font-weight:700;pointer-events:all;color:#fff}.external-link{cursor:pointer}.hp-caption-text-wrap{position:relative;z-index:200}.black-caption .hp-image-caption-wrap .hp-image-cpation-wrap a{color:#000}.long-caption-toggle{pointer-events:all}.black-caption .hp-image-caption-wrap{color:#000}.hp-image-caption-primary,.hp-image-caption-secondary{font-family:mallory,arial;font-size:1rem;text-transform:uppercase;line-height:1.25;letter-spacing:.05rem}.hp-image-caption-primary{margin-bottom:.175rem;font-weight:700}.hp-image-caption-secondary{font-weight:300;line-height:1.3em}.hp-image-caption-secondary-span>p{display:inline}.long-caption-toggle{font-weight:700;cursor:pointer;margin-left:13px}#image-grid-mobile{list-style:none;z-index:20}#image-grid-mobile,#image-grid-mobile .hp-image-wrapper{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative}#image-grid-mobile .hp-image-wrapper{height:100%;-webkit-transition:opacity 1s ease;transition:opacity 1s ease;will-change:opacity}#image-grid-mobile .hp-caption-wrapper{padding:2.5rem 3rem .5rem}.home-grid-item-wrapper-mobile{width:100%;position:relative;margin-bottom:3rem}.hp-mobile-grid-item{background-size:cover;background-position:50%;background-repeat:no-repeat}@-webkit-keyframes b{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:0}50%{-webkit-transform:translateY(.75rem);transform:translateY(.75rem);opacity:.75}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:0}}@keyframes b{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:0}50%{-webkit-transform:translateY(.75rem);transform:translateY(.75rem);opacity:.75}to{-webkit-transform:translateY(0);transform:translateY(0);opacity:0}}.scroll-prompt{width:45px;height:9rem;display:block;position:absolute;margin:auto;left:0;right:0;bottom:0;opacity:0;-webkit-transition:opacity 1.5s ease;transition:opacity 1.5s ease;will-change:opacity;z-index:9000}.scroll-prompt.top{opacity:0;-webkit-animation-name:b;animation-name:b;-webkit-animation-duration:4s;animation-duration:4s;-webkit-animation-direction:normal;animation-direction:normal;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;-webkit-animation-delay:3s;animation-delay:3s}@media (min-width:640px){header{padding-left:3rem!important;padding-right:3rem!important}}@media (min-width:1510px){header{padding-left:7%!important;padding-right:7%!important}}@media (min-width:640px){#filter-grid{padding-left:calc($double_pad - 1.5rem);padding-right:calc($double_pad - 1.5rem)}}@media (min-width:1510px){#filter-grid{padding-left:calc(7% - 1.5rem);padding-right:calc(7% - 1.5rem)}}@media (min-width:640px){#category-menu-wrapper,#footer-layout,#hero .caption-wrapper{padding-left:3rem;padding-right:3rem}}@media (min-width:1510px){#category-menu-wrapper,#footer-layout,#hero .caption-wrapper{padding-left:7%;padding-right:7%}}#blog-landing,#footer-layout,.article-title-wrapper,.page-about .about-sub-wrap,.page-about .main-content,.page-about section{padding-left:3rem;padding-right:3rem}@media (min-width:1510px){#blog-landing,#footer-layout,.article-title-wrapper,.page-about .about-sub-wrap,.page-about .main-content,.page-about section{padding-left:7%;padding-right:7%}}.hero-swiper-pagination{right:3rem!important}@media (min-width:1510px){.hero-swiper-pagination{right:7%!important}}@media (min-width:1510px){main.photo-film-project #flexible-layout,main.publication-detail #flexible-layout{padding-left:calc(7% - 3rem);padding-right:calc(7% - 3rem)}main.photo-film-project #film-detail-header,main.photo-film-project #portfolio-header,main.photo-film-project #social-share,main.photo-film-project .ex-pub-primary,main.publication-detail #film-detail-header,main.publication-detail #portfolio-header,main.publication-detail #social-share,main.publication-detail .ex-pub-primary{padding-left:7%;padding-right:7%}}#film-project-top{width:100vw;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}#film-project-top,#video-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;position:relative;-webkit-box-align:center;-ms-flex-align:center;align-items:center}#video-wrapper{width:100%;background-size:cover;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}#play{font-family:mallory,arial;font-size:1rem;font-weight:700;color:#fff;letter-spacing:.1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.play-icon{width:2.6rem;height:3rem;display:block;background-size:contain;background-position:50%;background-repeat:no-repeat;margin-bottom:1.5rem}#film-detail-header{width:100%;position:relative;padding:3rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.hl-primary,.hl-secondary{display:inline-block;vertical-align:baseline;margin-right:10px}.expand{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}#film-project-top .dropdown-content,.expand{display:-webkit-box;display:-ms-flexbox;display:flex}#film-project-top .dropdown-content{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:auto;width:100%;max-width:117rem;padding:0 3rem}@media (max-width:1230px){#film-project-top .dropdown-content{max-width:100%;padding:0 3rem}#film-project-top #film-detail-header{max-width:100%;padding:3rem}}#film-project-top .dropdown-content.closed{height:0;overflow:hidden}.read-more{border:0;background:hsla(0,0%,100%,0);margin-right:1rem;cursor:pointer;margin-bottom:0!important;width:120px;text-align:right}.read-more:after{content:\"Read Less\";border-bottom:1px solid #010101}.read-more.closed:after{content:\"Read More\";border-bottom:1px solid #010101}.no-match{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}@media (min-width:640px){.no-match{padding-top:6rem}}.no-match section{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.no-match h1,.no-match h2{margin-bottom:1rem}.no-match a{text-decoration:underline;color:#010101;text-transform:uppercase;font-size:1.4rem}html{font-size:58%;-webkit-font-smoothing:antialiased}@media screen and (min-width:960px){html{font-size:62.5%}}body{font-size:16px;overflow-x:hidden;width:100vw;min-height:100vh;margin:0;font-family:mallory,arial;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}body *{-webkit-box-sizing:border-box;box-sizing:border-box;outline:0}article,section{width:100%}.switch-wrapper{position:relative}.switch-wrapper>div{position:absolute;width:100%}.back-arrow{width:2.75rem;height:1rem;background-size:contain;display:block;margin:0 auto 1rem}#video-player iframe{width:100%;height:100%}.page-wrap{min-height:calc(100vh - 6rem);width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;position:relative;margin:0 auto}@-webkit-keyframes c{0%{opacity:0}to{opacity:1}}@keyframes c{0%{opacity:0}to{opacity:1}}.pop-in{-webkit-animation-name:c;animation-name:c;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-duration:1s;animation-duration:1s;-webkit-animation-delay:.2s;animation-delay:.2s;will-change:opacity}#slideshow-modal{overflow:hidden}#slideshow-modal ::-webkit-scrollbar{width:2px;height:2px}#slideshow-modal ::-webkit-scrollbar-track{-webkit-box-shadow:inset 0 0 1px grey;box-shadow:inset 0 0 1px grey;border-radius:0;background-color:#000}#slideshow-modal ::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.5);border-radius:0}.hero-swiper-pagination{display:none}@media (min-width:640px){.hero-swiper-pagination{display:-webkit-box;display:-ms-flexbox;display:flex}}", ""]);

// exports


/***/ }),
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(408);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(237)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/sass-loader/lib/loader.js!./_social-share.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/lib/index.js??ref--2-2!../../node_modules/sass-loader/lib/loader.js!./_social-share.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ })
],[278]);


// WEBPACK FOOTER //
// static/js/app.d7094440ec75b96b3752.js